import React, { useState, useRef, useCallback, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  FileText,
  Image,
  Shapes,
  Type,
  Upload,
  Eye,
  StickyNote,
  X,
  Clipboard,
  Lock,
  Copy,
  Plus,
  Trash2,
  RotateCw,
  MoreHorizontal,
  Unlock,
  ChevronUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  List,
  FlipHorizontal,
  FlipVertical,
  Italic,
  Bold,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  Filter,
  AlignJustify,
  RotateCcw,
  Scissors,
  Split,
  Package,
  Edit3,
  ArrowUpRight,
  Settings,
  Check,
  Wrench,
  Volume2,
  Tag,
  Sparkles,
  Sliders,
  Zap,
  PenTool,
  History,
  Layers,
  Maximize2
} from 'lucide-react'
import TemplatesSidebar from './components/TemplatesSidebar'
import PhotosSidebar from './components/PhotosSidebar'
import ElementsSidebar from './components/ElementsSidebar'
import TextSidebar from './components/TextSidebar'
import ImportProgressDialog from './components/ImportProgressDialog'
import GraphicsSidebar from './components/GraphicsSidebar'
import ClipartSidebar from './components/ClipartSidebar'
import AudioSidebar from './components/AudioSidebar'
import SoundEffectsSidebar from './components/SoundEffectsSidebar'
import VideoSidebar from './components/VideoSidebar'
import TTSSidebar from './components/TTSSidebar'
import ItemsListSidebar from './components/ItemsListSidebar'
import CategoryFieldsSidebar from './components/CategoryFieldsSidebar'
import FilterPanel from './components/FilterPanel'
import EditorNavigation from './components/EditorNavigation'
import InlineTextEditor from './components/InlineTextEditor'
import AutoFitText from './components/AutoFitText'
import HistorySidebar from './components/HistorySidebar'

import Canvas from '../components/Canvas/Canvas'
import Timeline from './components/Timeline.jsx'




import EffectsPanel from './components/EffectsPanel.jsx'
import VideoOverlaysPanel from './components/VideoOverlaysPanel.jsx'
import AdjustmentLayerPanel from './components/AdjustmentLayerPanel.jsx'
import AnimatePanelSecondaryBar from './components/AnimatePanelSecondaryBar.jsx'
import MotionPanelSecondaryBar from './components/MotionPanelSecondaryBar.jsx'
import MotionPropertiesPanel from './components/MotionPropertiesPanel.js'
import TextEffectsSecondaryBar from './components/TextEffectsSecondaryBar.jsx'
import TextEffectsPropertiesPanel from './components/TextEffectsPropertiesPanel.js'
import ShapeEffectsPanel from './components/ShapeEffectsPanel.jsx'
import ImageEffectsPanel from './components/ImageEffectsPanel.jsx'
import TextAnimationWrapper from './components/TextAnimationWrapper.jsx'
import VideoExportProgress from './components/VideoExportProgress.jsx'
import BackgroundRemovalSnackbar from './components/BackgroundRemovalSnackbar.jsx'
import AIImageGenerationSnackbar from './components/AIImageGenerationSnackbar.jsx'
import audioMixer from './utils/audioMixer'
import ExportProgress from './components/ExportProgress.jsx'

import videoExportService from './services/videoExportService.js'
import exportService from './services/exportService.js'

import DrawingCanvas from '../components/Canvas/DrawingCanvas'

import ImageElementProperties from './components/ImageElementProperties'
import VideoElementProperties from './components/VideoElementProperties'
import VideoPreview from './components/VideoPreview'
import TextElementProperties from './components/TextElementProperties'
import ShapeElementProperties from './components/ShapeElementProperties'
import GraphicsElementProperties from './components/GraphicsElementProperties'
import SvgElementProperties from './components/SvgElementProperties'
import FreehandElementProperties from './components/FreehandElementProperties'
import TTSElementProperties from './components/TTSElementProperties'
import AudioElementProperties from './components/AudioElementProperties'
import PowerClipAdvancedControls from './components/PowerClipAdvancedControls'
import CommonElementProperties from './components/CommonElementProperties'
import FontsSecondarySidebar from './components/FontsSecondarySidebar'
import MaskElementProperties from './components/MaskElementProperties'
import TifColorModeDialog from './components/TifColorModeDialog'
import ColorModeDialog from './components/ColorModeDialog'
import VideoExportDialog from './components/VideoExportDialog'
import DurationScaleDialog from './components/DurationScaleDialog'
import { normalizeSvgColors, injectOverrideStyleScoped, ensureViewBox, prepareSvgContent, getSvgIntrinsicSize, isLikelySvg } from './utils/svgUtils'
import { stackEffects } from '../utils/videoEffects'
import { replacePlaceholders } from './utils/placeholderUtils'
import AddPageDialog from './components/AddPageDialog'
import ContentDialog from './components/ContentDialog'
import CommentDialog from './components/CommentDialog'
import PagePropertiesDialog from './components/PagePropertiesDialog'
import PagesViewDialog from './components/PagesViewDialog'
// import ToolsSidebar from './components/ToolsSidebar' // Disabled - will be implemented later
import Rulers from './components/Rulers'
import PhotoUploadDialog from './components/PhotoUploadDialog'
import CategoryDialog from './components/CategoryDialog'
import ErrorDialog from './components/ErrorDialog'
import { CanvasProvider } from '../contexts/CanvasContext'
import { ALL_SHAPES } from '../data/shapesData'
import { templateAPI, projectAPI, importAPI } from '../services/api'
import { createHandleMouseMove } from './functions/mouseHandlers'
import FreehandComponent from './tools/freehand/FreehandComponent'
import StrokePropertiesPanel from './tools/freehand/StrokePropertiesPanel'
import { createLoadTemplate } from './functions/templateLoader'
import { createGroup, ungroupItem, cloneItemWithNewIds, applyPropertyToGroupChildren } from './functions/groupOperations'
import { createHandleSave } from './functions/saveHandler'
import ContextMenu from './components/ContextMenu'
import { useContextMenu } from './hooks/useContextMenu'
import { useAuth } from '../contexts/AuthContext'
import SampleGenerationDialog from './components/SampleGenerationDialog'
import PastSamplesDialog from './components/PastSamplesDialog'
import AiQueueDialog from './components/AiQueueDialog'
import pkg from '../../package.json';
import { computeAnimationTransform, computeTextAnimation, isTextAnimation } from './utils/animationEngine'
import { computeMotion, isMotionType } from './utils/motionEngine'
import { computeTextEffects, textEffectsToDomStyles } from './utils/textEffectsEngine'
import { buildShapeGeometry, pointsToSvgPath, shapeNeedsEngine } from './utils/shapeEngine'
import { computeTransition, transitionClipPath } from './utils/transitionEngine'
import './styles/textEffects.css';
const version = pkg.version;

const DEFAULT_TIMELINE_HEIGHT = 280
const MIN_TIMELINE_HEIGHT = 160
const MAX_TIMELINE_HEIGHT = 560
const TIMELINE_HEIGHT_STORAGE_KEY = 'editor.timelineHeight'

// Properties that, when set on a GROUP container, should be applied to every
// child in the group (so one animation/effect covers all grouped items). These
// are per-element visual/motion properties that have no meaning on the group
// container itself. Positional/structural props (x, y, width, height, time,
// layer, rotation, opacity, children) are intentionally excluded so they stay
// on the container.
const GROUP_FANOUT_PROPERTIES = [
  'animations',
  'motion',
  'transition',
  'textEffects',
  'effects',
  'animation',
]

const DEFAULT_GLOW_PULSE_SETTINGS = {
  color: '#ffffff',
  blur: 12,
  spread: 18,
  intensity: 0.85,
  duration: 2.6,
}

const normalizeGlowPulseSettings = (settings = {}) => ({
  color: settings.color || DEFAULT_GLOW_PULSE_SETTINGS.color,
  blur: typeof settings.blur === 'number' ? settings.blur : DEFAULT_GLOW_PULSE_SETTINGS.blur,
  spread: typeof settings.spread === 'number' ? settings.spread : DEFAULT_GLOW_PULSE_SETTINGS.spread,
  intensity: typeof settings.intensity === 'number' ? settings.intensity : DEFAULT_GLOW_PULSE_SETTINGS.intensity,
  duration: typeof settings.duration === 'number' ? settings.duration : DEFAULT_GLOW_PULSE_SETTINGS.duration,
})

const hexToRgba = (hex, alpha = 1) => {
  if (!hex) return `rgba(255,255,255,${alpha})`
  const sanitized = hex.replace('#', '')
  if (sanitized.length !== 6) {
    return `rgba(255,255,255,${alpha})`
  }
  const r = parseInt(sanitized.slice(0, 2), 16)
  const g = parseInt(sanitized.slice(2, 4), 16)
  const b = parseInt(sanitized.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${Math.min(1, Math.max(0, alpha))})`
}

const normalizeTimelineHeight = (value) => {
  const numericValue = typeof value === 'number' ? value : parseFloat(value)
  if (!Number.isFinite(numericValue)) {
    return null
  }
  return Math.min(MAX_TIMELINE_HEIGHT, Math.max(MIN_TIMELINE_HEIGHT, numericValue))
}

/**
 * Get translated content for a text item, replacing placeholders with values
 * @param {Object} item - The text item element
 * @param {boolean} useRichTextContent - If true, use richText.content instead of content
 * @returns {string} Translated content with placeholders replaced
 */
const getTranslatedContent = (item, useRichTextContent = false) => {
  if (!item || (item.type !== 'text' && item.type !== 'wordart')) {
    return item?.content || ''
  }
  
  // For rich text, use richText.content if available, otherwise use content
  const rawContent = useRichTextContent && item.richText?.content 
    ? item.richText.content 
    : (item.content || '')
  
  const placeholders = item.placeholders || []
  
  // If no placeholders array or it's empty, return raw content
  if (!Array.isArray(placeholders) || placeholders.length === 0) {
    return rawContent
  }
  
  // Replace placeholders with values
  return replacePlaceholders(rawContent, placeholders)
}

const WorkspacePage = () => {
  const { projectId } = useParams()
  const navigate = useNavigate()
  const { user } = useAuth()
  const [selectedElement, setSelectedElement] = useState(null)
  const [showContentDialog, setShowContentDialog] = useState(false)
  const [currentPageIndex, setCurrentPageIndex] = useState(0)
  const [isDragging, setIsDragging] = useState(false)
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 })
  const [isResizing, setIsResizing] = useState(false)
  const [resizeHandle, setResizeHandle] = useState(null)
  const [isRotating, setIsRotating] = useState(false)
  const [rotationStart, setRotationStart] = useState({ x: 0, y: 0, angle: 0 })
  const [showCommentDialog, setShowCommentDialog] = useState(false)
  const [showReplaceDialog, setShowReplaceDialog] = useState(false)
  const [showPagePropertiesDialog, setShowPagePropertiesDialog] = useState(false)
  const [showGrid, setShowGrid] = useState(false)
  const [showMouseCoords, setShowMouseCoords] = useState(false)
  const [showPropertiesBarAtBottom, setShowPropertiesBarAtBottom] = useState(false)
  const [showVideoExportProgress, setShowVideoExportProgress] = useState(() => {
    if (typeof window === 'undefined') return true
    const stored = window.localStorage.getItem('editor.showVideoExportProgress')
    return stored ? stored === 'true' : true
  })
  const [showRulers, setShowRulers] = useState(() => {
    if (typeof window === 'undefined') return true
    const stored = window.localStorage.getItem('editor.showRulers')
    return stored ? stored === 'true' : true
  })
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [showFooterBar, setShowFooterBar] = useState(() => {
    if (typeof window === 'undefined') return true
    const stored = window.localStorage.getItem('editor.showFooterBar')
    return stored ? stored === 'true' : true
  })
  const [showAnimateSecondaryBar, setShowAnimateSecondaryBar] = useState(false)
  const [showMotionSecondaryBar, setShowMotionSecondaryBar] = useState(false)
  const [showTextEffectsSecondaryBar, setShowTextEffectsSecondaryBar] = useState(false)
  const [isTimelineExpanded, setIsTimelineExpanded] = useState(true)
  const [timelineHeight, setTimelineHeight] = useState(() => {
    if (typeof window === 'undefined') {
      return DEFAULT_TIMELINE_HEIGHT
    }
    const stored = window.localStorage.getItem(TIMELINE_HEIGHT_STORAGE_KEY)
    const normalized = stored !== null ? normalizeTimelineHeight(parseInt(stored, 10)) : null
    return normalized ?? DEFAULT_TIMELINE_HEIGHT
  })
  const handleTimelineHeightChange = useCallback((value) => {
    setTimelineHeight(prev => {
      const normalized = normalizeTimelineHeight(value)
      return normalized ?? prev
    })
  }, [])
  const [selectedAudioTrack, setSelectedAudioTrack] = useState(null)
  const [maskContentPicker, setMaskContentPicker] = useState(null)
  const [graphicsSidebarTab, setGraphicsSidebarTab] = useState('graphics')
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(TIMELINE_HEIGHT_STORAGE_KEY, String(timelineHeight))
    }
  }, [timelineHeight])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('editor.showVideoExportProgress', showVideoExportProgress ? 'true' : 'false')
    }
  }, [showVideoExportProgress])

  // Save showRulers preference
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('editor.showRulers', showRulers ? 'true' : 'false')
    }
  }, [showRulers])

  // Save showFooterBar preference
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('editor.showFooterBar', showFooterBar ? 'true' : 'false')
    }
  }, [showFooterBar])

  // Handle fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isCurrentlyFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      )
      setIsFullscreen(isCurrentlyFullscreen)
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', handleFullscreenChange)
    document.addEventListener('MSFullscreenChange', handleFullscreenChange)

    // Handle F11 key for fullscreen
    const handleKeyDown = (e) => {
      if (e.key === 'F11') {
        e.preventDefault()
        const isCurrentlyFullscreen = !!(
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement
        )
        if (!isCurrentlyFullscreen) {
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen()
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen()
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen()
          } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen()
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          }
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange)
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  // Video export queue state
  const [videoExportJobs, setVideoExportJobs] = useState([])
  const [isExportingVideo, setIsExportingVideo] = useState(false)
  const [showVideoExportDialog, setShowVideoExportDialog] = useState(false)
  const [showDurationScaleDialog, setShowDurationScaleDialog] = useState(false)

  // Background removal jobs state
  const [backgroundRemovalJobs, setBackgroundRemovalJobs] = useState([])

  // AI image generation jobs state
  const [aiImageGenerationJobs, setAiImageGenerationJobs] = useState([])

  // Export progress jobs state (for PDF and image exports)
  const [exportProgressJobs, setExportProgressJobs] = useState([])
  const [isExportProgressExpanded, setIsExportProgressExpanded] = useState(true)
  const [mouseCoords, setMouseCoords] = useState({ x: 0, y: 0 })
  const [workspaceMouseCoords, setWorkspaceMouseCoords] = useState({ x: 0, y: 0 })
  const [currentPagePosition, setCurrentPagePosition] = useState({ x: 0, y: 0 })

  // Freehand tool state
  const [freehandToolActive, setFreehandToolActive] = useState(false)
  const [freehandPaths, setFreehandPaths] = useState([])
  const [freehandStrokeStyle, setFreehandStrokeStyle] = useState({
    color: '#000000',
    width: 2,
    lineCap: 'round',
    lineJoin: 'round',
    opacity: 1,
    startArrow: 'none',
    endArrow: 'none'
  })

  // Inline text editing state
  const [isEditingText, setIsEditingText] = useState(false)
  const [editingTextId, setEditingTextId] = useState(null)
  const [selectedTextRange, setSelectedTextRange] = useState(null)
  const [hasTextSelection, setHasTextSelection] = useState(false)
  const [textEditCaretPoint, setTextEditCaretPoint] = useState(null)

  // Context menu hook
  const { contextMenu, showContextMenu, hideContextMenu } = useContextMenu()

  // Unit conversion helpers (CSS pixel based)
  const DPI = 96
  const unitToPx = {
    px: 1,
    mm: DPI / 25.4,
    cm: DPI / 2.54,
    in: DPI,
    ft: DPI * 12,
  }
  const toPx = (value, unit) => Math.max(1, Math.round((value || 0) * (unitToPx[unit] || 1)))
  const fromPx = (px, unit) => Number(((px || 0) / (unitToPx[unit] || 1)).toFixed(2))
  const [showShareDialog, setShowShareDialog] = useState(false)
  const [selectedElementComment, setSelectedElementComment] = useState('')
  const [pageProperties, setPageProperties] = useState({ width: 800, height: 600, backgroundColor: '#ffffff' })
  const [showPagesViewDialog, setShowPagesViewDialog] = useState(false)
  const [zoomLevel, setZoomLevel] = useState(100) // Zoom percentage
  const zoomOptions = [1, 2, 10, 25, 40, 50, 65, 75, 85, 90, 95, 100, 110, 125, 150, 175, 200, 400, 800, 1200, 2000]
  const [downloadingStates, setDownloadingStates] = useState({
    currentPdf: false,
    fullPdf: false,
    currentImage: false,
    fullImage: false,
    currentTif: false,
    fullTif: false,
    save: false
  })
  const [showTifColorDialog, setShowTifColorDialog] = useState(false)
  const [tifDownloadType, setTifDownloadType] = useState('current') // 'current' or 'full'

  // Universal color mode dialog state
  const [showColorModeDialog, setShowColorModeDialog] = useState(false)
  const [colorModeDialogConfig, setColorModeDialogConfig] = useState({
    format: 'TIF',
    downloadType: 'current',
    handler: null
  })

  // Import progress state
  const [showImportProgress, setShowImportProgress] = useState(false)
  const [importProgress, setImportProgress] = useState({
    type: 'pdf', // 'pdf', 'psd', 'powerpoint'
    fileName: '',
    status: 'processing', // 'processing', 'success', 'error'
    progress: 0,
    message: ''
  })

  const [isSaving, setIsSaving] = useState(false)
  const [isSaved, setIsSaved] = useState(true) // Track if template is saved
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)

  const [previewTime, setPreviewTime] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)

  // PowerClip states
  const [powerClipMode, setPowerClipMode] = useState(false)
  const [powerClipContent, setPowerClipContent] = useState(null) // Element to be clipped
  const [editingPowerClip, setEditingPowerClip] = useState(null) // Currently editing PowerClip

  // Group editing state
  const [editingGroup, setEditingGroup] = useState(null) // ID of group currently in editing mode
  const [selectedElements, setSelectedElements] = useState([]) // Array of selected element IDs for multi-selection
  
  // Start a background removal job and poll its status
  const startBackgroundRemovalJob = useCallback(async (imageUrl, filename, elementId) => {
    try {
      // Add a temporary job entry while requesting job id
      const tempId = `br-${Date.now()}-${Math.random().toString(36).slice(2)}`
      setBackgroundRemovalJobs(prev => ([
        ...prev,
        {
          id: tempId,
          status: 'starting',
          progress: 0,
          filename: filename || 'image.png',
          elementId,
          new_image_url: null
        }
      ]))

      // Start job via the workflow General Queue (AI queue) — same path the AI
      // image flow uses. Returns { status:'success', job_id }.
      const resp = await fetch('/api/v1/ai-image/editor/remove-bg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_url: imageUrl, client_ref: `${elementId || 'el'}-${tempId}` })
      })
      const data = await resp.json().catch(() => null)
      if (!resp.ok || !data?.job_id) {
        throw new Error(data?.detail || data?.message || 'Failed to start background removal')
      }

      // Replace temp job with real job using returned job_id
      const realJob = {
        id: data.job_id,
        status: 'processing',
        progress: 0,
        filename: filename || 'image.png',
        elementId,
        new_image_url: null
      }
      setBackgroundRemovalJobs(prev => prev
        .filter(j => j.id !== tempId)
        .concat(realJob)
      )

      // Poller — the AI-queue status endpoint returns the cut-out as output_url.
      const poll = async () => {
        try {
          const statusResp = await fetch(`/api/v1/ai-image/editor/status/${data.job_id}?_t=${Date.now()}`, { cache: 'no-store' })
          const statusData = await statusResp.json().catch(() => null)
          const jobData = statusData?.data || statusData
          if (statusResp.ok && jobData && jobData.status) {
            const resultUrl = jobData.output_url || jobData.new_image_url || null
            setBackgroundRemovalJobs(prev => prev.map(j => j.id === data.job_id ? {
              ...j,
              status: jobData.status,
              progress: jobData.status === 'completed' ? 100 : (j.progress || 0),
              new_image_url: resultUrl || j.new_image_url,
              error: jobData.status === 'failed' ? (jobData.message || 'Background removal failed') : undefined
            } : j))

            if (jobData.status === 'processing' || jobData.status === 'starting') {
              setTimeout(poll, 2000)
            }
            // completed/failed/cancelled -> stop polling
          } else {
            // Transient failure to read status — keep polling instead of
            // immediately failing (the queue item may not be queryable yet).
            setTimeout(poll, 2500)
          }
        } catch (err) {
          // Network blip — retry rather than hard-fail.
          setTimeout(poll, 2500)
        }
      }
      // Initial delay to give backend time to enqueue
      setTimeout(poll, 1500)
    } catch (err) {
      // Mark any temp starting job as failed
      setBackgroundRemovalJobs(prev => prev.map(j => j.status === 'starting' ? {
        ...j,
        status: 'failed',
        error: err.message || 'Failed to start background removal'
      } : j))
    }
  }, [setBackgroundRemovalJobs])

  // Listen for start event dispatched by ImageElementProperties
  useEffect(() => {
    const handleStart = (e) => {
      const { imageUrl, filename, elementId } = e.detail || {}
      if (!imageUrl) return
      startBackgroundRemovalJob(imageUrl, filename, elementId)
      // Close/hide the Image Properties panel by clearing selection
      setSelectedElement(null)
    }
    window.addEventListener('background-removal:start', handleStart)
    return () => window.removeEventListener('background-removal:start', handleStart)
  }, [startBackgroundRemovalJob])

  const [drawingMode, setDrawingMode] = useState(null)
  const [isDrawing, setIsDrawing] = useState(false)
  const [drawingPath, setDrawingPath] = useState([])
  const [brushSize, setBrushSize] = useState(4)
  const [brushColor, setBrushColor] = useState('#000000')
  const [brushOpacity, setBrushOpacity] = useState(1)
  const [lineStart, setLineStart] = useState(null)

  // Drawing event handlers
  const onDrawingStart = useCallback((point) => {
    console.log('Drawing started at:', point);
  }, []);

  const onDrawingMove = useCallback((point) => {
    console.log('Drawing moved to:', point);
  }, []);

  const onDrawingEnd = useCallback(() => {
    console.log('Drawing ended');
  }, []);

  const addTable = (rows = 2, cols = 2, cellWidth = 80, cellHeight = 40, stroke = '#000000') => {
    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
    const width = cols * cellWidth
    const height = rows * cellHeight
    const id = `table-${Date.now()}`
    const table = {
      id,
      type: 'table',
      x: 100,
      y: 100,
      width,
      height,
      rows,
      cols,
      cellWidth,
      cellHeight,
      stroke,
      layer: maxLayer + 1,
    }
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) => index === currentPageIndex ? { ...page, items: [...(page.items || []), table] } : page)
    }))
    setSelectedElement(id)
  }
  // duplicate declarations removed (defined above with defaults)

  // File menu state
  const [showFileMenu, setShowFileMenu] = useState(false)

  // Clipboard state
  const [clipboardData, setClipboardData] = useState(null)
  const [clipboardOperation, setClipboardOperation] = useState(null) // 'copy' or 'cut'

  // Import menu state
  const [showImportMenu, setShowImportMenu] = useState(false)

  // Action menu state
  const [showActionMenu, setShowActionMenu] = useState(false)

  // View menu state
  const [showViewMenu, setShowViewMenu] = useState(false)
  const [showSampleGenerationDialog, setShowSampleGenerationDialog] = useState(false)
  const [showPastSamplesDialog, setShowPastSamplesDialog] = useState(false)
  const [showAiQueueDialog, setShowAiQueueDialog] = useState(false)

  // Undo/Redo state
  const [history, setHistory] = useState([])
  const [historyIndex, setHistoryIndex] = useState(-1)

  // Loading and template states
  const [isLoading, setIsLoading] = useState(true)
  const [template_id, settemplate_id] = useState(null)
  const [showAddPageDialog, setShowAddPageDialog] = useState(false)
  const [addPageConfig, setAddPageConfig] = useState({ width: 1000, height: 1000, backgroundColor: '#ffffff' })

  const [activeSecondarySidebar, setActiveSecondarySidebar] = useState(null)
  useEffect(() => {
    if (!maskContentPicker) return
    if (activeSecondarySidebar !== 'photos' && activeSecondarySidebar !== 'video') {
      setMaskContentPicker(null)
    }
  }, [activeSecondarySidebar])
  const [showAdvancedTextProperties, setShowAdvancedTextProperties] = useState(false)
  const [fontsSidebarPreviewText, setFontsSidebarPreviewText] = useState('Hello World')
  const shareDropdownRef = useRef(null)
  // Fixed rulers container size tracking
  const workspaceRef = useRef(null)
  const scrollAreaRef = useRef(null)
  // Audio playback references for timeline synchronization
  const audioRefs = useRef({})
  const currentWindowWidth = window.innerWidth
  const currentWindowHeight = window.innerHeight
  const [workspaceSize, setWorkspaceSize] = useState({ width: currentWindowWidth, height: currentWindowHeight }) 
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 })
  const [showPhotoUploadDialog, setShowPhotoUploadDialog] = useState(false)
  const [showCategoryDialog, setShowCategoryDialog] = useState(false)
  const [categoryDialogType, setCategoryDialogType] = useState(null) // 'photos', 'graphics', 'text', etc.
  
  // Error dialog state
  const [showErrorDialog, setShowErrorDialog] = useState(false)
  const [errorDialogConfig, setErrorDialogConfig] = useState({
    title: '',
    message: '',
    showContactInfo: false
  })

  useEffect(() => {
    if (!workspaceRef.current) return
    const observe = () => {
      const rect = workspaceRef.current.getBoundingClientRect()
      setWorkspaceSize({ width: Math.floor(rect.width), height: Math.floor(rect.height) })
    }
    observe()
    const ro = new ResizeObserver(observe)
    ro.observe(workspaceRef.current)
    window.addEventListener('resize', observe)
    return () => {
      ro.disconnect()
      window.removeEventListener('resize', observe)
    }
  }, [])



  // Helper function to generate CSS clipPath from shapeType for PowerClip containers
  const getShapeClipPath = (shapeType) => {
    if (!shapeType || shapeType === 'rectangle' || shapeType === 'square') return 'none';
    if (shapeType === 'circle') return 'circle(50%)';
    if (shapeType === 'ellipse') return 'ellipse(50% 50%)';
    if (shapeType === 'triangle') return 'polygon(50% 0%, 0% 100%, 100% 100%)';
    if (shapeType === 'star') return 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)';
    if (shapeType === 'hexagon') return 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)';
    if (shapeType === 'plus') return 'polygon(40% 0%, 60% 0%, 60% 40%, 100% 40%, 100% 60%, 60% 60%, 60% 100%, 40% 100%, 40% 60%, 0% 60%, 0% 40%, 40% 40%)';
    if (shapeType === 'heart') return 'path("M 0.5 0.9 C 0.5 0.9 0.1 0.5 0.1 0.3 C 0.1 0.2 0.2 0.1 0.3 0.1 C 0.4 0.1 0.5 0.2 0.5 0.3 C 0.5 0.2 0.6 0.1 0.7 0.1 C 0.8 0.1 0.9 0.2 0.9 0.3 C 0.9 0.5 0.5 0.9 0.5 0.9 Z")';
    if (shapeType === 'chat') return 'polygon(10% 10%, 90% 10%, 90% 70%, 30% 70%, 10% 90%)';
    if (shapeType === 'arrow') return 'polygon(50% 10%, 70% 50%, 50% 70%, 30% 50%)';

    // For SVG-path shapes from shapesData.js
    const shapeData = ALL_SHAPES.find(shape => shape.shapeType === shapeType);
    if (shapeData && shapeData.svgPath) {
      return `url(#clip-${shapeType})`;
    }

    return 'none';
  };

  // Helper to render inline SVG clipPath definitions for complex shapes
  const renderSvgClipDefs = (shapeType) => {
    if (!shapeType) return null;
    const shapeData = ALL_SHAPES.find(shape => shape.shapeType === shapeType);
    if (!shapeData || !shapeData.svgPath) return null;
    // Only render for shapes that use url(#clip-...) — skip basic shapes handled by CSS
    const basicTypes = ['rectangle', 'square', 'circle', 'ellipse', 'triangle', 'star', 'hexagon', 'plus', 'heart', 'chat', 'arrow'];
    if (basicTypes.includes(shapeType)) return null;

    return (
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <clipPath id={`clip-${shapeType}`} clipPathUnits="objectBoundingBox"
            transform={`scale(${1 / (parseFloat((shapeData.viewBox || '0 0 100 100').split(/[\s,]+/)[2]) || 100)}, ${1 / (parseFloat((shapeData.viewBox || '0 0 100 100').split(/[\s,]+/)[3]) || 100)})`}>
            <path d={shapeData.svgPath} />
          </clipPath>
        </defs>
      </svg>
    );
  };

  // Helper function to render shapes using shapes data
  const renderShapeByType = (shapeType, fill, stroke, strokeWidth) => {
    // First check if it's a basic shape (existing logic)
    const basicShapes = {
      'triangle': '50,10 90,90 10,90',
      'star': '50,5 61,35 96,35 68,57 79,91 50,70 21,91 32,57 4,35 39,35',
      'heart': 'M50,90 C50,90 10,50 10,30 C10,20 20,10 30,10 C40,10 50,20 50,30 C50,20 60,10 70,10 C80,10 90,20 90,30 C90,50 50,90 50,90 Z',
      'arrow': '50,10 70,50 50,70 30,50',
      'hexagon': '25,10 75,10 90,50 75,90 25,90 10,50',
      'plus': 'M40,10 L60,10 L60,40 L90,40 L90,60 L60,60 L60,90 L40,90 L40,60 L10,60 L10,40 L40,40 Z',
      'chat': 'M10,20 Q10,10 20,10 L80,10 Q90,10 90,20 L90,60 Q90,70 80,70 L30,70 L10,90 L10,20 Z'
    };

    // Check if it's a basic shape
    if (basicShapes[shapeType]) {
      const isPolygon = ['triangle', 'star', 'arrow', 'hexagon'].includes(shapeType);
      return isPolygon ? (
        <polygon
          points={basicShapes[shapeType]}
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      ) : (
        <path
          d={basicShapes[shapeType]}
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      );
    }

    // Check if it's a comprehensive shape from shapes data
    const shapeData = ALL_SHAPES.find(shape => shape.shapeType === shapeType);
    if (shapeData) {
      return (
        <path
          d={shapeData.svgPath}
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      );
    }

    // Fallback for unknown shapes
    return null;
  };

  // Close share dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (shareDropdownRef.current && !shareDropdownRef.current.contains(event.target)) {
        setShowShareDialog(false)
      }
    }

    if (showShareDialog) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showShareDialog])
  const canvasRef = useRef(null)
  const [template_content, settemplate_content] = useState(null)
  const [template_category_id, settemplate_category_id] = useState(null)
  const [templateMetadata, setTemplateMetadata] = useState(null)

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(template_content, null, 2))
      // TODO: replace with snackbar service
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'success', message: 'Template content copied to clipboard!' } }))
    } catch (err) {
      console.error('Failed to copy: ', err)
      // Fallback for older browsers
      const textArea = document.createElement('textarea')
      textArea.value = JSON.stringify(template_content, null, 2)
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      alert('Template content copied to clipboard!')
    }
  }

  // Re-arrange every page's items array into ascending order of their `layer`
  // number (items without a layer are treated as 0). This only reorders the
  // array; it does not change any layer values or item geometry — purely a
  // tidy-up of the JSON order so it matches render/stacking order.
  const rearrangeItemsByLayer = () => {
    settemplate_content(prev => {
      if (!prev || !Array.isArray(prev.pages)) return prev
      return {
        ...prev,
        pages: prev.pages.map(page => {
          if (!page || !Array.isArray(page.items)) return page
          // Stable sort by layer (ascending). Array.prototype.sort is stable in
          // modern engines, so items sharing a layer keep their relative order.
          const sortedItems = [...page.items].sort(
            (a, b) => ((a?.layer ?? 0) - (b?.layer ?? 0))
          )
          return { ...page, items: sortedItems }
        })
      }
    })
    setHasUnsavedChanges(true)
    setIsSaved(false)
    window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'success', message: 'Items re-arranged by layer order.' } }))
  }

  // Page management functions
  const currentPage = template_content?.pages?.[currentPageIndex]
  const isPageLocked = currentPage?.page_config?.locked || false

  // Element interaction functions
  const handleElementMouseDown = useCallback((e, elementId) => {
    // Don't prevent default for double-click events on text elements
    const targetElement = currentPage?.items?.find(item => item.id === elementId)
    if (targetElement?.type === 'text' && e.detail === 2) {
      // This is a double-click on a text element, let it through
      return
    }

    e.preventDefault()
    e.stopPropagation()

    if (isPageLocked) return

    // Handle PowerClip mode
    if (powerClipMode && powerClipContent) {
      applyPowerClip(elementId)
      return
    }

    // Handle group selection logic
    // Check if the clicked element is a child of a group
    let resolvedElementId = elementId
    let parentGroup = null
    for (const item of currentPage?.items || []) {
      if (item.type === 'group' && item.children) {
        const isChild = item.children.some(child => child.id === elementId)
        if (isChild) {
          parentGroup = item
          break
        }
      }
    }

    if (parentGroup) {
      if (editingGroup === parentGroup.id) {
        // In editing mode for this group: select the child directly
        resolvedElementId = elementId
      } else {
        // Not in editing mode: select the parent group
        resolvedElementId = parentGroup.id
      }
    }

    // If clicking a group item directly (not a child), select the group
    const clickedItem = currentPage?.items?.find(item => item.id === elementId)
    if (clickedItem?.type === 'group' && editingGroup !== clickedItem.id) {
      resolvedElementId = clickedItem.id
    }

    // If we're in group editing mode and clicking outside the editing group's children,
    // exit editing mode
    if (editingGroup) {
      const editingGroupItem = currentPage?.items?.find(item => item.id === editingGroup)
      const isClickOnEditingGroup = resolvedElementId === editingGroup
      const isClickOnEditingGroupChild = editingGroupItem?.children?.some(child => child.id === resolvedElementId)
      if (!isClickOnEditingGroup && !isClickOnEditingGroupChild) {
        setEditingGroup(null)
      }
    }

    // Shift+click: toggle item in multi-selection for grouping
    if (e.shiftKey && !editingGroup) {
      setSelectedElements(prev => {
        const alreadySelected = prev.includes(resolvedElementId)
        let updated
        if (alreadySelected) {
          // Remove from multi-selection
          updated = prev.filter(id => id !== resolvedElementId)
        } else {
          // Add to multi-selection (include current selectedElement if not already there)
          updated = [...prev]
          if (selectedElement && !updated.includes(selectedElement)) {
            updated.push(selectedElement)
          }
          updated.push(resolvedElementId)
        }
        return updated
      })
      setSelectedElement(resolvedElementId)
      return // Don't start dragging during multi-select
    }

    // Regular click: clear multi-selection and select single item
    if (selectedElements.length > 0) {
      setSelectedElements([])
    }

    setSelectedElement(resolvedElementId)
    setIsDragging(true)

    if (!canvasRef.current) return
    if (!canvasRef.current) return
    const rect = canvasRef.current.getBoundingClientRect()
    let element = currentPage?.items?.find(item => item.id === resolvedElementId)
    let container = null

    // If not found as regular element, check PowerClip contents
    if (!element) {
      for (const item of currentPage?.items || []) {
        if (item.isPowerClipContainer && item.powerClipContents) {
          const foundContent = item.powerClipContents.find(content => content.id === resolvedElementId)
          if (foundContent) {
            element = foundContent
            container = item
            break
          }
        }
      }
    }

    // If not found as regular element or PowerClip content, check group children
    if (!element) {
      for (const item of currentPage?.items || []) {
        if (item.type === 'group' && item.children) {
          const foundChild = item.children.find(child => child.id === resolvedElementId)
          if (foundChild) {
            element = foundChild
            container = item
            break
          }
        }
      }
    }

    if (element) {
      // Calculate absolute position for PowerClip content or group children
      const absoluteX = container ? container.x + element.x : element.x
      const absoluteY = container ? container.y + element.y : element.y
      const scale = zoomLevel / 100

      // Adjust drag offset for zoom level
      setDragOffset({
        x: (e.clientX - rect.left) / scale - absoluteX,
        y: (e.clientY - rect.top) / scale - absoluteY
      })
    }
  }, [isPageLocked, currentPage, editingGroup, selectedElement, selectedElements])

  // Create handleMouseMove function using the external handler
  const handleMouseMove = createHandleMouseMove({
    isPageLocked,
    canvasRef,
    isDrawing,
    drawingMode,
    lineStart,
    setDrawingPath,
    isDragging,
    selectedElement,
    dragOffset,
    settemplate_content,
    currentPageIndex,
    isResizing,
    resizeHandle,
    currentPage,
    isRotating,
    rotationStart,
    zoomLevel // Pass zoomLevel to mouse handler
  })

  const handleMouseUp = useCallback(() => {
    // Handle drawing finish
    if (isDrawing) {
      // Inline drawing finish logic to avoid circular dependency
      if (drawingMode === 'line' && lineStart && drawingPath.length === 2) {
        const [p0, p1] = drawingPath
        const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
        const newLine = {
          id: `line-${Date.now()}`,
          type: 'line',
          x: Math.min(p0.x, p1.x),
          y: Math.min(p0.y, p1.y),
          width: Math.abs(p1.x - p0.x),
          height: Math.abs(p1.y - p0.y),
          pathData: `M ${p0.x} ${p0.y} L ${p1.x} ${p1.y}`,
          stroke: brushColor,
          strokeWidth: brushSize,
          opacity: brushOpacity,
          fill: 'none',
          rotation: 0,
          locked: false,
          layer: maxLayer + 1,
        }
        settemplate_content(prev => ({
          ...prev,
          pages: prev.pages.map((page, index) => index === currentPageIndex ? { ...page, items: [...(page.items || []), newLine] } : page)
        }))
        setHasUnsavedChanges(true)
        setIsSaved(false)
      } else if (drawingPath.length >= 2) {
        // Create SVG path from drawing points
        const pathData = drawingPath.reduce((path, point, index) => {
          if (index === 0) {
            return `M ${point.x} ${point.y}`
          } else {
            return `${path} L ${point.x} ${point.y}`
          }
        }, '')

        // Add drawing as a new element
        const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
        const newDrawing = {
          id: `drawing-${Date.now()}`,
          type: 'drawing',
          x: Math.min(...drawingPath.map(p => p.x)),
          y: Math.min(...drawingPath.map(p => p.y)),
          width: Math.max(...drawingPath.map(p => p.x)) - Math.min(...drawingPath.map(p => p.x)) + brushSize,
          height: Math.max(...drawingPath.map(p => p.y)) - Math.min(...drawingPath.map(p => p.y)) + brushSize,
          pathData,
          stroke: drawingMode === 'highlighter' ? brushColor : brushColor,
          strokeWidth: drawingMode === 'marker' ? brushSize * 2 : brushSize,
          opacity: drawingMode === 'highlighter' ? 0.35 : brushOpacity,
          fill: 'none',
          rotation: 0,
          locked: false,
          layer: maxLayer + 1,
          drawingMode: drawingMode
        }

        settemplate_content(prev => ({
          ...prev,
          pages: prev.pages.map((page, index) =>
            index === currentPageIndex
              ? { ...page, items: [...(page.items || []), newDrawing] }
              : page
          )
        }))

        // Mark as unsaved inline
        setHasUnsavedChanges(true)
        setIsSaved(false)
      }

      setIsDrawing(false)
      setLineStart(null)
      setDrawingPath([])
      return
    }

    setIsDragging(false)
    setIsResizing(false)
    setIsRotating(false)
    setResizeHandle(null)
  }, [isDrawing, drawingPath, brushSize, drawingMode, brushColor, brushOpacity, currentPage, currentPageIndex])



  const updateElementSize = (elementId, width, height) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: page.items.map(item =>
              item.id === elementId
                ? { ...item, width: Math.max(20, width), height: Math.max(20, height) }
                : item
            )
          }
          : page
      )
    }))
  }

  const handleResizeMouseDown = useCallback((e, handle) => {
    e.preventDefault()
    e.stopPropagation()
    if (isPageLocked) return

    setIsResizing(true)
    setResizeHandle(handle)
  }, [isPageLocked])

  const handleRotateMouseDown = useCallback((e, elementId) => {
    e.preventDefault()
    e.stopPropagation()
    if (isPageLocked) return

    if (!canvasRef.current) return
    const rect = canvasRef.current.getBoundingClientRect()
    const scale = zoomLevel / 100
    const element = currentPage?.items?.find(item => item.id === elementId)
    if (element) {
      const centerX = element.x + element.width / 2
      const centerY = element.y + element.height / 2
      // Adjust mouse coordinates for zoom level
      const mouseX = (e.clientX - rect.left) / scale
      const mouseY = (e.clientY - rect.top) / scale

      const initialAngle = Math.atan2(mouseY - centerY, mouseX - centerX) * (180 / Math.PI)

      setIsRotating(true)
      setRotationStart({
        x: mouseX,
        y: mouseY,
        angle: initialAngle,
        initialRotation: element.rotation || 0
      })
    }
  }, [isPageLocked, currentPage])

  const deleteElement = (elementId) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
              ...page,
              items: page.items.map(item => {
                // If this is the container/element to delete, remove it.
                // For a group, matching the group id removes the whole group
                // (and all its children) at once.
                if (item.id === elementId) {
                  return null; // Will be filtered out
                }

                // If a specific child inside a group is being deleted (while
                // editing the group), remove just that child.
                if (item.type === 'group' && Array.isArray(item.children)) {
                  if (item.children.some(child => child.id === elementId)) {
                    return {
                      ...item,
                      children: item.children.filter(child => child.id !== elementId)
                    };
                  }
                }

                // Check if this item is a PowerClip container with nested items
                if (item.isPowerClipContainer && item.powerClipContents) {
                  // Check if the element to delete is inside this PowerClip container
                  const hasNestedItem = item.powerClipContents.some(nested => nested.id === elementId);
                  
                  if (hasNestedItem) {
                    // Remove the nested item from powerClipContents
                    const updatedContents = item.powerClipContents.filter(nested => nested.id !== elementId);
                    
                    // If container becomes empty, optionally remove it or keep it
                    // For now, we'll keep the container even if empty
                    return {
                      ...item,
                      powerClipContents: updatedContents
                    };
                  }

                  // Recursively check nested PowerClip containers
                  const updatedContents = item.powerClipContents.map(nestedItem => {
                    // If nested item is a PowerClip container, recursively process it
                    if (nestedItem.isPowerClipContainer && nestedItem.powerClipContents) {
                      const hasNestedNestedItem = nestedItem.powerClipContents.some(nestedNested => nestedNested.id === elementId);
                      if (hasNestedNestedItem) {
                        return {
                          ...nestedItem,
                          powerClipContents: nestedItem.powerClipContents.filter(nestedNested => nestedNested.id !== elementId)
                        };
                      }
                    }
                    return nestedItem;
                  });

                  // Check if any nested item was updated
                  if (updatedContents.some((c, i) => c !== item.powerClipContents[i])) {
                    return { ...item, powerClipContents: updatedContents };
                  }
                }

                return item;
              }).filter(item => item !== null) // Remove null items (deleted containers)
            }
          : page
      )
    }))
    setSelectedElement(null)
    markAsUnsaved()
  }

  const duplicateElement = (elementId) => {
    const element = currentPage?.items?.find(item => item.id === elementId)
    if (element) {
      const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
      // Deep-clone with fresh ids so groups/PowerClips don't share child ids
      // with the original (which would break selection, updates, and delete).
      const newElement = {
        ...cloneItemWithNewIds(element),
        x: element.x + 20,
        y: element.y + 20,
        layer: maxLayer + 1
      }

      settemplate_content(prev => ({
        ...prev,
        pages: prev.pages.map((page, index) =>
          index === currentPageIndex
            ? {
              ...page,
              items: [...page.items, newElement]
            }
            : page
        )
      }))
      markAsUnsaved()
    }
  }

  const toggleElementLock = (elementId) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: page.items.map(item =>
              item.id === elementId
                ? { ...item, locked: !item.locked }
                : item
            )
          }
          : page
      )
    }))
  }

  // Utility function to ensure all elements have layer values
  const ensureElementsHaveLayers = (items) => {
    return items.map((item, index) => ({
      ...item,
      layer: item.layer !== undefined ? item.layer : index
    }))
  }

  // Layer management functions
  const moveElementUp = (elementId) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: page.items.map(item =>
              item.id === elementId
                ? { ...item, layer: (item.layer || 0) + 1 }
                : item
            )
          }
          : page
      )
    }))
  }

  const moveElementDown = (elementId) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
              ...page,
              items: page.items.map(item =>
                item.id === elementId
                  ? { ...item, layer: Math.max(0, (item.layer || 0) - 1) }
                  : item
              )
            }
          : page
      )
    }))
  }

  // Fit container to content
  const fitElementToContent = (elementId) => {
    const item = currentPage?.items?.find(item => item.id === elementId)
    if (!item) return

    let newWidth = item.width || 100
    let newHeight = item.height || 100

    if (item.type === 'text') {
      // Use a temporary DOM element to measure text accurately
      // This accounts for all CSS properties including word wrapping
      const tempDiv = document.createElement('div')
      tempDiv.style.position = 'absolute'
      tempDiv.style.visibility = 'hidden'
      tempDiv.style.whiteSpace = 'pre-wrap' // Preserve line breaks
      tempDiv.style.wordWrap = 'break-word'
      tempDiv.style.overflow = 'visible'
      tempDiv.style.width = 'auto'
      tempDiv.style.height = 'auto'
      tempDiv.style.maxWidth = 'none'
      tempDiv.style.minWidth = '0'
      tempDiv.style.display = 'inline-block'
      
      // Apply all text properties
      const fontSize = item.fontSize || 16
      const fontFamily = item.fontFamily || 'Arial'
      const fontWeight = item.fontWeight || 'normal'
      const fontStyle = item.fontStyle || 'normal'
      const lineHeight = item.lineHeight || 1.2
      const letterSpacing = item.letterSpacing || 0
      const wordSpacing = item.wordSpacing || 0
      const textAlign = item.textAlign || 'left'
      
      tempDiv.style.fontSize = `${fontSize}px`
      tempDiv.style.fontFamily = `"${fontFamily}", sans-serif`
      tempDiv.style.fontWeight = fontWeight
      tempDiv.style.fontStyle = fontStyle
      tempDiv.style.lineHeight = lineHeight
      tempDiv.style.letterSpacing = `${letterSpacing}px`
      tempDiv.style.wordSpacing = `${wordSpacing}px`
      tempDiv.style.textAlign = textAlign
      tempDiv.style.padding = '0'
      tempDiv.style.margin = '0'
      tempDiv.style.border = 'none'
      tempDiv.style.boxSizing = 'content-box'
      
      // Set content - preserve line breaks
      const textContent = item.content || ''
      tempDiv.textContent = textContent
      
      // Add to DOM temporarily (required for accurate measurement)
      document.body.appendChild(tempDiv)
      
      // Force a reflow to ensure accurate measurement
      void tempDiv.offsetHeight
      
      // Get dimensions using multiple methods for accuracy
      const rect = tempDiv.getBoundingClientRect()
      const scrollWidth = tempDiv.scrollWidth
      const scrollHeight = tempDiv.scrollHeight
      
      let measuredWidth = Math.max(rect.width, scrollWidth)
      let measuredHeight = Math.max(rect.height, scrollHeight)
      
      // If height is 0 or very small (empty or single line), calculate based on line height
      if (measuredHeight < fontSize) {
        const lines = textContent.split('\n').filter(line => line.trim().length > 0)
        const lineCount = lines.length || 1
        measuredHeight = fontSize * lineHeight * lineCount
      }
      
      // If width is 0 (empty text), set a minimum
      if (measuredWidth === 0) {
        measuredWidth = fontSize * 2
      }
      
      // Account for stroke width
      const strokeWidth = item.strokeWidth || 0
      if (strokeWidth > 0) {
        measuredWidth += strokeWidth * 2
        measuredHeight += strokeWidth * 2
      }
      
      // Account for text shadow
      if (item.textShadow?.enabled || item.shadowBlur > 0) {
        const shadowBlur = item.textShadow?.blur || item.shadowBlur || 4
        const shadowOffsetX = Math.abs(item.textShadow?.offsetX || item.shadowOffsetX || 2)
        const shadowOffsetY = Math.abs(item.textShadow?.offsetY || item.shadowOffsetY || 2)
        measuredWidth += (shadowOffsetX + shadowBlur) * 2
        measuredHeight += (shadowOffsetY + shadowBlur) * 2
      }
      
      // Add padding for better visual fit
      const padding = 12
      newWidth = Math.max(Math.ceil(measuredWidth + padding * 2), 50)
      newHeight = Math.max(Math.ceil(measuredHeight + padding * 2), 50)
      
      // Clean up
      document.body.removeChild(tempDiv)
      
    } else if (item.type === 'image') {
      // Use image natural dimensions if available
      if (item.naturalWidth && item.naturalHeight) {
        newWidth = item.naturalWidth
        newHeight = item.naturalHeight
      } else {
        // Try to load image and get natural dimensions
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          settemplate_content(prev => ({
            ...prev,
            pages: prev.pages.map((page, index) =>
              index === currentPageIndex
                ? {
                    ...page,
                    items: page.items.map(i =>
                      i.id === elementId
                        ? { 
                            ...i, 
                            width: img.naturalWidth, 
                            height: img.naturalHeight,
                            naturalWidth: img.naturalWidth,
                            naturalHeight: img.naturalHeight
                          }
                        : i
                    )
                  }
                : page
          )
          }))
          markAsUnsaved()
        }
        img.onerror = () => {
          // If image fails to load, keep current dimensions
          console.warn('Failed to load image for fit operation')
        }
        img.src = item.src || item.url || ''
        
        // Return early since we're handling this asynchronously
        return
      }
      
    } else if (item.type === 'video') {
      // Use video dimensions if available
      if (item.naturalWidth && item.naturalHeight) {
        newWidth = item.naturalWidth
        newHeight = item.naturalHeight
      } else if (item.width && item.height) {
        newWidth = item.width
        newHeight = item.height
      }
      
    } else if (item.type === 'shape' || item.type === 'graphic') {
      // For shapes, use current dimensions (they're already defined by the shape)
      // Could potentially calculate from SVG bounds, but current dimensions should work
      newWidth = item.width || 100
      newHeight = item.height || 100
      
    } else if (item.isPowerClipContainer && item.powerClipContents && item.powerClipContents.length > 0) {
      // Calculate bounding box of all nested items
      let minX = Infinity
      let minY = Infinity
      let maxX = -Infinity
      let maxY = -Infinity
      
      item.powerClipContents.forEach(content => {
        const x = content.x || 0
        const y = content.y || 0
        const w = content.width || 0
        const h = content.height || 0
        
        minX = Math.min(minX, x)
        minY = Math.min(minY, y)
        maxX = Math.max(maxX, x + w)
        maxY = Math.max(maxY, y + h)
      })
      
      if (minX !== Infinity && minY !== Infinity) {
        newWidth = Math.max(maxX - minX, 50)
        newHeight = Math.max(maxY - minY, 50)
      }
    }

    // Update the element with new dimensions
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
              ...page,
              items: page.items.map(i =>
                i.id === elementId
                  ? { ...i, width: newWidth, height: newHeight }
                  : i
              )
            }
          : page
      )
    }))
    
    markAsUnsaved()
  }

  // Element visibility toggle
  const toggleElementVisibility = (elementId) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: page.items.map(item =>
              item.id === elementId
                ? { ...item, hidden: !item.hidden }
                : item
            )
          }
          : page
      )
    }))
  }

  // Element selection from items list
  const handleElementSelectFromList = (elementId) => {
    setSelectedElement(elementId)
    // Keep sidebar open after selection for better user experience
  }

  // Handle selecting a child inside a group from the items list sidebar
  const handleGroupChildSelectFromList = (groupId, childId) => {
    setEditingGroup(groupId)
    setSelectedElement(childId)
  }

  // Text splitting functions
  const splitTextIntoWords = (elementId) => {
    const element = currentPage?.items?.find(item => item.id === elementId)
    if (!element || element.type !== 'text' || !element.content) return

    const words = element.content.split(/\s+/).filter(word => word.trim())
    if (words.length <= 1) return

    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
    const newElements = words.map((word, index) => ({
      ...element,
      id: `text-word-${Date.now()}-${index}`,
      content: word,
      x: element.x + (index * 60), // Offset each word
      y: element.y,
      layer: maxLayer + index + 1
    }))

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: [
              ...page.items.filter(item => item.id !== elementId),
              ...newElements
            ]
          }
          : page
      )
    }))
    setSelectedElement(null)
  }

  const splitTextIntoCharacters = (elementId) => {
    const element = currentPage?.items?.find(item => item.id === elementId)
    if (!element || element.type !== 'text' || !element.content) return

    const characters = element.content.split('').filter(char => char.trim())
    if (characters.length <= 1) return

    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
    const newElements = characters.map((char, index) => ({
      ...element,
      id: `text-char-${Date.now()}-${index}`,
      content: char,
      x: element.x + (index * 20), // Offset each character
      y: element.y,
      width: 20,
      layer: maxLayer + index + 1
    }))

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: [
              ...page.items.filter(item => item.id !== elementId),
              ...newElements
            ]
          }
          : page
      )
    }))
    setSelectedElement(null)
  }

  // Inline text editing functions
  const handleTextDoubleClick = (textElement, e) => {
    setEditingTextId(textElement.id)
    setIsEditingText(true)
    setSelectedElement(textElement.id)

    if (e) {
      const target = e.currentTarget
      const rect = target?.getBoundingClientRect()
      const point = { x: e.clientX, y: e.clientY }
      const local = rect ? { x: point.x - rect.left, y: point.y - rect.top } : null
      setTextEditCaretPoint({ ...point, local })
    } else {
      setTextEditCaretPoint(null)
    }
  }

  const handleTextUpdate = (elementId, updates) => {
    // Handle multiple property updates
    Object.entries(updates).forEach(([property, value]) => {
      updateElementProperty(elementId, property, value)
    })
  }

  const handleTextEditClose = () => {
    setIsEditingText(false)
    setEditingTextId(null)
    setSelectedTextRange(null)
    setHasTextSelection(false)
    // Clear the global reference
    if (window.currentTextEditor) {
      window.currentTextEditor = null
    }
  }

  // Handle clicks outside to exit text editing mode
  const handleWorkspaceClick = (e) => {
    if (!isEditingText) return

    const clickedInsideEditor = e.target.closest('.inline-text-editor')
    const clickedInsideCurrentElement = e.target.closest(`[data-element-id="${editingTextId}"]`)

    // Only close if click is outside both the editor overlay and the current text element container
    if (!clickedInsideEditor && !clickedInsideCurrentElement) {
      handleTextEditClose()
    }
  }

  const getGlowPulseSettingsForElement = (element) => {
    if (!element) {
      return DEFAULT_GLOW_PULSE_SETTINGS
    }
    if (element.textEffect?.type === 'glowPulse' && element.textEffect?.settings) {
      return normalizeGlowPulseSettings(element.textEffect.settings)
    }
    if (element.textGlow?.enabled) {
      return normalizeGlowPulseSettings({
        color: element.textGlow?.color,
        blur: element.textGlow?.blur,
        spread: element.textGlow?.spread,
        intensity: element.textGlow?.intensity,
      })
    }
    if (element.glowEnabled) {
      return normalizeGlowPulseSettings({
        color: element.glowColor,
        blur: element.glowBlur,
        spread: element.glowSpread,
        intensity: element.glowIntensity,
      })
    }
    return DEFAULT_GLOW_PULSE_SETTINGS
  }

  const getTextEffectPresentation = (element) => {
    if (!element) {
      return { effectType: null, effectClass: '', effectStyle: {} }
    }
    const effectType = typeof element.textEffect === 'string'
      ? element.textEffect
      : element.textEffect?.type
    if (!effectType) {
      return { effectType: null, effectClass: '', effectStyle: {} }
    }
    const effectClass = `text-effect text-effect-${effectType}`
    const effectStyle = {}
    if (effectType === 'typewriter') {
      const length = Math.max((element.content || '').length, 1)
      effectStyle['--text-effect-length'] = `${length}`
      const typingDuration = Math.max(element.time?.duration || 3, 1)
      effectStyle['--typing-duration'] = `${typingDuration}s`
    } else if (effectType === 'strokeReveal') {
      const textLength = Math.max((element.content || '').length * 20, 400)
      effectStyle['--stroke-length'] = `${textLength}`
    } else if (effectType === 'glowPulse') {
      const settings = getGlowPulseSettingsForElement(element)
      effectStyle['--glow-blur-min'] = `${Math.max(2, settings.blur * 0.6)}px`
      effectStyle['--glow-blur-max'] = `${Math.max(3, settings.blur)}px`
      effectStyle['--glow-spread'] = `${Math.max(2, settings.spread)}px`
      effectStyle['--glow-duration'] = `${Math.max(0.5, settings.duration)}s`
      effectStyle['--glow-color-weak'] = hexToRgba(settings.color, settings.intensity * 0.45)
      effectStyle['--glow-color-strong'] = hexToRgba(settings.color, Math.min(1, settings.intensity))
    }
    return { effectType, effectClass, effectStyle }
  }

  const handleTextSelection = (selectedText, range, selectionRange) => {
    // Handle text selection for formatting
    console.log('Text selected:', selectedText, range)
    setSelectedTextRange(selectionRange)
    setHasTextSelection(!!selectedText)

    // Store reference for properties bar to use
    window.currentTextEditor = {
      hasSelection: !!selectedText,
      selectedText,
      selectionRange
    }
  }

  // Save functionality
  // const saveTemplate = async (showAlert = true) => {
  //   if (isSaving) return

  //   // Check if template is public (cannot be modified)
  //   if (templateMetadata?.is_public) {
  //     console.log('Template is public, cannot be modified')
  //     if (showAlert) {
  //       alert('This template is public and cannot be modified.')
  //     }
  //     return
  //   }

  //   // Check if template is locked
  //   const currentPage = template_content?.pages?.[currentPageIndex]
  //   if (currentPage?.page_config?.locked) {
  //     console.log('Template is locked, skipping save')
  //     return
  //   }

  //   setIsSaving(true)
  //   setIsSaved(false) // Mark as not saved during save process

  //   try {
  //     // Prepare save data
  //     const template_id = template_content.id || projectId
  //     const saveData = {
  //       name: template_content.name || 'Untitled Template',
  //       description: template_content.description || 'Created with video editor',
  //       category: template_content.category || 'custom',
  //       template_content: template_content,
  //       is_public: false
  //     }

  //     // Check if template exists before including ID
  //     if (template_id) {
  //       try {
  //         const checkResponse = await templateAPI.check(template_id)
  //         const checkResult = checkResponse.data

  //         if (checkResult.success && checkResult.exists) {
  //           saveData.id = template_id
  //           console.log('Template exists, will update:', template_id)
  //         } else {
  //           console.log('Template does not exist, will create new one. Original ID:', template_id)
  //         }
  //       } catch (error) {
  //         console.warn('Could not check template existence, will create new one:', error)
  //       }
  //     }

  //     const response = await templateAPI.save(saveData)
  //     const result = response.data
  //     console.log('Template saved successfully:', result)

  //     // Update template content with the saved ID
  //     if (result.data && result.data.id) {
  //       settemplate_content(prev => ({ ...prev, id: result.data.id }))

  //       // If this was a new template, update the URL to include the ID
  //       if (!template_content.id && !projectId) {
  //         window.history.replaceState(null, '', `/editor/${result.data.id}`)
  //       }
  //     }

  //     // Mark as saved and clear unsaved changes
  //     setIsSaved(true)
  //     setHasUnsavedChanges(false)

  //     // Show success message only for manual saves
  //     if (showAlert) {
  //       const isUpdate = template_content.id || projectId
  //       const message = isUpdate ? 'Template updated successfully!' : 'Template saved successfully!'
  //       window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'success', message } }))
  //     }
  //   } catch (error) {
  //     console.error('Error saving template:', error)
  //     setIsSaved(false) // Mark as not saved on error
  //     if (showAlert) {
  //       window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'error', message: `Failed to save template: ${error.message}` } }))
  //     }
  //   } finally {
  //     setIsSaving(false)
  //   }
  // }

  // Auto-save functionality - every 60 seconds, only if unlocked and has unsaved changes
  useEffect(() => {
    const autoSaveInterval = setInterval(() => {
      const currentPage = template_content?.pages?.[currentPageIndex]
      const isLocked = currentPage?.page_config?.locked

      if (template_content &&
        template_content.pages &&
        template_content.pages.length > 0 &&
        !isLocked &&
        hasUnsavedChanges) {
        console.log('Auto-saving template...')
        //handleSave(false) // Don't show alert for auto-save
      }
    }, 5*60000) // 5 minutes

    return () => clearInterval(autoSaveInterval)
  }, [template_content, currentPageIndex, hasUnsavedChanges])

  // Helper function to mark template as having unsaved changes
  const markAsUnsaved = () => {
    setHasUnsavedChanges(true)
    setIsSaved(false)
  }

  // PowerClip Functions
  const startPowerClip = (elementId) => {
    const element = currentPage?.items?.find(item => item.id === elementId)
    if (element) {
      setPowerClipContent(element)
      setPowerClipMode(true)
      setSelectedElement(null)
    }
  }

  // Recursive function to render PowerClip content (supports nested PowerClip)
  const renderPowerClipContent = (content, parentId) => {
    if (content.type === 'text') {
      return (
        <div
          className="w-full h-full flex items-center justify-center"
          style={{
            fontSize: content.fontSize || 16,
            fontFamily: content.fontFamily || 'Arial',
            color: content.color || '#000000',
            fontWeight: content.fontWeight || 'normal',
            textAlign: content.textAlign || 'center'
          }}
        >
          {content.content}
        </div>
      )
    }

    if (content.type === 'image') {
      return (
        <div
          className="w-full h-full"
          style={{
            opacity: content.opacity ?? 1,
            filter: (() => {
              if (content.filters?.cssFilter) {
                return content.filters.cssFilter;
              }
              return `
                brightness(${(content.brightness ?? 0) + 100}%)
                contrast(${(content.contrast ?? 0) + 100}%)
                saturate(${(content.intensity ?? 0) + 100}%)
                hue-rotate(${content.hueRotate || 0}deg)
                sepia(${Math.max(0, content.sepia || 0)}%)
                grayscale(${Math.max(0, content.grayscale || 0)}%)
                blur(${Math.max(0, content.blur || 0)}px)
              `;
            })(),
            transform: `scaleX(${content.flipX ? -1 : 1}) scaleY(${content.flipY ? -1 : 1})`,
            transformOrigin: 'center center',
            WebkitMaskImage: content.gradientMask || undefined,
            maskImage: content.gradientMask || undefined,
            WebkitMaskSize: '100% 100%',
            maskSize: '100% 100%',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
          }}
        >
          <img
            src={content.src}
            alt={content.alt || 'PowerClip content'}
            className="w-full h-full object-cover"
            draggable={false}
          />
        </div>
      )
    }

    if (content.type === 'shape') {
      // Handle nested PowerClip containers
      if (content.isPowerClipContainer && content.powerClipContents) {
        return (
          <div
            className={`w-full h-full relative ${editingPowerClip === content.id ? '' : 'overflow-hidden'
              } ${selectedElement === content.id ? 'ring-2 ring-blue-500' : ''
              }`}
            style={{
              backgroundColor: content.fill || 'transparent',
              border: `${(content.strokeWidth || 0)}px solid ${content.stroke || 'transparent'}`,
              borderRadius: `${(content.borderRadius ?? content.cornerRadius ?? 0)}px`,
              boxShadow: (() => {
                if (content.shadow?.enabled) {
                  const { offsetX, offsetY, blur, spread, color, opacity, inset } = content.shadow;
                  const shadowOpacity = opacity || 0.25;
                  const shadowColor = color || '#000000';
                  const rgbaColor = shadowColor.startsWith('#')
                    ? `${shadowColor}${Math.round(shadowOpacity * 255).toString(16).padStart(2, '0')}`
                    : `rgba(0, 0, 0, ${shadowOpacity})`;
                  return `${inset ? 'inset ' : ''}${offsetX || 0}px ${offsetY || 0}px ${blur || 0}px ${spread || 0}px ${rgbaColor}`;
                }
                return 'none';
              })(),
              clipPath: getShapeClipPath(content.shapeType)
            }}
          >
            {/* SVG clipPath definitions for complex shapes */}
            {renderSvgClipDefs(content.shapeType)}
            {/* Render nested PowerClip contents recursively */}
            {content.powerClipContents.map((nestedContent, nestedIndex) => (
              <div                key={`${nestedContent.id}-nested-${nestedIndex}`}
                className={`absolute ${editingPowerClip === content.id ? 'cursor-move' : ''
                  } ${editingPowerClip === content.id && selectedElement === nestedContent.id ? 'ring-2 ring-green-500' : ''
                  }`}
                style={{
                  left: nestedContent.x,
                  top: nestedContent.y,
                  width: nestedContent.width,
                  height: nestedContent.height,
                  transform: `rotate(${nestedContent.rotation || 0}deg)`,
                  opacity: nestedContent.opacity || 1,
                  zIndex: nestedContent.layer || 0
                }}
                onClick={(e) => {
                  if (editingPowerClip === content.id) {
                    e.stopPropagation()
                    setSelectedElement(nestedContent.id)
                  }
                }}
                onMouseDown={(e) => {
                  if (editingPowerClip === content.id) {
                    e.stopPropagation()
                    handleElementMouseDown(e, nestedContent.id)
                  }
                }}
              >
                {/* Recursive call for infinite nesting */}
                {renderPowerClipContent(nestedContent, content.id)}
              </div>
            ))}
          </div>
        )
      } else {
        // Regular shape rendering
        return (
          <div
            className="w-full h-full"
            style={{
              backgroundColor: content.fill || 'transparent',
              border: `${(content.strokeWidth || 0)}px solid ${content.stroke || 'transparent'}`,
              borderRadius: `${(content.borderRadius ?? content.cornerRadius ?? 0)}px`,
              clipPath: content.clipPath !== 'none' ? content.clipPath : 'none'
            }}
          />
        )
      }
    }

    // Group inside PowerClip - render group children within the PowerClip's clipping region
    if (content.type === 'group' && content.children) {
      return (
        <div
          className="w-full h-full relative"
          style={{
            pointerEvents: content.locked ? 'none' : 'auto',
          }}
        >
          {content.children
            .slice()
            .sort((a, b) => (a.layer || 0) - (b.layer || 0))
            .map((groupChild, groupChildIndex) => (
              <div
                key={`${groupChild.id}-pcgroup-${groupChildIndex}`}
                className="absolute"
                style={{
                  left: groupChild.x,
                  top: groupChild.y,
                  width: groupChild.width,
                  height: groupChild.height,
                  transform: `rotate(${groupChild.rotation || 0}deg)`,
                  transformOrigin: 'center center',
                  opacity: groupChild.opacity ?? 1,
                  zIndex: (groupChild.layer || 0) + 10,
                }}
              >
                {renderPowerClipContent(groupChild, content.id)}
              </div>
            ))}
        </div>
      )
    }

    // Default fallback
    return (
      <div className="w-full h-full bg-gray-200 flex items-center justify-center text-xs text-gray-500">
        {content.type || 'Unknown'}
      </div>
    )
  }

  /**
   * Renders a single canvas item by type. Used for group children rendering
   * so that nested groups and other item types render correctly via recursion.
   * @param {Object} child - The item to render
   * @param {Object|null} parentGroup - The parent group item (for editing mode context)
   */
  const renderCanvasItem = (child, parentGroup) => {
    if (child.type === 'shape' && !child.isPowerClipContainer) {
      return (
        <div
          className="w-full h-full"
          style={{
            backgroundColor: child.fill || '#cccccc',
            borderRadius: `${(child.borderRadius ?? child.cornerRadius ?? 0)}px`,
            border: child.stroke ? `${child.strokeWidth || 1}px solid ${child.stroke}` : 'none',
            boxShadow: (() => {
              if (child.shadow?.enabled) {
                const { offsetX, offsetY, blur, spread, color, opacity, inset } = child.shadow;
                const shadowOpacity = opacity || 0.25;
                const shadowColor = color || '#000000';
                const rgbaColor = shadowColor.startsWith('#')
                  ? `rgba(${parseInt(shadowColor.slice(1, 3), 16)}, ${parseInt(shadowColor.slice(3, 5), 16)}, ${parseInt(shadowColor.slice(5, 7), 16)}, ${shadowOpacity})`
                  : shadowColor;
                return `${inset ? 'inset ' : ''}${offsetX || 4}px ${offsetY || 4}px ${blur || 8}px ${spread || 0}px ${rgbaColor}`;
              }
              return child.boxShadow || 'none';
            })(),
            clipPath: child.clipPath !== 'none' ? child.clipPath : undefined,
          }}
        />
      )
    }

    if (child.type === 'shape' && child.isPowerClipContainer && child.powerClipContents) {
      return (
        <div
          className={`w-full h-full relative overflow-hidden`}
          style={{
            backgroundColor: child.fill || 'transparent',
            border: `${(child.strokeWidth || 0)}px solid ${child.stroke || 'transparent'}`,
            borderRadius: `${(child.borderRadius ?? child.cornerRadius ?? 0)}px`,
            clipPath: getShapeClipPath(child.shapeType),
          }}
        >
          {renderSvgClipDefs(child.shapeType)}
          {child.powerClipContents.map((content, contentIndex) => (
            <div
              key={`${content.id}-${contentIndex}`}
              className="absolute"
              style={{
                left: content.x,
                top: content.y,
                width: content.width,
                height: content.height,
                transform: `rotate(${content.rotation || 0}deg)`,
                opacity: content.opacity ?? 1,
                zIndex: content.layer || 0,
              }}
            >
              {renderPowerClipContent(content, child.id)}
            </div>
          ))}
        </div>
      )
    }

    if (child.type === 'text') {
      return (
        <div
          className={`w-full h-full flex ${child.verticalAlign === 'bottom' ? 'items-end' :
            child.verticalAlign === 'middle' ? 'items-center' : 'items-start'
            } ${child.textAlign === 'left' ? 'justify-start' :
              child.textAlign === 'right' ? 'justify-end' : 'justify-center'
            }`}
          style={{
            fontSize: child.fontSize || 16,
            fontFamily: child.fontFamily || 'Arial',
            color: child.color || child.fill || '#000000',
            fontWeight: child.fontWeight || 'normal',
            fontStyle: child.fontStyle || 'normal',
            lineHeight: child.lineHeight || 1,
            letterSpacing: `${child.letterSpacing || 0}px`,
            textAlign: child.textAlign || 'center',
            textDecoration: child.textDecoration || 'none',
            direction: child.direction || 'ltr',
            textShadow: (() => {
              const shadows = [];
              if (child.strokeWidth > 0) {
                const strokeColor = child.stroke || '#000000';
                const sw = child.strokeWidth;
                for (let angle = 0; angle < 360; angle += 30) {
                  const radian = (angle * Math.PI) / 180;
                  shadows.push(`${Math.cos(radian) * sw}px ${Math.sin(radian) * sw}px ${sw * 0.3}px ${strokeColor}`);
                }
              }
              if (child.textShadow?.enabled) {
                const { offsetX, offsetY, blur, color, opacity: shadowOpacity } = child.textShadow;
                const sc = color || '#000000';
                const so = shadowOpacity || 0.5;
                const rgbaColor = sc.startsWith('#')
                  ? `rgba(${parseInt(sc.slice(1, 3), 16)}, ${parseInt(sc.slice(3, 5), 16)}, ${parseInt(sc.slice(5, 7), 16)}, ${so})`
                  : sc;
                shadows.push(`${offsetX || 2}px ${offsetY || 2}px ${blur || 4}px ${rgbaColor}`);
              }
              return shadows.length > 0 ? shadows.join(', ') : 'none';
            })(),
          }}
        >
          {child.richText && child.richText.spans && child.richText.spans.length > 0
            ? <span dangerouslySetInnerHTML={{
                __html: (() => {
                  const content = child.content || ''
                  const spans = [...child.richText.spans].sort((a, b) => a.start - b.start)
                  let html = ''
                  let cursor = 0
                  spans.forEach(({ start, end, styles }) => {
                    if (start > cursor) html += content.slice(cursor, start).replace(/\n/g, '<br/>')
                    const text = content.slice(start, end).replace(/\n/g, '<br/>')
                    const styleStr = Object.entries(styles || {}).map(([k, v]) => `${k.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}:${v}`).join(';')
                    html += `<span style="${styleStr}">${text}</span>`
                    cursor = end
                  })
                  if (cursor < content.length) html += content.slice(cursor).replace(/\n/g, '<br/>')
                  return html
                })()
              }} />
            : (child.content || '').split('\n').map((line, idx, arr) => (
                <React.Fragment key={`${child.id}-line-${idx}`}>
                  {line || '\u00A0'}
                  {idx < arr.length - 1 && <br />}
                </React.Fragment>
              ))
          }
        </div>
      )
    }

    if (child.type === 'image') {
      return (
        <div
          className="w-full h-full"
          style={{
            opacity: child.opacity ?? 1,
            filter: (() => {
              if (child.filters?.cssFilter) return child.filters.cssFilter;
              return `
                brightness(${(child.brightness ?? 0) + 100}%)
                contrast(${(child.contrast ?? 0) + 100}%)
                saturate(${(child.intensity ?? 0) + 100}%)
                hue-rotate(${child.hueRotate || 0}deg)
              `;
            })(),
            transform: `scaleX(${child.flipX ? -1 : 1}) scaleY(${child.flipY ? -1 : 1})`,
            transformOrigin: 'center center',
          }}
        >
          <img
            src={child.src || child.url || child.image_url}
            alt=""
            className="w-full h-full object-cover"
            draggable={false}
          />
        </div>
      )
    }

    if (child.type === 'video') {
      return (
        <VideoPreview
          item={child}
          previewTime={previewTime}
          isPlaying={isPlaying}
          isVideoTemplate={(template_content?.type || template_content?.mediaType) === 'video'}
          onTimeUpdate={null}
        />
      )
    }

    if (child.type === 'group' && child.children) {
      // Recursive group rendering for nested groups
      return (
        <div
          className="w-full h-full relative"
          style={{
            pointerEvents: child.locked ? 'none' : 'auto',
          }}
        >
          {child.children
            .slice()
            .sort((a, b) => (a.layer || 0) - (b.layer || 0))
            .map((nestedChild) => (
              <div
                key={nestedChild.id}
                data-element-id={nestedChild.id}
                className="absolute"
                style={{
                  left: nestedChild.x,
                  top: nestedChild.y,
                  width: nestedChild.width,
                  height: nestedChild.height,
                  transform: `rotate(${nestedChild.rotation || 0}deg)`,
                  transformOrigin: 'center center',
                  opacity: nestedChild.opacity ?? 1,
                  zIndex: (nestedChild.layer || 0) + 10,
                }}
              >
                {renderCanvasItem(nestedChild, child)}
              </div>
            ))}
        </div>
      )
    }

    // First-class inline SVG item (type:"svg" + svgContent). Preserves the
    // SVG's own multi-color palette by default; recolors only when the item
    // opts in via recolorSvg (fill/stroke override).
    if (child.type === 'svg') {
      const markup = prepareSvgContent(child.svgContent, {
        scopeId: `svg-${child.id}`,
        preserveAspectRatio: child.preserveAspectRatio || (child.stretch ? 'none' : 'xMidYMid meet'),
        recolor: !!child.recolorSvg,
        fill: child.fill,
        stroke: child.stroke,
        strokeWidth: child.strokeWidth,
      })
      return (
        <div
          className="w-full h-full"
          style={{ opacity: child.opacity ?? 1 }}
          dangerouslySetInnerHTML={{ __html: markup }}
        />
      )
    }

    if (child.type === 'graphic' || child.type === 'svg-graphic') {
      return (
        <div
          className="w-full h-full"
          style={{
            fill: child.fill || 'currentColor',
            stroke: child.stroke || 'none',
            strokeWidth: child.strokeWidth || 1,
          }}
          dangerouslySetInnerHTML={{
            __html: child.svgData?.replace(
              /<svg([^>]*)>/,
              (_m, attrs) => {
                const idMatch = attrs.match(/\sid="([^"]+)"/)
                const id = idMatch ? idMatch[1] : `svg-${child.id}`
                const withId = idMatch ? `<svg${attrs}>` : `<svg${attrs} id="${id}">`
                const style = `<style>#${id} path,#${id} rect,#${id} circle,#${id} ellipse,#${id} line,#${id} polyline,#${id} polygon,#${id} text{fill:${child.fill || 'currentColor'} !important;stroke:${child.stroke || 'none'} !important;stroke-width:${child.strokeWidth || 1}px !important;vector-effect:non-scaling-stroke;}</style>`
                return withId.replace(/<svg([^>]*)>/, `<svg$1 width="100%" height="100%" preserveAspectRatio="none" style="overflow: visible;">${style}`)
              }
            )
          }}
        />
      )
    }

    if (child.type === 'drawing' || child.type === 'line') {
      return (
        <svg width={child.width} height={child.height} className="absolute inset-0">
          <path d={child.pathData} stroke={child.stroke} strokeWidth={child.strokeWidth} fill={child.fill || 'none'} opacity={child.opacity ?? 1} />
        </svg>
      )
    }

    // Default fallback for unknown types
    return (
      <div className="w-full h-full bg-gray-200 flex items-center justify-center text-xs text-gray-500">
        {child.type || 'Unknown'}
      </div>
    )
  }

  const applyPowerClip = (containerId) => {
    if (!powerClipContent || !containerId) return

    const container = currentPage?.items?.find(item => item.id === containerId)
    if (!container) return

    // Only shapes can be PowerClip containers
    if (container.type !== 'shape') {
      alert('PowerClip containers must be shapes. Please select a shape as the container.')
      return
    }

    // Prevent PowerClipping an element into itself
    if (powerClipContent.id === containerId) {
      alert('Cannot PowerClip an element into itself.')
      return
    }

    // Check for circular nesting (prevent infinite loops)
    const checkCircularNesting = (element, targetId) => {
      if (element.id === targetId) return true
      if (element.isPowerClipContainer && element.powerClipContents) {
        return element.powerClipContents.some(content => checkCircularNesting(content, targetId))
      }
      return false
    }

    if (checkCircularNesting(powerClipContent, containerId)) {
      alert('Cannot create circular PowerClip nesting. This would create an infinite loop.')
      return
    }

    // Create PowerClip relationship
    const powerClipId = `powerclip-${Date.now()}`
    const existing = Array.isArray(container.powerClipContents) ? container.powerClipContents : []
    const newContent = {
      ...powerClipContent,
      id: `${powerClipContent.id}-clipped-${Date.now()}`,
      isPowerClipContent: true,
      powerClipId,
      x: (container.width - powerClipContent.width) / 2,
      y: (container.height - powerClipContent.height) / 2,
      // Preserve nested PowerClip structure if the content is also a PowerClip container
      ...(powerClipContent.isPowerClipContainer && {
        isPowerClipContainer: true,
        powerClipContents: powerClipContent.powerClipContents
      })
    }

    const updatedContainer = {
      ...container,
      isPowerClipContainer: true,
      powerClipContents: [...existing, newContent]
    }

    // Update template content
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: page.items
              .filter(item => item.id !== powerClipContent.id)
              .map(item => (item.id === containerId ? updatedContainer : item))
          }
          : page
      )
    }))

    // Reset PowerClip mode
    setPowerClipMode(false)
    setPowerClipContent(null)
    setSelectedElement(containerId)
    markAsUnsaved()
  }

  const editPowerClip = (elementId) => {
    setEditingPowerClip(elementId)
  }

  const finishEditingPowerClip = () => {
    setEditingPowerClip(null)
  }

  // Update layer for PowerClip content item
  const updatePowerClipContentLayer = (containerId, contentId, newLayer) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
              ...page,
              items: page.items.map(item => {
                if (item.id === containerId && item.isPowerClipContainer && item.powerClipContents) {
                  return {
                    ...item,
                    powerClipContents: item.powerClipContents.map(content =>
                      content.id === contentId
                        ? { ...content, layer: parseInt(newLayer) || 0 }
                        : content
                    )
                  }
                }
                return item
              })
            }
          : page
      )
    }))
    markAsUnsaved()
  }

  // Delete PowerClip content item
  const deletePowerClipContent = (containerId, contentId) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
              ...page,
              items: page.items.map(item => {
                if (item.id === containerId && item.isPowerClipContainer && item.powerClipContents) {
                  return {
                    ...item,
                    powerClipContents: item.powerClipContents.filter(content => content.id !== contentId)
                  }
                }
                return item
              })
            }
          : page
      )
    }))
    markAsUnsaved()
    // If the deleted item was selected, clear selection
    if (selectedElement === contentId) {
      setSelectedElement(null)
    }
  }

  const extractPowerClipContents = (elementId) => {
    const element = currentPage?.items?.find(item => item.id === elementId)
    if (!element || !element.isPowerClipContainer || !element.powerClipContents) return

    const extractedContents = element.powerClipContents.map(content => ({
      ...content,
      id: content.id.replace('-clipped', ''),
      isPowerClipContent: false,
      powerClipId: undefined,
      // Convert back to absolute positioning
      x: content.x + element.x,
      y: content.y + element.y
    }))

    const containerWithoutPowerClip = {
      ...element,
      isPowerClipContainer: false,
      powerClipContents: undefined
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: [
              ...page.items.filter(item => item.id !== elementId),
              containerWithoutPowerClip,
              ...extractedContents
            ]
          }
          : page
      )
    }))

    setSelectedElement(null)
    markAsUnsaved()
  }

  // Update PowerClip content properties
  const updatePowerClipContent = (containerId, contentId, property, value) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: page.items.map(item =>
              item.id === containerId && item.isPowerClipContainer
                ? {
                  ...item,
                  powerClipContents: item.powerClipContents.map(content =>
                    content.id === contentId
                      ? { ...content, [property]: value }
                      : content
                  )
                }
                : item
            )
          }
          : page
      )
    }))
    markAsUnsaved()
  }

  // Track changes to mark template as having unsaved changes (but not on initial load)
  useEffect(() => {
    if (template_content && template_content.pages && template_content.pages.length > 0) {
      // Only mark as unsaved if this isn't the initial load
      const isInitialLoad = template_content.pages.length === 1 &&
        template_content.pages[0].items.length === 0
      if (!isInitialLoad) {
        setHasUnsavedChanges(true)
        setIsSaved(false)
      }
    }
  }, [template_content])

  const saveElementComment = (elementId, comment) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: page.items.map(item =>
              item.id === elementId
                ? { ...item, comment: comment }
                : item
            )
          }
          : page
      )
    }))
  }

  const openPageProperties = () => {
    const currentPageConfig = currentPage?.page_config || {}
    setPageProperties({
      width: currentPageConfig.width || 800,
      height: currentPageConfig.height || 600,
      unit: currentPageConfig.unit || 'px',
      backgroundColor: currentPageConfig.backgroundColor || '#ffffff'
    })
    setShowPagePropertiesDialog(true)
  }

  const savePageProperties = () => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            page_config: {
              ...page.page_config,
              width: toPx(pageProperties.width, pageProperties.unit),
              height: toPx(pageProperties.height, pageProperties.unit),
              unit: pageProperties.unit,
              backgroundColor: pageProperties.backgroundColor
            }
          }
          : page
      )
    }))
    setShowPagePropertiesDialog(false)
  }

  // Zoom functions
  const zoomIn = () => {
    const currentIndex = zoomOptions.indexOf(zoomLevel)
    if (currentIndex < zoomOptions.length - 1) {
      setZoomLevel(zoomOptions[currentIndex + 1])
    }
  }

  const zoomOut = () => {
    const currentIndex = zoomOptions.indexOf(zoomLevel)
    if (currentIndex > 0) {
      setZoomLevel(zoomOptions[currentIndex - 1])
    }
  }

  const zoomToFit = () => {
    const currentPageData = template_content?.pages?.[currentPageIndex]
    if (!currentPageData || !canvasRef.current || !scrollAreaRef.current) return

    // Get the scrollable container (canvas area)
    const scrollContainer = scrollAreaRef.current
    
    // Get available space in the scroll container
    const containerWidth = scrollContainer.clientWidth
    const containerHeight = scrollContainer.clientHeight

    // Get page dimensions
    const pageWidth = currentPageData.page_config?.width || 800
    const pageHeight = currentPageData.page_config?.height || 600

    // Calculate scale to fit page within available space
    // Account for padding: 40px on each side horizontally, and account for top padding (200px for first page)
    const horizontalPadding = 80 // 40px on each side
    const topPadding = currentPageIndex === 0 ? 200 : 100
    const bottomPadding = 50
    const availableWidth = containerWidth - horizontalPadding
    const availableHeight = containerHeight - topPadding - bottomPadding

    const scaleX = availableWidth / pageWidth
    const scaleY = availableHeight / pageHeight
    const scale = Math.min(scaleX, scaleY)

    // Set zoom level. Allow very low zoom so large pages (up to 15000x15000) fit fully;
    // clamp min to 1% so a 15000px page still fits in a ~900px viewport.
    const newZoomLevel = Math.max(1, Math.min(500, Math.round(scale * 100)))
    setZoomLevel(newZoomLevel)

    // After zoom is set, center the page by scrolling
    // Use setTimeout to ensure the zoom has been applied and DOM is updated
    setTimeout(() => {
      if (!canvasRef.current || !scrollContainer) return
      
      // Get the actual position of the canvas element
      const canvasRect = canvasRef.current.getBoundingClientRect()
      const scrollRect = scrollContainer.getBoundingClientRect()
      
      // Calculate the page's position relative to the scroll container
      const pageOffsetX = canvasRect.left - scrollRect.left + scrollContainer.scrollLeft
      const pageOffsetY = canvasRect.top - scrollRect.top + scrollContainer.scrollTop
      
      const scaledPageWidth = pageWidth * (newZoomLevel / 100)
      const scaledPageHeight = pageHeight * (newZoomLevel / 100)
      
      // Calculate scroll position to center the page horizontally and position it at the top with padding
      const scrollLeft = Math.max(0, pageOffsetX - (containerWidth - scaledPageWidth) / 2)
      const scrollTop = Math.max(0, pageOffsetY - topPadding)
      
      scrollContainer.scrollTo({
        left: scrollLeft,
        top: scrollTop,
        behavior: 'smooth'
      })
    }, 150)
  }

  const zoomTo100 = () => {
    setZoomLevel(100)
  }

  // Auto-fit when the current page's dimensions change (open, page switch, or resize)
  // and the page would overflow the viewport at the current zoom. Keeps large pages
  // (up to 15000x15000) usable without manual fitting. Runs once per size change.
  const _lastFitKeyRef = useRef(null)
  useEffect(() => {
    const page = template_content?.pages?.[currentPageIndex]
    const sc = scrollAreaRef.current
    if (!page?.page_config || !sc) return
    const pw = page.page_config.width || 800
    const ph = page.page_config.height || 600
    const key = `${currentPageIndex}:${pw}x${ph}`
    if (_lastFitKeyRef.current === key) return
    _lastFitKeyRef.current = key

    // Only auto-fit if the page doesn't comfortably fit at the current zoom.
    const t = setTimeout(() => {
      const cont = scrollAreaRef.current
      if (!cont) return
      const availW = cont.clientWidth - 80
      const availH = cont.clientHeight - (currentPageIndex === 0 ? 250 : 150)
      const scaledW = pw * (zoomLevel / 100)
      const scaledH = ph * (zoomLevel / 100)
      if (scaledW > availW || scaledH > availH) {
        zoomToFit()
      }
    }, 120)
    return () => clearTimeout(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPageIndex, template_content?.pages?.[currentPageIndex]?.page_config?.width, template_content?.pages?.[currentPageIndex]?.page_config?.height])

  // Handle mouse wheel zoom
  const handleWheelZoom = useCallback((e) => {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault()
      const currentIndex = zoomOptions.indexOf(zoomLevel)
      if (e.deltaY > 0 && currentIndex > 0) {
        setZoomLevel(zoomOptions[currentIndex - 1]) // Zoom out
      } else if (e.deltaY < 0 && currentIndex < zoomOptions.length - 1) {
        setZoomLevel(zoomOptions[currentIndex + 1]) // Zoom in
      }
    }
  }, [zoomLevel, zoomOptions])

  // Handle keyboard shortcuts for zoom
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && !e.shiftKey) {
        switch (e.key) {
          case '=':
          case '+':
            e.preventDefault()
            zoomIn()
            break
          case '-':
            e.preventDefault()
            zoomOut()
            break
          case '0':
            e.preventDefault()
            zoomTo100()
            break
          case '1':
            e.preventDefault()
            zoomToFit()
            break
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [zoomIn, zoomOut, zoomTo100, zoomToFit])

  // Add wheel event listener to canvas area
  useEffect(() => {
    const canvasArea = document.querySelector('.canvas-area')
    if (canvasArea) {
      canvasArea.addEventListener('wheel', handleWheelZoom, { passive: false })
      return () => canvasArea.removeEventListener('wheel', handleWheelZoom)
    }
  }, [handleWheelZoom])




  // Handle tool activation from toolbar
  const handleToolActivation = (tool) => {
    if (tool === 'pen' || tool === 'marker' || tool === 'highlighter' || tool === 'eraser') {
      setDrawingMode(tool)
      setSelectedElement(null) // Clear selection when entering drawing mode
    } else {
      setDrawingMode(null)
    }
  }

  // Listen for drawing mode activation events from toolbar
  useEffect(() => {
    const handleDrawingModeActivation = (event) => {
      handleToolActivation(event.detail)
    }

    window.addEventListener('activateDrawingMode', handleDrawingModeActivation)
    return () => {
      window.removeEventListener('activateDrawingMode', handleDrawingModeActivation)
    }
  }, [])

  // Close file menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showFileMenu && !event.target.closest('.file-menu-container')) {
        setShowFileMenu(false)
      }
      if (showImportMenu && !event.target.closest('.import-menu-container')) {
        setShowImportMenu(false)
      }
      if (showActionMenu && !event.target.closest('.action-menu-container')) {
        setShowActionMenu(false)
      }
      if (showViewMenu && !event.target.closest('.view-menu-container')) {
        setShowViewMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showFileMenu, showImportMenu, showActionMenu, showViewMenu])

  // History management functions
  const saveToHistory = useCallback((state) => {
    const newHistory = history.slice(0, historyIndex + 1)
    newHistory.push(JSON.parse(JSON.stringify(state)))

    // Limit history to 50 entries
    if (newHistory.length > 50) {
      newHistory.shift()
    } else {
      setHistoryIndex(prev => prev + 1)
    }

    setHistory(newHistory)
  }, [history, historyIndex])

  const undo = useCallback(() => {
    if (historyIndex > 0) {
      const previousState = history[historyIndex - 1]
      settemplate_content(previousState)
      setHistoryIndex(prev => prev - 1)
    }
  }, [history, historyIndex])

  const redo = useCallback(() => {
    if (historyIndex < history.length - 1) {
      const nextState = history[historyIndex + 1]
      settemplate_content(nextState)
      setHistoryIndex(prev => prev + 1)
    }
  }, [history, historyIndex])

  // Save initial state to history
  useEffect(() => {
    if (template_content && history.length === 0) {
      saveToHistory(template_content)
    }
  }, [template_content, history.length, saveToHistory])

  // Save to history when content changes (debounced)
  useEffect(() => {
    if (!template_content || history.length === 0) return

    const timeoutId = setTimeout(() => {
      const currentState = JSON.stringify(template_content)
      const lastState = history[historyIndex] ? JSON.stringify(history[historyIndex]) : null

      if (currentState !== lastState) {
        saveToHistory(template_content)
      }
    }, 1000) // 1 second debounce

    return () => clearTimeout(timeoutId)
  }, [template_content, history, historyIndex, saveToHistory])

  // Clipboard functions
  const copyElement = useCallback((elementId) => {
    const element = currentPage?.items?.find(item => item.id === elementId)
    if (element) {
      setClipboardData({ ...element })
      setClipboardOperation('copy')
      console.log('Element copied to clipboard:', element.id)
    }
  }, [currentPage])

  const cutElement = useCallback((elementId) => {
    const element = currentPage?.items?.find(item => item.id === elementId)
    if (element) {
      setClipboardData({ ...element })
      setClipboardOperation('cut')

      // Remove element from current page
      settemplate_content(prev => ({
        ...prev,
        pages: prev.pages.map((page, index) =>
          index === currentPageIndex
            ? {
                ...page,
                items: page.items.filter(item => item.id !== elementId)
              }
            : page
        )
      }))

      // Clear selection if the cut element was selected
      if (selectedElement === elementId) {
        setSelectedElement(null)
      }

      markAsUnsaved()
      console.log('Element cut to clipboard:', element.id)
    }
  }, [currentPage, currentPageIndex, selectedElement, settemplate_content, setSelectedElement, markAsUnsaved])

  const pasteElement = useCallback(() => {
    if (!clipboardData) return

    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
    // Deep-clone with fresh ids so a pasted group/PowerClip doesn't share child
    // ids with the source (which would break selection, updates, and delete).
    const newElement = {
      ...cloneItemWithNewIds(clipboardData),
      x: clipboardData.x + 20,
      y: clipboardData.y + 20,
      layer: maxLayer + 1
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
              ...page,
              items: [...page.items, newElement]
            }
          : page
      )
    }))

    // Select the pasted element
    setSelectedElement(newElement.id)

    // If it was a cut operation, clear clipboard after paste
    if (clipboardOperation === 'cut') {
      setClipboardData(null)
      setClipboardOperation(null)
    }

    markAsUnsaved()
    console.log('Element pasted:', newElement.id)
  }, [clipboardData, clipboardOperation, currentPage, currentPageIndex, settemplate_content, setSelectedElement, markAsUnsaved])

  // Keyboard shortcuts for undo/redo and clipboard
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Skip if user is typing in an input field
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.contentEditable === 'true') {
        return
      }

      if (e.ctrlKey || e.metaKey) {
        switch (e.key.toLowerCase()) {
          case 'z':
            if (!e.shiftKey) {
              e.preventDefault()
              undo()
            } else {
              e.preventDefault()
              redo()
            }
            break
          case 'y':
            e.preventDefault()
            redo()
            break
          case 'c':
            if (selectedElement) {
              e.preventDefault()
              copyElement(selectedElement)
            }
            break
          case 'x':
            if (selectedElement) {
              e.preventDefault()
              cutElement(selectedElement)
            }
            break
          case 'v':
            if (clipboardData) {
              e.preventDefault()
              pasteElement()
            }
            break
          case 'd':
            if (selectedElement) {
              e.preventDefault()
              duplicateElement(selectedElement)
            }
            break
          case 'g':
            e.preventDefault()
            if (e.shiftKey) {
              // Ctrl+Shift+G: Ungroup
              if (selectedElement) {
                const currentItems = template_content?.pages?.[currentPageIndex]?.items || []
                const selectedItem = currentItems.find(item => item.id === selectedElement)
                if (selectedItem && selectedItem.type === 'group') {
                  const updatedItems = ungroupItem(selectedItem, currentItems)
                  settemplate_content(prev => ({
                    ...prev,
                    pages: prev.pages.map((page, index) =>
                      index === currentPageIndex ? { ...page, items: updatedItems } : page
                    )
                  }))
                  setSelectedElement(null)
                  setEditingGroup(null)
                  markAsUnsaved()
                }
              }
            } else {
              // Ctrl+G: Group selected items
              if (selectedElements.length >= 2) {
                const currentItems = template_content?.pages?.[currentPageIndex]?.items || []
                const itemsToGroup = currentItems.filter(item => selectedElements.includes(item.id))
                if (itemsToGroup.length >= 2) {
                  const { group, updatedItems } = createGroup(itemsToGroup, currentItems)
                  if (group) {
                    settemplate_content(prev => ({
                      ...prev,
                      pages: prev.pages.map((page, index) =>
                        index === currentPageIndex ? { ...page, items: updatedItems } : page
                      )
                    }))
                    setSelectedElement(group.id)
                    setSelectedElements([])
                    markAsUnsaved()
                  }
                }
              }
            }
            break
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [undo, redo, selectedElement, selectedElements, clipboardData, copyElement, cutElement, pasteElement, duplicateElement, template_content, currentPageIndex, settemplate_content, editingGroup, markAsUnsaved])

  // Group editing mode: Escape key handler
  useEffect(() => {
    const handleGroupEditKeyDown = (e) => {
      if (e.key === 'Escape' && editingGroup) {
        e.preventDefault()
        // Exit editing mode and select the group
        setSelectedElement(editingGroup)
        setEditingGroup(null)
      }
    }

    window.addEventListener('keydown', handleGroupEditKeyDown)
    return () => window.removeEventListener('keydown', handleGroupEditKeyDown)
  }, [editingGroup])

  // Export progress event listener
  useEffect(() => {
    const handleExportProgress = (event) => {
      const { jobId, job } = event.detail;
      
      // Update exportProgressJobs (for ExportProgress component)
      setExportProgressJobs(prev => {
        const existingIndex = prev.findIndex(j => j.id === jobId);
        if (existingIndex >= 0) {
          // Update existing job
          const updated = [...prev];
          updated[existingIndex] = job;
          return updated;
        } else {
          // Add new job
          return [...prev, job];
        }
      });
    };

    window.addEventListener('export:progress', handleExportProgress);
    return () => {
      window.removeEventListener('export:progress', handleExportProgress);
    };
  }, []);

  // On mount (and when the user is known), seed the export queue panel with the user's
  // recent jobs from the server and resume polling for any still-in-flight jobs. This lets
  // the bottom-right queue survive reloads and show historical exports.
  useEffect(() => {
    const uid = user?.id;
    if (!uid) return;
    exportService.loadUserJobs(String(uid)).catch(() => {});
  }, [user?.id]);

  // Create loadTemplate function using the external loader
  const loadTemplate = createLoadTemplate({
    setIsLoading,
    settemplate_content,
    settemplate_id,
    templateAPI,
    settemplate_category_id,
    setTemplateMetadata
  })

  // Function to show error dialog
  const handleShowErrorDialog = useCallback((config) => {
    setErrorDialogConfig(config)
    setShowErrorDialog(true)
  }, [])
  
  // Load template on component mount or when template ID from URL changes
  useEffect(() => {
    const urlParams = window.location.pathname.split('/')
    const template_idFromUrl = urlParams[urlParams.length - 1]
    console.log('🔍 URL Params:', urlParams)
    console.log('🔍 Template ID from URL:', template_idFromUrl)

    // Check if we have a valid template ID from URL (not 'editor' or empty)
    if (template_idFromUrl && template_idFromUrl !== 'editor' && template_idFromUrl.length > 5) {
      console.log('🔍 Loading template from URL:', template_idFromUrl)
      loadTemplate(template_idFromUrl)
    } else if (projectId) {
      console.log('🔍 Loading template from projectId:', projectId)
      loadTemplate(projectId)
    } else {
      console.log('🔍 No template ID found, loading default template')
      loadTemplate(null)
    }
  }, [projectId, loadTemplate])

  // Ensure currentPageIndex is valid when template_content changes
  useEffect(() => {
    if (template_content?.pages && currentPageIndex >= template_content.pages.length) {
      setCurrentPageIndex(Math.max(0, template_content.pages.length - 1))
    }
  }, [template_content, currentPageIndex])

  

  // Create handleSave function using the external handler
  const handleSave = createHandleSave({
    setIsSaving,
    setHasUnsavedChanges,
    setIsSaved,
    template_content,
    template_id,
    navigate,
    projectAPI,
    templateAPI,
    showErrorDialog: handleShowErrorDialog
  })

  // All downloads now go through the workflow queue (wf.rajoffset.com general queue).
  // These handlers dispatch a queue job via exportService and let ExportProgress poll
  // the job until it completes / fails / is cancelled. The direct/synchronous
  // exportAPI path has been retired.
  const startQueuedExport = async (format, pageIndex, colorMode = 'RGB') => {
    if (!template_content?.pages || template_content.pages.length === 0) {
      alert('No content to export')
      return
    }
    const result = await exportService.startExport(
      template_content,
      format,
      pageIndex,
      colorMode,
      String(user?.id ?? 'default-user'), // userId
      template_id, // templateId
      String(user?.customerId ?? user?.customer_id ?? user?.id ?? ''), // customerId
      String(user?.id ?? '') // employeeId
    )
    if (!result.success) {
      alert(`Failed to start ${format.toUpperCase()} export: ${result.error}`)
    }
  }

  const handleDownload = async (format = 'pdf') => {
    // Current page export via the queue.
    await startQueuedExport(format, currentPageIndex)
  }

  const handleDownloadAll = async (format = 'pdf') => {
    // All pages export via the queue.
    await startQueuedExport(format, null)
  }

  // New endpoints per request — routed through the workflow queue.
  const handleDownloadCurrent = async (format = 'pdf') => {
    await startQueuedExport(format, currentPageIndex)
  }

  const handleDownloadFull = async (format = 'pdf') => {
    await startQueuedExport(format, null)
  }

  // TIF Download Functions
  const handleTifDownloadCurrent = () => {
    setTifDownloadType('current')
    setShowTifColorDialog(true)
  }

  const handleTifDownloadFull = () => {
    setTifDownloadType('full')
    setShowTifColorDialog(true)
  }

  const handleTifColorModeConfirm = async (colorMode) => {
    if (!template_content?.pages || template_content.pages.length === 0) {
      alert('No content to export')
      setShowTifColorDialog(false)
      return
    }

    // Close dialog first
    setShowTifColorDialog(false)

    // Start export with progress tracking
    const result = await exportService.startExport(
        template_content,
      'tif',
      tifDownloadType === 'current' ? currentPageIndex : null,
      colorMode,
      String(user?.id ?? 'default-user'), // userId
      template_id, // templateId
      String(user?.customerId ?? user?.customer_id ?? user?.id ?? ''), // customerId
      String(user?.id ?? '') // employeeId
    )

    if (!result.success) {
      alert('Failed to start TIF export: ' + result.error)
    }
  }

  // Universal Color Mode Download Functions
  const openColorModeDialog = (format, downloadType, handler) => {
    setColorModeDialogConfig({
      format: format.toUpperCase(),
      downloadType,
      handler
    })
    setShowColorModeDialog(true)
  }

  const handleColorModeConfirm = async (colorMode) => {
    const { format, downloadType, handler } = colorModeDialogConfig
    if (handler) {
      await handler(colorMode)
    }
    setShowColorModeDialog(false)
  }

  // Enhanced download handlers with color mode support
  const handleDownloadCurrentWithColorMode = (format) => {
    const handler = async (colorMode) => {
      if (!template_content?.pages || template_content.pages.length === 0) {
        alert('No content to export')
        return
      }

      // Start export with progress tracking (current page with color mode)
      const result = await exportService.startExport(
          template_content,
        format,
          currentPageIndex,
        colorMode,
        String(user?.id ?? 'default-user'), // userId
        template_id, // templateId
        String(user?.customerId ?? user?.customer_id ?? user?.id ?? ''), // customerId
        String(user?.id ?? '') // employeeId
      )

      if (!result.success) {
        alert('Failed to start export: ' + result.error)
      }
    }

    openColorModeDialog(format, 'current', handler)
  }

  const handleDownloadFullWithColorMode = (format) => {
    const handler = async (colorMode) => {
      if (!template_content?.pages || template_content.pages.length === 0) {
        alert('No content to export')
        return
      }

      // Start export with progress tracking (all pages with color mode)
      const result = await exportService.startExport(
          template_content,
        format,
        null, // null means export all pages
        colorMode,
        String(user?.id ?? 'default-user'), // userId
        template_id, // templateId
        String(user?.customerId ?? user?.customer_id ?? user?.id ?? ''), // customerId
        String(user?.id ?? '') // employeeId
      )

      if (!result.success) {
        alert('Failed to start export: ' + result.error)
      }
    }

    openColorModeDialog(format, 'full', handler)
  }

  // New video export function using queue system
  const handleVideoExport = async (exportParams = {}) => {
    if (!template_content?.pages || template_content.pages.length === 0) {
      alert('No content to export')
      return
    }

    setIsExportingVideo(true)

    try {
      // Start video export job with optional parameters
      const result = await videoExportService.startVideoExport(
        template_content,
        'user-' + Date.now(), // Simple user ID for now
        'mp4',
        template_content.id || template_id, // Template ID for identification
        'production', // Sample type for production exports
        exportParams // req_width, req_height, req_fps
      )

      if (result.success) {
        // Add job to local state
        const newJob = {
          id: result.queueId,
          status: 'pending',
          progress: 0,
          created_at: new Date().toISOString()
        }

        setVideoExportJobs(prev => [...prev, newJob])

        // Start polling for progress
        videoExportService.pollJobStatus(
          result.queueId,
          (progress, status, job) => {
            // Update job in state
            setVideoExportJobs(prev =>
              prev.map(j => j.id === result.queueId ? { ...j, ...job } : j)
            )
          }
        ).then((finalJob) => {
          console.log('Video export completed:', finalJob)
        }).catch((error) => {
          console.error('Video export failed:', error)
          // Update job with error
          setVideoExportJobs(prev =>
            prev.map(j => j.id === result.queueId ?
              { ...j, status: 'failed', error_message: error.message } : j
            )
          )
        })

      } else {
        alert('Failed to start video export: ' + result.error)
      }
    } catch (error) {
      console.error('Video export error:', error)
      alert('Failed to start video export')
    } finally {
      setIsExportingVideo(false)
    }
  }

  // Action menu handlers
  const isAdmin = user?.role === 'ADMIN'

  // Rename the current template. Persists to the server and updates local metadata + content.
  const handleRenameTemplate = async (newName) => {
    const name = (newName || '').trim()
    if (!name) return { success: false, error: 'Name cannot be empty' }
    if (!templateMetadata?.id) {
      // No saved template yet — update local content name so a later save persists it.
      settemplate_content(prev => prev ? { ...prev, name } : prev)
      return { success: true }
    }
    // Optimistic UI update.
    const prevName = templateMetadata.name
    setTemplateMetadata(prev => ({ ...prev, name }))
    settemplate_content(prev => prev ? { ...prev, name } : prev)
    try {
      await templateAPI.update(templateMetadata.id, { name })
      window.dispatchEvent(new CustomEvent('app:notify', {
        detail: { type: 'success', message: 'Template name updated.' }
      }))
      return { success: true }
    } catch (error) {
      console.error('Error renaming template:', error)
      // Revert on failure.
      setTemplateMetadata(prev => ({ ...prev, name: prevName }))
      settemplate_content(prev => prev ? { ...prev, name: prevName } : prev)
      window.dispatchEvent(new CustomEvent('app:notify', {
        detail: { type: 'error', message: 'Failed to update template name.' }
      }))
      return { success: false, error: error?.message || 'Update failed' }
    }
  }

  const handleMakePrivate = async () => {
    if (!templateMetadata?.id) return
    
    try {
      await templateAPI.update(templateMetadata.id, { is_public: false })
      setTemplateMetadata(prev => ({ ...prev, is_public: false }))
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'success', message: 'Template made private successfully!' } 
      }))
    } catch (error) {
      console.error('Error making template private:', error)
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'error', message: 'Failed to make template private' } 
      }))
    }
  }

  const handleMakePublic = async () => {
    if (!templateMetadata?.id) return
    
    try {
      await templateAPI.update(templateMetadata.id, { is_public: true })
      setTemplateMetadata(prev => ({ ...prev, is_public: true }))
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'success', message: 'Template made public successfully!' } 
      }))
    } catch (error) {
      console.error('Error making template public:', error)
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'error', message: 'Failed to make template public' } 
      }))
    }
  }

  const handleGenerateSample = async () => {
    if (!templateMetadata?.id) return
    
    try {
      await templateAPI.generateSample(templateMetadata.id)
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'success', message: 'Sample generated successfully!' } 
      }))
    } catch (error) {
      console.error('Error generating sample:', error)
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'error', message: 'Failed to generate sample' } 
      }))
    }
  }

  const handleApprove = async () => {
    if (!templateMetadata?.id) return
    
    const message = prompt('Enter approval message (optional):')
    if (message === null) return // User cancelled
    
    try {
      await templateAPI.updateStage(templateMetadata.id, { stage: 'approved', message: message || '' })
      setTemplateMetadata(prev => ({ ...prev, stage: 'approved' }))
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'success', message: 'Template approved successfully!' } 
      }))
    } catch (error) {
      console.error('Error approving template:', error)
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'error', message: 'Failed to approve template' } 
      }))
    }
  }

  const handleReject = async () => {
    if (!templateMetadata?.id) return
    
    const message = prompt('Enter rejection reason (required):')
    if (!message || message.trim() === '') {
      alert('Rejection reason is required')
      return
    }
    
    try {
      await templateAPI.updateStage(templateMetadata.id, { stage: 'rejected', message: message.trim() })
      setTemplateMetadata(prev => ({ ...prev, stage: 'rejected' }))
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'success', message: 'Template rejected successfully!' } 
      }))
    } catch (error) {
      console.error('Error rejecting template:', error)
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'error', message: 'Failed to reject template' } 
      }))
    }
  }

  const handleCloneAndOpen = async () => {
    if (!templateMetadata?.id) return
    
    try {
      const response = await templateAPI.clone(templateMetadata.id, {
        name: `${templateMetadata.name} (Copy)`,
        description: `Cloned from ${templateMetadata.name}`
      })
      
      if (response.data.success) {
        const clonedTemplateId = response.data.data.id
        // Navigate to the cloned template
        navigate(`/editor/${clonedTemplateId}`)
        window.dispatchEvent(new CustomEvent('app:notify', { 
          detail: { type: 'success', message: 'Template cloned and opened successfully!' } 
        }))
      }
    } catch (error) {
      console.error('Error cloning template:', error)
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'error', message: 'Failed to clone template' } 
      }))
    }
  }

  const handleTriggerSync = () => {
    // This feature is disabled for now
    window.dispatchEvent(new CustomEvent('app:notify', { 
      detail: { type: 'info', message: 'Trigger Sync feature coming soon!' } 
    }))
  }

  const handleGenerate9Samples = async () => {
    if (!templateMetadata?.id) return
    
    try {
      // Use the new queue-based bulk sample generation
      const response = await templateAPI.bulkGenerateSamples({
        template_ids: [templateMetadata.id] // Single template for now
      })
      
      if (response.data.success) {
        window.dispatchEvent(new CustomEvent('app:notify', { 
          detail: { type: 'success', message: 'Sample generation jobs created successfully! Processing in background...' } 
        }))
      } else {
        throw new Error(response.data.message || 'Failed to create sample generation jobs')
      }
    } catch (error) {
      console.error('Error generating samples:', error)
      window.dispatchEvent(new CustomEvent('app:notify', { 
        detail: { type: 'error', message: 'Failed to generate sample designs' } 
      }))
    }
  }

  // Handle video download
  const handleVideoDownload = (videoUrl, jobId) => {
    const a = document.createElement('a')
    a.href = videoUrl
    a.download = `video-export-${jobId}.mp4`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  // Handle job cancellation
  const handleJobCancel = async (jobId) => {
    const success = await videoExportService.cancelJob(jobId)
    if (success) {
      setVideoExportJobs(prev => prev.filter(j => j.id !== jobId))
    }
  }

  const handleJobDismiss = (jobId) => {
    setVideoExportJobs(prev => prev.filter(j => j.id !== jobId))
  }

  // Export progress handlers
  const handleExportDownload = (job) => {
    // Download is handled in the ExportProgress component
    console.log('Export download completed:', job);
  }

  const handleExportCancel = (jobId) => {
    const success = exportService.cancelJob(jobId);
    if (success) {
      setExportProgressJobs(prev => prev.filter(j => j.id !== jobId));
    }
  }

  const handleExportClose = (jobId) => {
    exportService.removeJob(jobId);
    setExportProgressJobs(prev => prev.filter(j => j.id !== jobId));
  }

  // Task 1: manually sync a single job from the workflow queue.
  const handleExportSync = async (jobId) => {
    await exportService.syncJob(jobId);
  }

  // Task 1: manually sync all non-terminal jobs.
  const handleExportSyncAll = async () => {
    await exportService.syncAllActive();
  }

  // Task 2: clear all queue records for the current user (server + local + panel).
  const handleExportClearQueue = async () => {
    const uid = String(user?.id ?? 'default-user');
    const result = await exportService.clearUserJobs(uid);
    if (result.success) {
      setExportProgressJobs([]);
    } else {
      alert('Failed to clear queue: ' + (result.error || 'Unknown error'));
    }
  }



  const copyLinkToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
      alert('Link copied to clipboard!')
    } catch (error) {
      console.error('Failed to copy:', error)
      alert('Failed to copy link')
    }
  }

  // Convert a text element into an SVG graphic (keeps position/size/rotation). Replaces the element.
  const convertTextToSVGGraphic = (elementId) => {
    const page = template_content?.pages?.[currentPageIndex]
    if (!page) return
    const item = page.items?.find(it => it.id === elementId)
    if (!item || item.type !== 'text') return

    // Get translated content (with placeholders replaced)
    const translatedContent = item.richText?.content 
      ? getTranslatedContent(item, true)
      : getTranslatedContent(item)
    const content = translatedContent
    const spans = Array.isArray(item.richText?.spans) ? [...item.richText.spans].sort((a, b) => a.start - b.start) : []

    // Build styled segments in order
    const segments = []
    let cursor = 0
    spans.forEach(({ start, end, styles }) => {
      if (start > cursor) segments.push({ text: content.slice(cursor, start), styles: {} })
      segments.push({ text: content.slice(start, end), styles: styles || {} })
      cursor = end
    })
    if (cursor < content.length) segments.push({ text: content.slice(cursor), styles: {} })

    // Split into lines while preserving styles
    const lines = [[]]
    segments.forEach(seg => {
      const parts = seg.text.split('\n')
      parts.forEach((p, idx) => {
        if (idx > 0) lines.push([])
        if (p.length) lines[lines.length - 1].push({ text: p, styles: seg.styles })
      })
    })

    // Helper to css string
    const cssStr = (obj = {}) => Object.entries(obj)
      .filter(([_, v]) => v != null && v !== '')
      .map(([k, v]) => `${k.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}:${v}`)
      .join(';')

    const fontSize = item.fontSize || 16
    const lineHeightPx = (item.lineHeight ? Number(item.lineHeight) : 1.2) * fontSize
    const textAnchor = item.textAlign === 'right' ? 'end' : (item.textAlign === 'center' ? 'middle' : 'start')

    // Generate SVG text with tspans
    let textInner = ''
    lines.forEach((segs, i) => {
      const dy = i === 0 ? 0 : lineHeightPx
      let lineHtml = ''
      segs.forEach(({ text, styles }) => {
        const s = { ...styles }
        if (s.color) { s.fill = s.color; delete s.color }
        const allowed = {
          fill: s.fill,
          fontWeight: s.fontWeight || item.fontWeight,
          fontStyle: s.fontStyle || item.fontStyle,
          letterSpacing: s.letterSpacing,
          wordSpacing: s.wordSpacing,
          textDecoration: s.textDecoration,
          fontFamily: s.fontFamily,
          fontSize: s.fontSize
        }
        const styleStr = cssStr(allowed)
        const esc = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        lineHtml += styleStr ? `<tspan style="${styleStr}">${esc}</tspan>` : esc
      })
      textInner += `<tspan x="0" dy="${dy}">${lineHtml}</tspan>`
    })

    const svgRootId = `svg-${elementId}`
    // Create SVG with behind-fill stroke effect
    let svgContent = '';
    const textX = item.textAlign === 'center' ? item.width / 2 : (item.textAlign === 'right' ? item.width : 0);

    // Add stroke behind fill if specified (with rounded corners)
    if (item.strokeWidth > 0 && item.stroke) {
      // Create multiple stroke layers for behind-fill effect with blur for rounded corners
      for (let angle = 0; angle < 360; angle += 30) {
        const radian = (angle * Math.PI) / 180;
        const dx = Math.cos(radian) * item.strokeWidth;
        const dy = Math.sin(radian) * item.strokeWidth;
        svgContent += `<text xml:space="preserve" x="${textX + dx}" y="${dy}" dominant-baseline="text-before-edge" text-anchor="${textAnchor}" ` +
          `font-family="${item.fontFamily || 'Arial'}" font-size="${fontSize}" fill="${item.stroke}" ` +
          `stroke-linejoin="${item.strokeLineJoin || 'miter'}" stroke-linecap="${item.strokeLineCap || 'butt'}" ` +
          `filter="blur(${item.strokeWidth * 0.3}px)">` +
          `${textInner}</text>`;
      }
    }

    // Add main text (fill) on top
    svgContent += `<text xml:space="preserve" x="${textX}" y="0" dominant-baseline="text-before-edge" text-anchor="${textAnchor}" ` +
      `font-family="${item.fontFamily || 'Arial'}" font-size="${fontSize}" ` +
      `stroke-linejoin="${item.strokeLineJoin || 'miter'}" stroke-linecap="${item.strokeLineCap || 'butt'}">` +
      `${textInner}</text>`;

    const svg = `<?xml version="1.0" encoding="UTF-8"?>\n` +
      `<svg xmlns="http://www.w3.org/2000/svg" id="${svgRootId}" width="${item.width}" height="${item.height}" viewBox="0 0 ${item.width} ${item.height}">` +
      svgContent + `</svg>`

    // Normalize and inject override styles so editor fill/stroke control applies; scope by id
    const processed = injectOverrideStyleScoped(
      normalizeSvgColors(svg),
      svgRootId,
      { fill: (item.color || item.fill || 'currentColor'), stroke: (item.stroke || 'none'), strokeWidth: (item.strokeWidth || 0) },
      { important: true }
    )

    const newItem = {
      ...item,
      type: 'svg-graphic',
      svgData: processed,
      originalSvgData: svg,
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((p, idx) => idx === currentPageIndex ? {
        ...p,
        items: p.items.map(it => it.id === elementId ? newItem : it)
      } : p)
    }))
    setSelectedElement(elementId)
    markAsUnsaved()
  }

  // Expose editor actions for cross-component buttons
  useEffect(() => {
    window.editorActions = window.editorActions || {}
    window.editorActions.convertTextToSVGGraphic = convertTextToSVGGraphic
    return () => {
      if (window.editorActions) {
        delete window.editorActions.convertTextToSVGGraphic
      }
    }
  }, [template_content, currentPageIndex])


  const shareViaWhatsApp = () => {
    const shareUrl = `${window.location.origin}/shared/${template_content.id || 'design'}`
    const message = `Check out my design: ${shareUrl}`
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank')
  }

  // Helper function to get maximum layer number
  const getMaxLayer = () => {
    return Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
  }

  // Import handlers
  const handleImportPDF = () => {
    console.log('🔴 Import PDF clicked')
    // Create file input for PDF
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.pdf'
    input.onchange = async (e) => {
      const file = e.target.files[0]
      if (file) {
        console.log('📄 PDF file selected:', file.name)

        // Show progress dialog
        setImportProgress({
          type: 'pdf',
          fileName: file.name,
          status: 'processing',
          progress: 0,
          message: 'Uploading and processing PDF file...'
        })
        setShowImportProgress(true)

        try {
          // Create FormData for file upload
          const formData = new FormData()
          formData.append('file', file)

          // Update progress
          setImportProgress(prev => ({
            ...prev,
            progress: 25,
            message: 'Extracting content from PDF pages...'
          }))

          // Call import API using the proper service with extended timeout
          const response = await importAPI.pdf(formData)
          const result = response.data
          console.log('✅ PDF import result:', result)

          // Update progress to completion
          setImportProgress(prev => ({
            ...prev,
            progress: 100,
            status: 'success',
            message: `Successfully processed ${result.total_pages || 1} page(s) with ${result.pages?.reduce((sum, page) => sum + (page.elements?.length || 0), 0) || 0} elements.`
          }))

          // Auto-close after 2 seconds and show results
          setTimeout(() => {
            setShowImportProgress(false)
            showImportResults(result)
          }, 2000)

        } catch (error) {
          console.error('❌ PDF import failed:', error)

          // Show error in progress dialog
          setImportProgress(prev => ({
            ...prev,
            status: 'error',
            message: error.response?.data?.detail || error.message || 'An unexpected error occurred during PDF import.'
          }))
        }
      }
    }
    input.click()
  }

  const handleImportPSD = () => {
    console.log('🔵 Import PSD clicked')
    // Create file input for PSD
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.psd'
    input.onchange = async (e) => {
      const file = e.target.files[0]
      if (file) {
        console.log('🎨 PSD file selected:', file.name)

        // Show progress dialog
        setImportProgress({
          type: 'psd',
          fileName: file.name,
          status: 'processing',
          progress: 0,
          message: 'Uploading and processing PSD file...'
        })
        setShowImportProgress(true)

        try {
          // Create FormData for file upload
          const formData = new FormData()
          formData.append('file', file)

          // Update progress
          setImportProgress(prev => ({
            ...prev,
            progress: 30,
            message: 'Extracting layers and assets from PSD...'
          }))

          // Call import API using the proper service with extended timeout
          const response = await importAPI.psd(formData)
          const result = response.data
          console.log('✅ PSD import result:', result)

          // Update progress to completion
          setImportProgress(prev => ({
            ...prev,
            progress: 100,
            status: 'success',
            message: `Successfully processed PSD with ${result.layers?.length || 0} layers.`
          }))

          // Auto-close after 2 seconds and show results
          setTimeout(() => {
            setShowImportProgress(false)
            showImportResults(result)
          }, 2000)

        } catch (error) {
          console.error('❌ PSD import failed:', error)

          // Show error in progress dialog
          setImportProgress(prev => ({
            ...prev,
            status: 'error',
            message: error.response?.data?.detail || error.message || 'An unexpected error occurred during PSD import.'
          }))
        }
      }
    }
    input.click()
  }

  const handleImportPowerPoint = () => {
    console.log('🟠 Import PowerPoint clicked')
    // Create file input for PowerPoint
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.ppt,.pptx'
    input.onchange = async (e) => {
      const file = e.target.files[0]
      if (file) {
        console.log('📊 PowerPoint file selected:', file.name)

        // Show progress dialog
        setImportProgress({
          type: 'powerpoint',
          fileName: file.name,
          status: 'processing',
          progress: 0,
          message: 'Uploading and processing PowerPoint file...'
        })
        setShowImportProgress(true)

        try {
          // Create FormData for file upload
          const formData = new FormData()
          formData.append('file', file)

          // Update progress
          setImportProgress(prev => ({
            ...prev,
            progress: 25,
            message: 'Extracting slides and content from PowerPoint...'
          }))

          // Call import API using the proper service with extended timeout
          const response = await importAPI.powerpoint(formData)
          const result = response.data
          console.log('✅ PowerPoint import result:', result)

          // Update progress to completion
          setImportProgress(prev => ({
            ...prev,
            progress: 100,
            status: 'success',
            message: `Successfully processed ${result.slides?.length || 1} slide(s) from PowerPoint.`
          }))

          // Auto-close after 2 seconds and show results
          setTimeout(() => {
            setShowImportProgress(false)
            showImportResults(result)
          }, 2000)

        } catch (error) {
          console.error('❌ PowerPoint import failed:', error)

          // Show error in progress dialog
          setImportProgress(prev => ({
            ...prev,
            status: 'error',
            message: error.response?.data?.detail || error.message || 'An unexpected error occurred during PowerPoint import.'
          }))
        }
      }
    }
    input.click()
  }

  const handleImportCDR = () => {
    console.log('🟣 Import CDR clicked')
    // Create file input for CDR
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.cdr'
    input.onchange = async (e) => {
      const file = e.target.files[0]
      if (file) {
        console.log('🎨 CDR file selected:', file.name)

        // Show progress dialog
        setImportProgress({
          type: 'cdr',
          fileName: file.name,
          status: 'processing',
          progress: 0,
          message: 'Uploading and processing CorelDRAW file...'
        })
        setShowImportProgress(true)

        try {
          // Create FormData for file upload
          const formData = new FormData()
          formData.append('file', file)

          // Update progress
          setImportProgress(prev => ({
            ...prev,
            progress: 30,
            message: 'Converting CDR to SVG format...'
          }))

          // Call import API using the proper service with extended timeout
          const response = await importAPI.cdr(formData)
          const result = response.data
          console.log('✅ CDR import result:', result)

          // Update progress to completion
          setImportProgress(prev => ({
            ...prev,
            progress: 100,
            status: 'success',
            message: `Successfully converted CorelDRAW file to SVG format.`
          }))

          // Auto-close after 2 seconds and show results
          setTimeout(() => {
            setShowImportProgress(false)
            showImportResults(result)
          }, 2000)

        } catch (error) {
          console.error('❌ CDR import failed:', error)

          // Show error in progress dialog
          setImportProgress(prev => ({
            ...prev,
            status: 'error',
            message: error.response?.data?.detail || error.message || 'An unexpected error occurred during CDR import.'
          }))
        }
      }
    }
    input.click()
  }

  const handleImportLegacyPlatform = () => {
    console.log('🔄 Import Legacy Platform clicked')

    // Create a dialog to paste JSON
    const jsonInput = prompt(
      'Paste your Legacy Platform JSON here:\n\n(This will convert your old system format to the new system)',
      ''
    )

    if (!jsonInput || jsonInput.trim() === '') {
      return
    }

    try {
      // Parse the legacy JSON
      const legacyData = JSON.parse(jsonInput.trim())
      console.log('📄 Legacy data parsed:', legacyData)

      // Convert legacy format to new format
      convertLegacyToNewFormat(legacyData)

    } catch (error) {
      console.error('❌ Failed to parse legacy JSON:', error)
      alert('Invalid JSON format. Please check your JSON and try again.\n\nError: ' + error.message)
    }
  }

  // Convert legacy platform JSON to new system format
  const convertLegacyToNewFormat = (legacyData) => {
    try {
      console.log('🔄 Converting legacy data to new format...')

      if (!legacyData.pages || !Array.isArray(legacyData.pages)) {
        throw new Error('Invalid legacy format: pages array not found')
      }

      // Process each page from legacy format
      const convertedPages = legacyData.pages.map((legacyPage, pageIndex) => {
        const pageConfig = legacyPage.pageConfig || {}
        const legacyItems = legacyPage.items || []

        // Convert legacy items to new format
        const newItems = []
        let backgroundProcessed = false

        // First, handle background URL if it exists
        if (pageConfig.backgroundUrl && !backgroundProcessed) {
          newItems.push({
            id: `bg_${Date.now()}`,
            type: 'image',
            x: 0,
            y: 0,
            width: pageConfig.width || 1240,
            height: pageConfig.height || 1754,
            layer: 0,
            src: pageConfig.backgroundUrl,
            opacity: 1,
            isLocked: false,
            import_type: 'legacy_background'
          })
          backgroundProcessed = true
        }

        // Convert legacy items
        legacyItems.forEach((legacyItem, index) => {
          const itemConfig = legacyItem.itemConfig || {}
          let newItem = null

          if (legacyItem.itemType === 'SIMPLE_IMAGE') {
            newItem = {
              id: `legacy_img_${Date.now()}_${index}`,
              type: 'image',
              x: legacyItem.positionX || itemConfig.Position_X || 0,
              y: legacyItem.positionY || itemConfig.Position_Y || 0,
              width: legacyItem.width || itemConfig.Width || 100,
              height: legacyItem.height || itemConfig.Height || 100,
              layer: (legacyItem.layer || itemConfig.layer || 0) + (backgroundProcessed ? 1 : 0),
              src: itemConfig.FieldValue || '',
              opacity: 1,
              isLocked: legacyItem.isLocked || false,
              import_type: 'legacy_image'
            }
          } else if (legacyItem.itemType === 'SIMPLE_TEXT') {
            // Handle text fill color
            let textColor = '#000000'
            if (itemConfig.Fill) {
              if (itemConfig.Fill.Type === 'Uniform') {
                textColor = itemConfig.Fill.UniformColor || '#000000'
              } else if (itemConfig.Fill.Type === 'Fountain' && itemConfig.Fill.Fountain?.Colors?.length > 0) {
                // Use first gradient color for simplicity
                textColor = itemConfig.Fill.Fountain.Colors[0].Color || '#000000'
              }
            }

            newItem = {
              id: `legacy_text_${Date.now()}_${index}`,
              type: 'text',
              x: legacyItem.positionX || itemConfig.Position_X || 0,
              y: legacyItem.positionY || itemConfig.Position_Y || 0,
              width: legacyItem.width || itemConfig.Width || 200,
              height: legacyItem.height || itemConfig.Height || 50,
              layer: (legacyItem.layer || itemConfig.layer || 0) + (backgroundProcessed ? 1 : 0),
              content: itemConfig.ItemValue || itemConfig.FieldValue || 'Text',
              fontSize: itemConfig.FontSize || 16,
              fontFamily: itemConfig.FontName || 'Arial',
              color: textColor,
              textAlign: itemConfig.TextAlign || 'left',
              fontWeight: itemConfig.FontWeight || 'normal',
              opacity: 1,
              isLocked: legacyItem.isLocked || false,
              textEffect: null,
              import_type: 'legacy_text'
            }
          }

          if (newItem) {
            newItems.push(newItem)
          }
        })

        return {
          id: `page_${pageIndex + 1}`,
          name: pageConfig.pageName || `Page ${pageIndex + 1}`,
          width: pageConfig.width || 1240,
          height: pageConfig.height || 1754,
          items: newItems
        }
      })

      // Add converted pages as new pages instead of replacing
      const updatedPages = [...template_content.pages]

      convertedPages.forEach((convertedPage, index) => {
        // Create new page with proper configuration
        const newPage = {
          id: `legacy_page_${Date.now()}_${index}`,
          name: convertedPage.name,
          page_config: {
            width: convertedPage.width,
            height: convertedPage.height,
            background_color: '#ffffff'
          },
          items: convertedPage.items
        }

        updatedPages.push(newPage)
      })

      const newtemplate_content = {
        ...template_content,
        pages: updatedPages
      }

      settemplate_content(newtemplate_content)

      // Switch to the first imported page
      if (convertedPages.length > 0) {
        setCurrentPageIndex(updatedPages.length - convertedPages.length)
      }

      // Show success message
      const totalItems = convertedPages.reduce((sum, page) => sum + page.items.length, 0)
      alert(`✅ Legacy Platform import successful!\n\nConverted:\n• ${convertedPages.length} new page(s) added\n• ${totalItems} item(s) imported\n• Page dimensions: ${convertedPages[0]?.width}x${convertedPages[0]?.height}\n\nYour old design has been imported as new pages.`)

      console.log('✅ Legacy conversion completed:', newtemplate_content)

    } catch (error) {
      console.error('❌ Legacy conversion failed:', error)
      alert(`Failed to convert legacy data: ${error.message}`)
    }
  }

  // Add PSD layers to current design
  const addPSDToDesign = (importResult) => {
    console.log('🎨 PSD import result received:', importResult)

    if (!importResult) {
      console.warn('⚠️ No PSD import result')
      alert('No PSD import result received.')
      return
    }

    // Check for layers in different possible locations
    let layers = importResult.layers || importResult.psd_layers || []

    if (!layers || layers.length === 0) {
      console.warn('⚠️ No PSD layers found in result:', importResult)
      alert('No visible layers found in PSD file. The file may be corrupted or have no visible content.')
      return
    }

    try {
      const newElements = []
      let yOffset = 50 // Starting Y position

      // Process each visible layer
      layers.forEach((layer, index) => {
        console.log(`🔍 Processing layer ${index}:`, layer)

        if (layer.visible === false) return // Skip invisible layers

        let newElement = null

        if (layer.layer_type === 'pixel' && layer.image_url) {
          // Create image element for pixel layers
          newElement = {
            id: `psd_layer_${Date.now()}_${index}`,
            type: 'image',
            x: layer.bbox?.[0] || 50,
            y: (layer.bbox?.[1] || yOffset) + yOffset,
            width: layer.bbox?.[2] - layer.bbox?.[0] || 200,
            height: layer.bbox?.[3] - layer.bbox?.[1] || 200,
            rotation: 0,
            opacity: (layer.opacity || 255) / 255,
            layer: Math.max(0, ...template_content.pages[currentPageIndex]?.items?.map(item => item.layer || 0) || [0]) + index + 1,
            src: layer.image_url,
            original_width: layer.width || 200,
            original_height: layer.height || 200,
            import_type: 'psd',
            layer_name: layer.name || `Layer ${index + 1}`
          }
        } else if (layer.layer_type === 'text' && layer.text_content) {
          // Create text element for text layers
          newElement = {
            id: `psd_text_${Date.now()}_${index}`,
            type: 'text',
            x: layer.bbox?.[0] || 50,
            y: (layer.bbox?.[1] || yOffset) + yOffset,
            width: layer.bbox?.[2] - layer.bbox?.[0] || 200,
            height: layer.bbox?.[3] - layer.bbox?.[1] || 50,
            rotation: 0,
            opacity: (layer.opacity || 255) / 255,
            layer: Math.max(0, ...template_content.pages[currentPageIndex]?.items?.map(item => item.layer || 0) || [0]) + index + 1,
            content: layer.text_content,
            fontSize: layer.font_size || 16,
            fontFamily: layer.font_family || 'Arial',
            color: layer.color || '#000000',
            textEffect: null,
            import_type: 'psd',
            layer_name: layer.name || `Text Layer ${index + 1}`
          }
        } else if (layer.layer_type === 'group' && layer.image_url) {
          // Group layers with image content (common in PSD exports)
          newElement = {
            id: `psd_group_${Date.now()}_${index}`,
            type: 'image',
            x: layer.bbox?.[0] || 50,
            y: layer.bbox?.[1] || (yOffset + index * 20),
            width: Math.abs((layer.bbox?.[2] || 200) - (layer.bbox?.[0] || 0)) || 200,
            height: Math.abs((layer.bbox?.[3] || 200) - (layer.bbox?.[1] || 0)) || 200,
            rotation: 0,
            opacity: (layer.opacity !== undefined ? layer.opacity : 255) / 255,
            layer: Math.max(0, ...template_content.pages[currentPageIndex]?.items?.map(item => item.layer || 0) || [0]) + index + 1,
            src: layer.image_url,
            original_width: layer.width || 200,
            original_height: layer.height || 200,
            import_type: 'psd',
            layer_name: layer.name || `Group ${index + 1}`
          }
        } else if (layer.layer_type === 'group') {
          // Group layers without direct image content
          console.log(`📁 Group layer "${layer.name}" - no direct image content`)
          return
        } else if (layer.image_url) {
          // Fallback: any layer with an image URL
          newElement = {
            id: `psd_layer_${Date.now()}_${index}`,
            type: 'image',
            x: layer.bbox?.[0] || 50,
            y: layer.bbox?.[1] || (yOffset + index * 20),
            width: Math.abs((layer.bbox?.[2] || 200) - (layer.bbox?.[0] || 0)) || 200,
            height: Math.abs((layer.bbox?.[3] || 200) - (layer.bbox?.[1] || 0)) || 200,
            rotation: 0,
            opacity: (layer.opacity !== undefined ? layer.opacity : 255) / 255,
            layer: Math.max(0, ...template_content.pages[currentPageIndex]?.items?.map(item => item.layer || 0) || [0]) + index + 1,
            src: layer.image_url,
            original_width: layer.width || 200,
            original_height: layer.height || 200,
            import_type: 'psd',
            layer_name: layer.name || `Layer ${index + 1}`
          }
        }

        if (newElement) {
          newElements.push(newElement)
          yOffset += 20 // Offset for next layer
        }
      })

      if (newElements.length === 0) {
        alert('No visible layers found to import from PSD file.')
        return
      }

      // Add all elements to current page
      const updatedPages = [...template_content.pages]
      const currentPage = updatedPages[currentPageIndex]

      if (!currentPage.items) {
        currentPage.items = []
      }

      currentPage.items.push(...newElements)

      // Update template content
      const updatedContent = {
        ...template_content,
        pages: updatedPages
      }

      settemplate_content(updatedContent)
      setHasUnsavedChanges(true)

      // Select the first imported element
      if (newElements.length > 0) {
        setSelectedElement(newElements[0].id)
      }

      console.log(`✅ Added ${newElements.length} PSD layers to design:`, newElements)

    } catch (error) {
      console.error('❌ Error adding PSD to design:', error)
      alert('Error adding PSD layers to design. Please try again.')
    }
  }

  // Show import results dialog
  const showImportResults = (result) => {
    console.log('📋 Showing import results:', result)

    if (result.import_type === 'pdf' && result.pages) {
      const totalElements = result.pages.reduce((sum, page) => sum + (page.elements?.length || 0), 0)
      const message = `PDF imported successfully!\n\nFile: ${result.filename}\nPages: ${result.total_pages}\nTotal Elements: ${totalElements}\n\nClick OK to add all elements from the first page to your design.`

      if (window.confirm(message)) {
        addPDFPageToDesign(result.pages[0], result)
      }
    } else if (result.import_type === 'cdr' && result.svg_content) {
      const message = `CorelDRAW file imported successfully!\n\nFile: ${result.filename}\nFormat: SVG Vector Graphics\nDimensions: ${result.dimensions?.width}x${result.dimensions?.height}\n\nClick OK to add the converted SVG to your design.`

      if (window.confirm(message)) {
        addCDRToDesign(result)
      }
    } else if (result.import_type === 'psd' && result.layers) {
      const totalLayers = result.layers?.length || 0
      const visibleLayers = result.layers?.filter(layer => layer.visible !== false)?.length || 0
      const message = `PSD file imported successfully!\n\nFile: ${result.filename}\nDimensions: ${result.psd_info?.width}x${result.psd_info?.height}\nTotal Layers: ${totalLayers}\nVisible Layers: ${visibleLayers}\n\nClick OK to add all visible layers to your design.`

      if (window.confirm(message)) {
        // eslint-disable-next-line no-undef
        addPSDToDesign(result)
      }
    } else {
      alert(`Import completed: ${result.message || 'Success'}`)
    }
  }

  // Add CDR SVG to current design
  const addCDRToDesign = (importResult) => {
    if (!importResult || !importResult.svg_content) {
      console.warn('⚠️ No CDR SVG content to import')
      return
    }

    try {
      // Create a new SVG element for the current page
      const newElement = {
        id: `cdr_import_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        type: 'svg',
        x: 50, // Position on page
        y: 50,
        width: Math.min(importResult.dimensions?.width || 200, 400), // Limit initial size
        height: Math.min(importResult.dimensions?.height || 200, 400),
        rotation: 0,
        opacity: 1,
        layer: Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0]) + 1,
        svg_content: importResult.svg_content,
        svg_url: importResult.svg_url,
        original_url: importResult.original_url,
        import_id: importResult.import_id,
        import_type: 'cdr',
        viewBox: importResult.dimensions?.viewBox || '0 0 100 100',
        preserveAspectRatio: 'xMidYMid meet'
      }

      // Add to current page
      const updatedPages = [...template_content.pages]
      const pageToUpdate = updatedPages[currentPageIndex]

      if (!pageToUpdate.items) {
        pageToUpdate.items = []
      }

      pageToUpdate.items.push(newElement)

      // Update template content
      const updatedContent = {
        ...template_content,
        pages: updatedPages
      }

      settemplate_content(updatedContent)
      setHasUnsavedChanges(true)

      // Select the new element
      setSelectedElement(newElement.id)

      console.log('✅ CDR SVG added to design:', newElement)

    } catch (error) {
      console.error('❌ Error adding CDR to design:', error)
      alert('Error adding CorelDRAW file to design. Please try again.')
    }
  }



  // Add PDF page with all elements to current design
  const addPDFPageToDesign = (pageData, importResult) => {
    if (!pageData || !pageData.elements) {
      console.warn('⚠️ No page data or elements to import')
      return
    }

    console.log(`🎨 Adding ${pageData.elements.length} elements from PDF page to design`)

    const newItems = []
    let currentLayer = getMaxLayer() + 1

    // Add page background if available
    if (pageData.background_image_url) {
      newItems.push({
        id: `pdf-bg-${Date.now()}`,
        type: 'image',
        src: pageData.background_image_url,
        x: 0,
        y: 0,
        width: Math.min(pageData.width, 800),
        height: Math.min(pageData.height, 600),
        rotation: 0,
        opacity: 0.8, // Slightly transparent background
        layer: currentLayer++,
        metadata: {
          imported_from: 'pdf',
          original_filename: importResult.filename,
          page_number: pageData.page_number,
          element_type: 'background'
        }
      })
    }

    // Add all extracted elements
    pageData.elements.forEach((element, index) => {
      try {
        let newItem = null

        if (element.type === 'text') {
          newItem = {
            id: `pdf-text-${Date.now()}-${index}`,
            type: 'text',
            text: element.content,
            x: element.x || 0,
            y: element.y || 0,
            width: element.width || 200,
            height: element.height || 30,
            fontSize: element.font_size || 12,
            fontFamily: element.font_family || 'Arial',
            color: element.color || '#000000',
            rotation: 0,
            opacity: 1,
            textEffect: null,
            layer: currentLayer++,
            metadata: {
              imported_from: 'pdf',
              original_filename: importResult.filename,
              page_number: pageData.page_number,
              element_id: element.element_id
            }
          }
        } else if (element.type === 'image' && element.url) {
          newItem = {
            id: `pdf-img-${Date.now()}-${index}`,
            type: 'image',
            src: element.url,
            x: element.x || 0,
            y: element.y || 0,
            width: element.width || 100,
            height: element.height || 100,
            rotation: 0,
            opacity: 1,
            layer: currentLayer++,
            metadata: {
              imported_from: 'pdf',
              original_filename: importResult.filename,
              page_number: pageData.page_number,
              element_id: element.element_id,
              original_width: element.original_width,
              original_height: element.original_height
            }
          }
        } else if (element.type === 'shape' && element.url) {
          newItem = {
            id: `pdf-shape-${Date.now()}-${index}`,
            type: 'image', // Treat SVG shapes as images for now
            src: element.url,
            x: element.x || 0,
            y: element.y || 0,
            width: element.width || 100,
            height: element.height || 100,
            rotation: 0,
            opacity: 1,
            layer: currentLayer++,
            metadata: {
              imported_from: 'pdf',
              original_filename: importResult.filename,
              page_number: pageData.page_number,
              element_id: element.element_id,
              element_type: 'vector_shape'
            }
          }
        }

        if (newItem) {
          newItems.push(newItem)
        }
      } catch (error) {
        console.warn(`⚠️ Could not import element ${index}:`, error)
      }
    })

    // Add all items to current page
    if (newItems.length > 0) {
      const updatedTemplate = {
        ...template_content,
        pages: template_content.pages.map((page, idx) =>
          idx === currentPageIndex
            ? { ...page, items: [...(page.items || []), ...newItems] }
            : page
        )
      }

      settemplate_content(updatedTemplate)
      setHasUnsavedChanges(true)
      console.log(`✅ Added ${newItems.length} elements from PDF to design`)
    } else {
      console.warn('⚠️ No elements could be imported from PDF')
    }
  }

  // Measure the natural pixel size a text item needs to show its content at the
  // item's exact fontSize. In WRAP mode the measurement keeps the current width
  // (text wraps) and reports the needed height; in NO-WRAP mode it reports the
  // single-line width + height. Returns { width, height } including stroke/shadow
  // padding. Pure DOM measurement — no state writes.
  const measureTextBox = useCallback((item) => {
    try {
      const fontSize = item.fontSize || 16
      const fontFamily = item.fontFamily || 'Arial'
      const fontWeight = item.fontWeight || 'normal'
      const fontStyle = item.fontStyle || 'normal'
      const lineHeight = item.lineHeight || 1.2
      const letterSpacing = item.letterSpacing || 0
      const wordSpacing = item.wordSpacing || 0
      const wrap = item.wrap !== false
      const textContent = item.content || item.richText?.content || ''

      const tempDiv = document.createElement('div')
      tempDiv.style.position = 'absolute'
      tempDiv.style.visibility = 'hidden'
      tempDiv.style.left = '-99999px'
      tempDiv.style.top = '0'
      tempDiv.style.overflow = 'visible'
      tempDiv.style.display = 'inline-block'
      tempDiv.style.boxSizing = 'content-box'
      tempDiv.style.padding = '0'
      tempDiv.style.margin = '0'
      tempDiv.style.border = 'none'
      tempDiv.style.fontSize = `${fontSize}px`
      tempDiv.style.fontFamily = `"${fontFamily}", sans-serif`
      tempDiv.style.fontWeight = fontWeight
      tempDiv.style.fontStyle = fontStyle
      tempDiv.style.lineHeight = String(lineHeight)
      tempDiv.style.letterSpacing = `${letterSpacing}px`
      tempDiv.style.wordSpacing = `${wordSpacing}px`
      if (wrap) {
        // Wrap: constrain to the item's current content width so we measure the
        // wrapped height. Keep the width the user defined; grow height.
        const innerW = Math.max(1, (item.width || 100))
        tempDiv.style.width = `${innerW}px`
        tempDiv.style.whiteSpace = 'pre-wrap'
        tempDiv.style.wordWrap = 'break-word'
        tempDiv.style.overflowWrap = 'break-word'
      } else {
        // No-wrap: single line; width grows to the text.
        tempDiv.style.width = 'auto'
        tempDiv.style.maxWidth = 'none'
        tempDiv.style.whiteSpace = 'nowrap'
      }
      tempDiv.textContent = textContent || ' '
      document.body.appendChild(tempDiv)
      void tempDiv.offsetHeight
      const rect = tempDiv.getBoundingClientRect()
      let measuredWidth = Math.max(rect.width, tempDiv.scrollWidth)
      let measuredHeight = Math.max(rect.height, tempDiv.scrollHeight)
      document.body.removeChild(tempDiv)

      if (!measuredHeight || measuredHeight < fontSize) {
        const lines = (textContent || '').split('\n')
        measuredHeight = fontSize * lineHeight * Math.max(1, lines.length)
      }
      if (!measuredWidth) measuredWidth = fontSize

      // Stroke expands the glyph outline outward on both sides.
      const strokeWidth = item.strokeWidth || 0
      if (strokeWidth > 0) {
        measuredWidth += strokeWidth * 2
        measuredHeight += strokeWidth * 2
      }
      return {
        width: Math.max(1, Math.ceil(measuredWidth)),
        height: Math.max(1, Math.ceil(measuredHeight)),
      }
    } catch (e) {
      return null
    }
  }, [])

  // Grow a text item's box so it contains its text at the exact fontSize. Only
  // grows (never shrinks) so a user's larger manual box is preserved. In wrap
  // mode the width is kept and the height grows; in no-wrap mode both grow.
  const autoGrowTextBox = useCallback((elementId) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) => {
        if (index !== currentPageIndex) return page
        return {
          ...page,
          items: (page.items || []).map((item) => {
            if (item.id !== elementId || item.type !== 'text') return item
            const m = measureTextBox(item)
            if (!m) return item
            const wrap = item.wrap !== false
            const curW = item.width || 0
            const curH = item.height || 0
            // Wrap: keep width (text wraps), grow height. No-wrap: grow both.
            const nextW = wrap ? curW : Math.max(curW, m.width)
            const nextH = Math.max(curH, m.height)
            if (nextW === curW && nextH === curH) return item
            return { ...item, width: nextW, height: nextH }
          }),
        }
      }),
    }))
  }, [currentPageIndex, measureTextBox])

  const updateElementProperty = (elementId, property, value) => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: page.items.map(item => {
              // Check if this is a PowerClip container with content to update
              if (item.isPowerClipContainer && item.powerClipContents) {
                const updatedContents = item.powerClipContents.map(content =>
                  content.id === elementId
                    ? { ...content, [property]: value }
                    : content
                )
                // If any content was updated, return updated container
                if (updatedContents.some((content, index) => content !== item.powerClipContents[index])) {
                  return { ...item, powerClipContents: updatedContents }
                }
              }

              // Group handling
              if (item.type === 'group' && Array.isArray(item.children)) {
                // Targeting the group container itself.
                if (item.id === elementId) {
                  // Fan effect-like properties out to every child so one
                  // animation/effect applies to the whole group at once. Other
                  // properties (position/size/time/etc.) stay on the container.
                  if (GROUP_FANOUT_PROPERTIES.includes(property)) {
                    return applyPropertyToGroupChildren({ ...item, [property]: value }, property, value)
                  }
                  return { ...item, [property]: value }
                }
                // Targeting a specific child inside the group (editing mode).
                if (item.children.some(child => child.id === elementId)) {
                  return {
                    ...item,
                    children: item.children.map(child =>
                      child.id === elementId ? { ...child, [property]: value } : child
                    )
                  }
                }
              }

              // Regular element update
              return item.id === elementId
                ? { ...item, [property]: value }
                : item
            })
          }
          : page
      )
    }))

    // Mark template as having unsaved changes
    setHasUnsavedChanges(true)
    setIsSaved(false)

    // Auto-grow the text box to contain the text at its exact font size when a
    // size-affecting property changes. The box (width/height) is the user's max;
    // the worker shrinks actual content into it. Growing happens on the NEXT
    // tick so it reads the just-applied value.
    const SIZE_AFFECTING = ['fontSize', 'content', 'fontFamily', 'fontWeight', 'fontStyle', 'lineHeight', 'letterSpacing', 'wordSpacing', 'wrap', 'strokeWidth']
    if (SIZE_AFFECTING.includes(property)) {
      const tgt = currentPage?.items?.find((it) => it.id === elementId)
      if (tgt && tgt.type === 'text') {
        setTimeout(() => autoGrowTextBox(elementId), 0)
      }
    }
  }

  // --- AI Image Generation -------------------------------------------------
  // Generate an image for an element from its prompt via the workflow AI queue,
  // then (when transparency is requested) run the result through background
  // removal, and finally apply the image to the element. Progress is surfaced
  // via the aiImageGenerationJobs snackbar queue. Returns the final image URL
  // (or null on failure) so the bulk flow can run items sequentially.
  //
  // NOTE: this block is defined AFTER updateElementProperty and the
  // template_content state so its useCallback dependency arrays (evaluated
  // eagerly during render) don't hit a temporal-dead-zone ReferenceError.
  // Apply a generated image to EXACTLY ONE image item, identified by id, across
  // ALL pages (not just the current page). We intentionally do NOT use
  // updateElementProperty here because that helper only mutates the current
  // page — which, during bulk generation across pages, would either drop the
  // update or (if ids collide) splatter the same image onto the wrong items.
  // Here we update the first item whose id matches and leave every other item
  // byte-identical, in a single atomic state update so src/url/storageUrl stay
  // consistent.
  const applyImageToElement = (elementId, url) => {
    if (!elementId || !url) return
    settemplate_content(prev => {
      if (!prev || !Array.isArray(prev.pages)) return prev
      let applied = false
      const pages = prev.pages.map(page => {
        if (applied || !page || !Array.isArray(page.items)) return page
        let pageChanged = false
        const items = page.items.map(item => {
          if (applied) return item
          if (item && item.id === elementId) {
            applied = true
            pageChanged = true
            return { ...item, src: url, url: url, storageUrl: url }
          }
          return item
        })
        return pageChanged ? { ...page, items } : page
      })
      if (!applied) return prev
      return { ...prev, pages }
    })
    setHasUnsavedChanges(true)
    setIsSaved(false)
  }

  const runAIImageGeneration = async ({ elementId, prompt, width, height, transparency, filename, jobId: existingJobId, autoApply = true }) => {
    // Reuse the job row on regenerate; create a fresh one otherwise.
    const jobId = existingJobId || `ai-${Date.now()}-${Math.random().toString(36).slice(2)}`
    const setJob = (patch) => setAiImageGenerationJobs(prev => prev.map(j => j.id === jobId ? { ...j, ...patch } : j))

    // The params are stored on the job so the snackbar's "Regenerate" button can
    // re-run the exact same request.
    const params = { elementId, prompt, width, height, transparency, filename }

    setAiImageGenerationJobs(prev => {
      const base = {
        id: jobId,
        status: 'starting',
        phase: 'generating',
        progress: 0,
        filename: filename || 'ai-image.png',
        elementId,
        output_url: null,
        params,
      }
      const existing = prev.find(j => j.id === jobId)
      if (existing) {
        return prev.map(j => j.id === jobId ? { ...base } : j)
      }
      return [...prev, base]
    })

    const pollStatus = async (url, isGeneration, expectedJobId) => {
      // Poll a status endpoint until completed/failed. Returns the result URL.
      for (let attempt = 0; attempt < 150; attempt++) { // ~5 min at 2s
        await new Promise(r => setTimeout(r, 2000))
        let resp
        try {
          // Cache-bust + no-store so a proxy/browser can never return a stale
          // status response belonging to a different job.
          const bust = `${url.includes('?') ? '&' : '?'}_t=${Date.now()}`
          resp = await fetch(url + bust, { cache: 'no-store' })
        } catch (e) {
          continue // transient network error, keep polling
        }
        const data = await resp.json().catch(() => null)
        const payload = data?.data || data
        if (!payload) continue
        // Guard: for generation, make sure the status we got is for the job we
        // asked about. If the backend/workflow ever echoes a different id, we do
        // NOT apply that result (prevents the "wrong image" mapping bug).
        if (isGeneration && expectedJobId && payload.job_id && String(payload.job_id) !== String(expectedJobId)) {
          console.warn('[ai-image] status id mismatch', { expectedJobId, got: payload.job_id })
          continue
        }
        if (isGeneration && expectedJobId && payload.wf_id && String(payload.wf_id) !== String(expectedJobId)) {
          console.warn('[ai-image] workflow id mismatch', { expectedJobId, wf_id: payload.wf_id })
          continue
        }
        const status = payload.status
        if (status === 'completed') {
          return isGeneration ? payload.output_url : payload.new_image_url
        }
        if (status === 'failed' || status === 'cancelled') {
          throw new Error(payload.message || 'Job failed')
        }
        // still processing
      }
      throw new Error('Timed out waiting for the job')
    }

    try {
      // 1) Enqueue generation. Send a unique client_ref so the workflow can
      //    never collapse/dedup two element jobs into one.
      setJob({ status: 'processing', phase: 'generating' })
      const clientRef = `${elementId || 'el'}-${jobId}`
      const genResp = await fetch('/api/v1/ai-image/editor/generate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt, width, height, client_ref: clientRef })
      })
      const genData = await genResp.json().catch(() => null)
      if (!genResp.ok || !genData?.job_id) {
        throw new Error(genData?.detail || genData?.message || 'Failed to start image generation')
      }
      const workflowJobId = genData.job_id
      // Surface the AI Queue id on the snackbar card as soon as we have it.
      setJob({ queueId: workflowJobId })
      console.log('[ai-image] generate', { elementId, clientRef, workflowJobId, prompt: (prompt || '').slice(0, 50) })

      // 2) Poll generation to completion. Append a cache-busting param so no
      //    intermediate proxy can serve a stale status for a different job.
      let imageUrl = await pollStatus(`/api/v1/ai-image/editor/status/${workflowJobId}`, true, workflowJobId)
      if (!imageUrl) throw new Error('Generation finished without an image')
      console.log('[ai-image] completed', { elementId, workflowJobId, imageUrl })

      // Remember the original generated image (before any background removal) so
      // the snackbar can show both the original and the cut-out result.
      const originalUrl = imageUrl
      setJob({ original_url: originalUrl, output_url: imageUrl })

      // By default we do NOT auto-apply — the generated image is shown in the
      // snackbar and the user applies it explicitly via the "Apply" button. The
      // bulk flow opts into autoApply so it can fill every item at once.
      if (autoApply) {
        applyImageToElement(elementId, imageUrl)
      }

      // 3) Optional background removal for transparency — routed through the
      //    workflow General Queue (same AI queue infrastructure as generation).
      let bgRemoved = false
      if (transparency) {
        setJob({ phase: 'removing-bg' })
        const brResp = await fetch('/api/v1/ai-image/editor/remove-bg', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ image_url: imageUrl, client_ref: `${clientRef}-bg` })
        })
        const brData = await brResp.json().catch(() => null)
        if (brResp.ok && brData?.job_id) {
          try {
            // bg-removal is an AI-queue image job, so its result comes back via
            // the same generation status endpoint as output_url.
            const transparentUrl = await pollStatus(`/api/v1/ai-image/editor/status/${brData.job_id}`, true, brData.job_id)
            if (transparentUrl) {
              imageUrl = transparentUrl
              bgRemoved = true
              if (autoApply) {
                applyImageToElement(elementId, imageUrl)
              }
            }
          } catch (brErr) {
            // Background removal failed — keep the generated (opaque) image and
            // continue; don't fail the whole generation.
            console.warn('Background removal failed, keeping generated image:', brErr)
          }
        } else {
          console.warn('Background removal enqueue failed:', brData?.detail || brData?.message)
        }
      }

      setJob({ status: 'completed', progress: 100, output_url: imageUrl, original_url: originalUrl, bgRemoved })
      setHasUnsavedChanges(true)
      setIsSaved(false)
      return imageUrl
    } catch (err) {
      setJob({ status: 'failed', error: err.message || 'Image generation failed' })
      return null
    }
  }

  // Apply a completed AI image (from the AI Generation Queue dialog) to the
  // element at a specific (pageIndex, itemIndex) in the live template_content,
  // so the canvas reflects it immediately. Position-based (not id-based) so it
  // targets exactly the item the backend generated for. Used for both the
  // manual "Apply" button and auto-apply on completion.
  const applyAiJobToTemplate = useCallback(({ pageIndex, itemIndex, url, auto }) => {
    if (url == null || pageIndex == null || itemIndex == null) return
    let didApply = false
    settemplate_content(prev => {
      if (!prev || !Array.isArray(prev.pages)) return prev
      const page = prev.pages[pageIndex]
      if (!page || !Array.isArray(page.items)) return prev
      const item = page.items[itemIndex]
      if (!item) return prev
      // Skip if already pointing at this URL (avoids redundant state churn on
      // repeated auto-apply passes).
      if (item.src === url && item.url === url && item.storageUrl === url) return prev
      const items = page.items.map((it, ii) =>
        ii === itemIndex ? { ...it, src: url, url, storageUrl: url } : it
      )
      const pages = prev.pages.map((pg, pi) => (pi === pageIndex ? { ...page, items } : pg))
      didApply = true
      return { ...prev, pages }
    })
    if (didApply) {
      setHasUnsavedChanges(true)
      setIsSaved(false)
      if (!auto) {
        window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'success', message: `Applied image to Page ${pageIndex + 1} · Item ${itemIndex + 1}` } }))
      }
    }
  }, [])

  // Retry a FAILED AI generation record from the AI Generation Queue dialog.
  // Re-enqueues generation for the record's item via the backend and surfaces
  // the new attempt in the Progress panel. Throws on failure so the dialog can
  // show an error.
  const retryAiJob = useCallback(async (job) => {
    if (!template_id || !job?.id) return
    try {
      await templateAPI.aiRetryJob(template_id, job.id)
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'success', message: 'Retry started. Track it in Progress Tracker.' } }))
      setIsExportProgressExpanded(true)
      const uid = user?.id
      if (uid) {
        setTimeout(() => { exportService.loadUserJobs(String(uid)).catch(() => {}) }, 1200)
      }
    } catch (err) {
      console.error('AI retry failed to start:', err)
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'error', message: err?.response?.data?.detail || 'Failed to start retry.' } }))
      throw err
    }
  }, [template_id, user?.id])

  // Generate a single image item through the backend Progress queue (so it's
  // recorded + resilient), instead of the old client-side snackbar flow. Saves
  // the latest content, locates the element's (page,item) index, enqueues one
  // generation, then opens the Progress panel to track it.
  const generateSingleImageViaQueue = async ({ elementId, prompt }) => {
    if (!template_id) {
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'error', message: 'Save the template once before generating.' } }))
      return
    }
    if (!elementId || !(prompt || '').trim()) return

    // Locate the element's position in the current template_content.
    let pageIndex = -1, itemIndex = -1
    const pages = template_content?.pages || []
    for (let pi = 0; pi < pages.length; pi++) {
      const items = pages[pi]?.items || []
      const ii = items.findIndex((it) => it && it.id === elementId)
      if (ii !== -1) { pageIndex = pi; itemIndex = ii; break }
    }
    if (pageIndex === -1) {
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'error', message: 'Could not locate the image on the page.' } }))
      return
    }

    try {
      await templateAPI.aiGenerateItem(template_id, {
        template_content,
        page_index: pageIndex,
        item_index: itemIndex,
      })
      setHasUnsavedChanges(false)
      setIsSaved(true)
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'success', message: 'Image generation started. Track it in Progress.' } }))
      setIsExportProgressExpanded(true)
      const uid = user?.id
      if (uid) {
        setTimeout(() => { exportService.loadUserJobs(String(uid)).catch(() => {}) }, 1200)
      }
    } catch (err) {
      console.error('Single AI generate failed to start:', err)
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'error', message: err?.response?.data?.detail || 'Failed to start generation.' } }))
    }
  }

  // Listen for per-element generate events dispatched by ImageElementProperties
  useEffect(() => {
    const handleGenerate = (e) => {
      const detail = e.detail || {}
      if (!detail.elementId || !detail.prompt) return
      generateSingleImageViaQueue(detail)
    }
    window.addEventListener('ai-image-generate:start', handleGenerate)
    return () => window.removeEventListener('ai-image-generate:start', handleGenerate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template_id, template_content, user?.id])

  // Bulk AI Image Generate (editor File-menu action).
  //
  // This now runs ENTIRELY on the backend via the resilient, callback-driven
  // queue: we persist the current template_content, then POST to
  // /templates/{id}/bulk-ai-generate. The server creates a Progress-queue
  // record, enqueues each prompted image on the workflow queue with a callback,
  // and applies + saves results as callbacks arrive (surviving restarts and the
  // up-to-30-minute processing). The user watches it in the Progress panel.
  const bulkGenerateAIImages = async () => {
    if (!template_id) {
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'error', message: 'Save the template once before bulk AI generation.' } }))
      return
    }

    // Count prompted image items for a friendly message / early-out.
    const promptedCount = (template_content?.pages || []).reduce((n, page) =>
      n + (page?.items || []).filter(it => it && it.type === 'image' && String(it.prompt || '').trim()).length, 0)
    if (promptedCount === 0) {
      window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'info', message: 'No image items with an AI prompt were found.' } }))
      return
    }

    try {
      // Save current content first so the backend generates against the latest
      // prompts, then kick off server-side bulk generation.
      await templateAPI.bulkAIGenerate(template_id, { template_content })
      setHasUnsavedChanges(false)
      setIsSaved(true)

      window.dispatchEvent(new CustomEvent('app:notify', {
        detail: { type: 'success', message: `Started AI generation for ${promptedCount} image${promptedCount > 1 ? 's' : ''}. Track it in Progress.` }
      }))

      // Surface it in the Progress panel: open it and reload the user's records
      // so the new 'ai_image' job appears and keeps updating.
      setIsExportProgressExpanded(true)
      const uid = user?.id
      if (uid) {
        // Small delay so the server-side Progress row is created first.
        setTimeout(() => { exportService.loadUserJobs(String(uid)).catch(() => {}) }, 1200)
      }
    } catch (err) {
      console.error('Bulk AI generate failed to start:', err)
      window.dispatchEvent(new CustomEvent('app:notify', {
        detail: { type: 'error', message: err?.response?.data?.detail || 'Failed to start bulk AI generation.' }
      }))
    }
  }

  // --- Alter Video Duration (global time scaling) ---------------------------
  // Compute the current composition duration = the latest point any item ends,
  // across ALL pages. Mirrors the Timeline derivation (max start + duration) and
  // the server-side helper in engine_proxy_server templateController.
  const computeTemplateDuration = useCallback(() => {
    let maxEnd = 0
    const consider = (item) => {
      if (!item) return
      const start = (item.time && typeof item.time.start === 'number')
        ? item.time.start
        : (typeof item.start === 'number' ? item.start : 0)
      let dur = 0
      if (item.time && typeof item.time.duration === 'number') dur = item.time.duration
      else if (typeof item.duration === 'number') dur = item.duration
      const end = start + dur
      if (end > maxEnd) maxEnd = end
    }
    const pages = template_content?.pages || []
    for (const page of pages) {
      for (const item of (page.items || [])) {
        consider(item)
        if (Array.isArray(item.powerClipContents)) item.powerClipContents.forEach(consider)
      }
    }
    return maxEnd
  }, [template_content])

  // Scale one item's time-based values in place-safe (returns a new item).
  // `scaleEffects` controls whether animation/motion/transition/fade timings
  // are scaled too (full fidelity) or only item placement (start/duration).
  const scaleItemTiming = useCallback((item, ratio, scaleEffects) => {
    if (!item || !isFinite(ratio) || ratio <= 0) return item
    const next = { ...item }

    // Core placement timing (all item types).
    if (next.time && typeof next.time === 'object') {
      next.time = { ...next.time }
      if (typeof next.time.start === 'number') next.time.start = next.time.start * ratio
      if (typeof next.time.duration === 'number') next.time.duration = next.time.duration * ratio
    }
    if (typeof next.start === 'number') next.start = next.start * ratio
    if (typeof next.duration === 'number') next.duration = next.duration * ratio

    // Source trim window (audio/video) scales so the clip still fills its slot.
    if (next.trim && typeof next.trim === 'object') {
      next.trim = { ...next.trim }
      if (typeof next.trim.start === 'number') next.trim.start = next.trim.start * ratio
      if (typeof next.trim.end === 'number') next.trim.end = next.trim.end * ratio
    }
    if (next.file && typeof next.file === 'object' && typeof next.file.duration === 'number') {
      next.file = { ...next.file, duration: next.file.duration * ratio }
    }

    if (scaleEffects) {
      // Animations (array; each has start/duration in seconds).
      if (Array.isArray(next.animations)) {
        next.animations = next.animations.map((a) => {
          if (!a || typeof a !== 'object') return a
          const na = { ...a }
          if (typeof na.start === 'number') na.start = na.start * ratio
          if (typeof na.duration === 'number') na.duration = na.duration * ratio
          if (typeof na.delay === 'number') na.delay = na.delay * ratio
          if (typeof na.stagger === 'number') na.stagger = na.stagger * ratio
          return na
        })
      }
      // Text motion.
      if (next.motion && typeof next.motion === 'object') {
        next.motion = { ...next.motion }
        if (typeof next.motion.start === 'number') next.motion.start = next.motion.start * ratio
        if (typeof next.motion.duration === 'number') next.motion.duration = next.motion.duration * ratio
      }
      // Clip transitions (in/out/shorthand durations in seconds).
      if (next.transition && typeof next.transition === 'object') {
        const t = { ...next.transition }
        if (typeof t.duration === 'number') t.duration = t.duration * ratio
        if (t.in && typeof t.in === 'object' && typeof t.in.duration === 'number') {
          t.in = { ...t.in, duration: t.in.duration * ratio }
        }
        if (t.out && typeof t.out === 'object' && typeof t.out.duration === 'number') {
          t.out = { ...t.out, duration: t.out.duration * ratio }
        }
        next.transition = t
      }
      // Audio-style fade envelope (seconds).
      if (next.settings && typeof next.settings === 'object') {
        const s = { ...next.settings }
        if (typeof s.fadeIn === 'number') s.fadeIn = s.fadeIn * ratio
        if (typeof s.fadeOut === 'number') s.fadeOut = s.fadeOut * ratio
        next.settings = s
      }
    }

    return next
  }, [])

  // Apply a global time scale to the entire template (all pages, all items,
  // including PowerClip contents). Triggered from the "Alter Video Duration"
  // dialog. `ratio` is targetDuration / currentDuration (e.g. 2 = double length).
  const scaleTemplateDuration = useCallback(({ ratio, scaleEffects = true } = {}) => {
    if (!isFinite(ratio) || ratio <= 0 || Math.abs(ratio - 1) < 1e-6) return
    settemplate_content(prev => ({
      ...prev,
      pages: (prev.pages || []).map(page => ({
        ...page,
        items: (page.items || []).map(item => {
          const scaled = scaleItemTiming(item, ratio, scaleEffects)
          if (Array.isArray(scaled.powerClipContents)) {
            return {
              ...scaled,
              powerClipContents: scaled.powerClipContents.map(pc => scaleItemTiming(pc, ratio, scaleEffects))
            }
          }
          return scaled
        })
      }))
    }))
    setHasUnsavedChanges(true)
    setIsSaved(false)
  }, [scaleItemTiming])

  // Get element visibility and properties at current time
  const getElementAtTime = (element, time) => {
    const timeProps = element.time || {}
    const start = timeProps.start || 0
    const duration = timeProps.duration || 2
    const end = start + duration

    // Element is not visible if outside its time range
    if (time < start || time > end) {
      return { ...element, visible: false, opacity: 0 }
    }

    // Calculate progress within the element's duration (0 to 1)
    const progress = (time - start) / duration

    // Apply time-based transformations
    let elementAtTime = { ...element, visible: true }

    // Handle fade in/out effects
    if (timeProps.fadeIn && progress < timeProps.fadeIn) {
      elementAtTime.opacity = (element.opacity || 1) * (progress / timeProps.fadeIn)
    } else if (timeProps.fadeOut && progress > (1 - timeProps.fadeOut)) {
      const fadeProgress = (1 - progress) / timeProps.fadeOut
      elementAtTime.opacity = (element.opacity || 1) * fadeProgress
    }

    // Handle animations (basic slide, scale, rotate)
    if (timeProps.animation) {
      const anim = timeProps.animation
      const easeProgress = progress // Could add easing functions here

      if (anim.type === 'slideIn') {
        const startX = element.x + (anim.fromX || -100)
        const startY = element.y + (anim.fromY || 0)
        elementAtTime.x = startX + (element.x - startX) * easeProgress
        elementAtTime.y = startY + (element.y - startY) * easeProgress
      } else if (anim.type === 'scaleIn') {
        const startScale = anim.fromScale || 0
        const targetScale = element.scaleX || 1
        elementAtTime.scaleX = startScale + (targetScale - startScale) * easeProgress
        elementAtTime.scaleY = startScale + (targetScale - startScale) * easeProgress
      } else if (anim.type === 'rotate') {
        const startRotation = anim.fromRotation || 0
        const targetRotation = element.rotation || 0
        elementAtTime.rotation = startRotation + (targetRotation - startRotation) * easeProgress
      }
    }

    return elementAtTime
  }

  // Get all elements at current preview time for video playback
  const getElementsAtCurrentTime = () => {
    // For video templates, always filter items based on current preview time (seeker position)
    if ((template_content?.type || template_content?.mediaType) === 'video') {
      return (currentPage?.items || []).map(element => getElementAtTime(element, previewTime))
        .filter(element => element.visible !== false) // Only show visible elements
    }

    // For non-video templates, return all items
    return currentPage?.items || []
  }

  // Get audio items (audio and sound-effect types)
  const getAudioItems = useCallback(() => {
    const page = template_content?.pages?.[currentPageIndex]
    if (!page) return []
    return (page.items || []).filter(item => 
      item.type === 'audio' || 
      item.type === 'sound-effect' || 
      item.type === 'tts' ||
      item.type === 'video' // Include video items for audio extraction
    )
  }, [template_content, currentPageIndex])

  // Get adjustment layers that affect a given item
  const getAdjustmentLayersForItem = useCallback((item) => {
    const page = template_content?.pages?.[currentPageIndex]
    if (!page) return []
    
    const itemLayer = item.layer || 0
    const currentTime = previewTime || 0
    
    // Get all adjustment layers that are:
    // 1. Above this item (higher layer number)
    // 2. Enabled
    // 3. Active at current time
    return (page.items || []).filter(adjLayer => {
      if (adjLayer.type !== 'adjustment-layer') return false
      if (!adjLayer.enabled) return false
      if ((adjLayer.layer || 0) <= itemLayer) return false // Must be above
      
      // Check if adjustment layer is active at current time
      const adjStart = adjLayer.time?.start || 0
      const adjDuration = adjLayer.time?.duration || 10
      const adjEnd = adjStart + adjDuration
      
      return currentTime >= adjStart && currentTime <= adjEnd
    }).sort((a, b) => (a.layer || 0) - (b.layer || 0)) // Sort by layer (ascending)
  }, [template_content, currentPageIndex, previewTime])

  // Apply adjustment layer effects to an item's style
  const applyAdjustmentLayerEffects = useCallback((item, baseStyles) => {
    const itemStart = item.time?.start || 0
    const relativeTime = previewTime - itemStart
    
    const adjustmentLayers = getAdjustmentLayersForItem(item)
    if (adjustmentLayers.length === 0) {
      // Still apply item's own effects
      if (item.effects && Array.isArray(item.effects) && item.effects.length > 0) {
        const effectStyles = stackEffects(item.effects, relativeTime)
        
        return {
          ...baseStyles,
          filter: [baseStyles.filter, effectStyles.filter].filter(Boolean).join(' '),
          transform: [baseStyles.transform, effectStyles.transform].filter(Boolean).join(' '),
          opacity: (baseStyles.opacity || 1) * effectStyles.opacity,
          transformOrigin: effectStyles.transformOrigin || baseStyles.transformOrigin || 'center center'
        }
      }
      return baseStyles
    }
    
    // Collect all effects from adjustment layers and item
    // All effects should have start times relative to item start
    const allEffects = []
    
    // Adjustment layer effects: convert from absolute time to relative time
    adjustmentLayers.forEach(adjLayer => {
      if (adjLayer.effects && Array.isArray(adjLayer.effects)) {
        const adjStart = adjLayer.time?.start || 0
        adjLayer.effects.forEach(effect => {
          allEffects.push({
            ...effect,
            // Convert absolute start time to relative (relative to item start)
            start: (effect.start || 0) + adjStart - itemStart
          })
        })
      }
    })
    
    // Item's own effects: start times are already relative to item start
    if (item.effects && Array.isArray(item.effects)) {
      item.effects.forEach(effect => {
        allEffects.push({
          ...effect,
          start: effect.start || 0
        })
      })
    }
    
    // Stack all effects using relative time
    const effectStyles = stackEffects(allEffects, relativeTime)
    
    // Combine with base styles
    return {
      ...baseStyles,
      filter: [baseStyles.filter, effectStyles.filter].filter(Boolean).join(' '),
      transform: [baseStyles.transform, effectStyles.transform].filter(Boolean).join(' '),
      opacity: (baseStyles.opacity || 1) * effectStyles.opacity,
      transformOrigin: effectStyles.transformOrigin || baseStyles.transformOrigin || 'center center'
    }
  }, [getAdjustmentLayersForItem, previewTime])

  // Audio playback synchronization effect using Web Audio API
  // DISABLED: Regular "Play" button is now video-only (no audio)
  // Audio playback is handled by "Play with audio" button which generates combined audio
  useEffect(() => {
    // Always cleanup audioMixer - we're using "Play with audio" for audio playback
    audioMixer.cleanup()
  }, [isPlaying, previewTime, template_content, currentPageIndex])

  // Cleanup audio mixer on unmount
  useEffect(() => {
    return () => {
      // Cleanup audio mixer
      audioMixer.cleanup()
    }
  }, [])

  const togglePageLock = () => {
    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            page_config: {
              ...page.page_config,
              locked: !page.page_config.locked
            }
          }
          : page
      )
    }))
  }

  const duplicatePage = () => {
    const pageToClone = template_content?.pages?.[currentPageIndex]
    if (!pageToClone) return
    const newPage = {
      ...pageToClone,
      id: `page-${Date.now()}`,
      page_config: {
        ...pageToClone.page_config,
        name: `${pageToClone.page_config.name} Copy`
      },
      items: pageToClone.items.map(item => ({
        ...item,
        id: `${item.id}-copy-${Date.now()}`,
        layer: item.layer || 0 // Ensure layer value exists
      }))
    }

    settemplate_content(prev => ({
      ...prev,
      pages: [
        ...prev.pages.slice(0, currentPageIndex + 1),
        newPage,
        ...prev.pages.slice(currentPageIndex + 1)
      ]
    }))
    setCurrentPageIndex(currentPageIndex + 1)
    markAsUnsaved()
  }





  const addNewPage = () => {
    const baseWidth = template_content?.pages?.[currentPageIndex]?.page_config?.width || 800
    const baseHeight = template_content?.pages?.[currentPageIndex]?.page_config?.height || 600
    const baseBg = template_content?.pages?.[currentPageIndex]?.page_config?.backgroundColor || '#ffffff'
    setAddPageConfig({ width: baseWidth, height: baseHeight, backgroundColor: baseBg })
    setShowAddPageDialog(true)
  }

  const deletePage = () => {
    if (!template_content?.pages || template_content.pages.length <= 1) {
      alert('Cannot delete the last page!')
      return
    }

    if (window.confirm('Are you sure you want to delete this page?')) {
      settemplate_content(prev => ({
        ...prev,
        pages: prev.pages.filter((_, index) => index !== currentPageIndex)
      }))

      // Adjust current page index if necessary
      if (currentPageIndex >= template_content.pages.length - 1) {
        setCurrentPageIndex(Math.max(0, currentPageIndex - 1))
      }
    }
  }

  // Handle template import/merge
  const handleTemplateSelect = async (template) => {
    try {
      // First, fetch the full template data if we only have basic info
      let templateData = template.template_content

      if (!templateData && template.id) {
        console.log('🔄 Fetching full template data for import...')
        const response = await templateAPI.getById(template.id)
        if (response.data.success && response.data.data) {
          const tpl = response.data.data

          // Handle nested template_content structure (same logic as templateLoader)
          if (tpl.template_content?.template_content) {
            templateData = tpl.template_content.template_content
          } else if (tpl.template_content) {
            templateData = tpl.template_content
          } else if (tpl.template_content || tpl.content) {
            templateData = tpl.template_content || tpl.content
          }
        }
      }

      if (!templateData || !templateData.pages) {
        alert('Unable to import template: No page data found')
        return
      }

      console.log('📥 Importing template:', template.name)
      console.log('📄 Template pages:', templateData.pages.length)
      console.log('📄 Current pages:', template_content?.pages?.length || 0)

      // Import template by merging pages
      settemplate_content(prev => {
        const currentPages = prev?.pages || []
        const importPages = templateData.pages || []
        const newPages = [...currentPages]

        // Process each page from the imported template
        importPages.forEach((importPage, importIndex) => {
          const importItems = importPage.items || []

          if (importIndex < currentPages.length) {
            // Page exists in current design - merge items
            console.log(`🔗 Merging ${importItems.length} items into existing page ${importIndex + 1}`)

            // Generate unique IDs for imported items to avoid conflicts
            const mergedItems = importItems.map(item => ({
              ...item,
              id: `imported-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`,
              // Offset position slightly to avoid exact overlap
              x: (item.x || 0) ,
              y: (item.y || 0) 
            }))

            // Union of current items and imported items
            newPages[importIndex] = {
              ...newPages[importIndex],
              items: [...(newPages[importIndex].items || []), ...mergedItems]
            }
          } else {
            // Page doesn't exist in current design - create new page
            console.log(`➕ Creating new page ${importIndex + 1} with ${importItems.length} items`)

            // Generate unique IDs for imported items
            const newPageItems = importItems.map(item => ({
              ...item,
              id: `imported-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`
            }))

            // Create new page with imported content
            const newPage = {
              ...importPage,
              id: `imported-page-${Date.now()}-${importIndex}`,
              items: newPageItems,
              page_config: {
                ...importPage.page_config,
                name: `${importPage.page_config?.name || `Page ${importIndex + 1}`} (Imported)`
              }
            }

            newPages.push(newPage)
          }
        })

        console.log(`✅ Import complete: ${newPages.length} total pages`)
        return {
          ...prev,
          pages: newPages
        }
      })

      // Mark as unsaved since we've made changes
      markAsUnsaved()

      // Show success message
      const importedItemsCount = templateData.pages.reduce((total, page) => total + (page.items?.length || 0), 0)
      alert(`✅ Successfully imported ${importedItemsCount} items from "${template.name}"!\n\n` +
            `• ${templateData.pages.length} pages processed\n` +
            `• Items merged into existing pages\n` +
            `• New pages created as needed`)

    } catch (error) {
      console.error('❌ Error importing template:', error)
      alert('Failed to import template. Please try again.')
    }

    // Close the sidebar
    setActiveSecondarySidebar(null)
  }

  // Handle photo selection
  const handlePhotoSelect = (photo) => {
    if (maskContentPicker && maskContentPicker.type === 'image' && maskContentPicker.elementId) {
      const targetElement = currentPage?.items?.find(item => item.id === maskContentPicker.elementId)
      const existingTransform = targetElement?.maskContent?.transform || {
        scale: 1,
        offsetX: 0,
        offsetY: 0,
        rotation: 0,
        fitMode: 'cover'
      }

      updateElementProperty(maskContentPicker.elementId, 'maskContent', {
        id: photo.id,
        type: 'image',
        url: photo.url || photo.thumbnailUrl || photo.storageUrl,
        thumbnailUrl: photo.thumbnailUrl || photo.url,
        width: photo.width,
        height: photo.height,
        transform: existingTransform
      })
      setMaskContentPicker(null)
      setActiveSecondarySidebar(null)
      return
    }

    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0]);
    const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video';
    const newElement = {
      id: `image-${Date.now()}`,
      type: 'image',
      x: 100,
      y: 100,
      width: 200,
      height: 150,
      rotation: 0,
      src: photo.url || photo.thumbnailUrl,
      alt: photo.name,
      opacity: 1,
      borderRadius: 0,
      shadow: false,
      locked: false,
      // AI-generated images default to transparent (background removed). Absent
      // is treated as false elsewhere, so we set it explicitly on new items.
      ai_image_transparency: true,
      layer: maxLayer + 1
    };

    // Add default timing for video templates
    if (isVideoTemplate) {
      newElement.time = {
        start: previewTime || 0,
        duration: 5
      };
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: [...page.items, newElement]
          }
          : page
      )
    }))
    setActiveSecondarySidebar(null)
    markAsUnsaved()
  }

  // Handle element selection
  const handleElementSelect = (element) => {
    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0]);
    const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video';
    let newElement;

    if (element.type === 'shape') {
      // Built-in shape
      newElement = {
        id: `shape-${Date.now()}`,
        type: 'shape',
        x: 100,
        y: 100,
        width: 100,
        height: 100,
        rotation: 0,
        shapeType: element.shapeType,
        fill: 'transparent', // No default background color
        stroke: '#1E40AF',
        strokeWidth: 2,
        opacity: 1,
        locked: false,
        layer: maxLayer + 1
      };
    } else if (element.type === 'vector') {
      // Vector graphic element
      newElement = {
        id: `vector-${Date.now()}`,
        type: 'vector',
        x: 100,
        y: 100,
        width: 100,
        height: 100,
        rotation: 0,
        vectorId: element.id,
        svgPath: element.svgPath,
        viewBox: element.viewBox,
        fill: element.defaultProperties?.fill || 'transparent',
        stroke: element.defaultProperties?.stroke || '#1E40AF',
        strokeWidth: element.defaultProperties?.strokeWidth || 2,
        opacity: element.defaultProperties?.opacity || 1,
        scaleX: element.defaultProperties?.scaleX || 1,
        scaleY: element.defaultProperties?.scaleY || 1,
        skewX: element.defaultProperties?.skewX || 0,
        skewY: element.defaultProperties?.skewY || 0,
        shadow: element.defaultProperties?.shadow || { enabled: false },
        gradient: element.defaultProperties?.gradient || { enabled: false },
        locked: false,
        layer: maxLayer + 1
      };
    } else {
      // Database graphic element
      newElement = {
        id: `graphic-${Date.now()}`,
        type: 'graphic',
        x: 100,
        y: 100,
        width: 100,
        height: 100,
        rotation: 0,
        svgData: injectOverrideStyleScoped(normalizeSvgColors(element.svgData), `graphic-${Date.now()}`, { fill: element.defaultProperties?.fill || 'transparent', stroke: element.defaultProperties?.stroke || '#1E40AF', strokeWidth: element.defaultProperties?.strokeWidth || 2 }, { important: true }),
        fill: element.defaultProperties?.fill || 'transparent', // No default background color
        stroke: element.defaultProperties?.stroke || '#1E40AF',
        strokeWidth: element.defaultProperties?.strokeWidth || 2,
        opacity: 1,
        locked: false,
        layer: maxLayer + 1
      };
    }

    // Add default timing for video templates
    if (isVideoTemplate) {
      newElement.time = {
        start: previewTime || 0,
        duration: 5
      };
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: [...page.items, newElement]
          }
          : page
      )
    }));
    setActiveSecondarySidebar(null);
  };

  // Handle text selection
  const handleTextSelect = (textOption) => {
    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0]);
    const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video';
    let newElement;

    if (textOption.type === 'wordart') {
      newElement = {
        id: `wordart-${Date.now()}`,
        type: 'wordart',
        x: 100,
        y: 100,
        width: 300,
        height: 80,
        rotation: 0,
        content: textOption.content,
        style: textOption.style,
        wordArtId: textOption.wordArtId,
        opacity: 1,
        locked: false,
        layer: maxLayer + 1
      };
    } else {
      // Determine default font family based on text option
      // English text uses "Bakbak One", Hindi text uses "Sarala"
      // Store just the font name (not the full CSS format like "Arial, sans-serif")
      const defaultFontFamily = textOption.fontFamily || 'Arial'
      
      newElement = {
        id: `text-${Date.now()}`,
        type: 'text',
        x: 100,
        y: 100,
        width: 300,
        height: 50,
        rotation: 0,
        content: textOption.content,
        fontSize: textOption.fontSize,
        fontFamily: defaultFontFamily, // Store font name only (e.g., "Bakbak One" or "Sarala")
        fontWeight: textOption.fontWeight,
        textAlign: 'left',
        color: textOption.color,
        opacity: 1,
        locked: false,
        textEffect: null,
        layer: maxLayer + 1
      };
    }

    // Add default timing for video templates
    if (isVideoTemplate) {
      newElement.time = {
        start: previewTime || 0,
        duration: 5
      };
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: [...page.items, newElement]
          }
          : page
      )
    }));
    setActiveSecondarySidebar(null);
  };

  // Handle graphic selection (SVG graphics)
  const handleGraphicSelect = (graphic) => {
    // Locally-uploaded SVGs (and any graphic that carries full SVG markup)
    // are placed as first-class `type:"svg"` items so their original
    // multi-color palette is preserved. The legacy `svg-graphic` path forces a
    // single fill/stroke and is kept only for server library graphics that rely
    // on recoloring.
    if (graphic?.isLocal && isLikelySvg(graphic.svgData)) {
      insertSvgContentItem(graphic.svgData, graphic.name || 'SVG');
      return;
    }

    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0]);
    const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video';
    const newElement = {
      id: `svg-graphic-${Date.now()}`,
      type: 'svg-graphic',
      x: 100,
      y: 100,
      width: graphic.width || graphic.defaultProperties?.width || 150,
      height: graphic.height || graphic.defaultProperties?.height || 150,
      rotation: 0,
      svgData: graphic.svgData,
      originalSvgData: graphic.svgData, // Keep original for editing
      fill: graphic.defaultProperties?.fill || '#000000',
      stroke: graphic.defaultProperties?.stroke || '#000000',
      strokeWidth: graphic.defaultProperties?.strokeWidth || 1,
      opacity: 1,
      isEditable: graphic.isEditable !== false,
      locked: false,
      name: graphic.name,
      graphicId: graphic.id,
      layer: maxLayer + 1
    };

    // Add default timing for video templates
    if (isVideoTemplate) {
      newElement.time = {
        start: previewTime || 0,
        duration: 5
      };
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: [...page.items, newElement]
          }
          : page
      )
    }));
    setActiveSecondarySidebar(null);
  };

  const handleMaskAssetSelect = (asset) => {
    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0]);
    const width = asset.width || 300;
    const height = asset.height || 300;
    const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video';
    const maskMediaType = asset.mediaType || asset.media_type || 'image';
    const maskProcessingData = asset.processingData || asset.processing_data || {};
    const newElement = {
      id: `mask-${Date.now()}`,
      type: 'mask',
      x: 100,
      y: 100,
      width,
      height,
      rotation: 0,
      opacity: 1,
      maskAsset: {
        id: asset.id,
        url: asset.storageUrl || asset.storage_url || asset.url,
        thumbnailUrl: asset.thumbnailUrl,
        mediaType: maskMediaType,
        width: asset.width,
        height: asset.height,
        duration: asset.duration,
        processingData: maskProcessingData,
      },
      maskSettings: {
        feather: 0,
        blur: 0,
        invert: false,
        opacity: 1,
      },
      maskContent: null,
      layer: maxLayer + 1,
      name: asset.originalName || asset.filename || 'Mask',
    };

    if (isVideoTemplate) {
      newElement.time = {
        start: previewTime || 0,
        duration: 5,
      };
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? {
            ...page,
            items: [...page.items, newElement],
          }
          : page
      ),
    }));
    setActiveSecondarySidebar(null);
    setGraphicsSidebarTab('graphics');
    markAsUnsaved();
  };

  // Import an SVG file directly onto the canvas as a first-class `type:"svg"`
  // item. The full markup is stored inline in `svgContent` (no upload/round-trip
  // needed). Box size is seeded from the SVG's intrinsic/viewBox size, capped so
  // very large art lands at a sane editor size. Returns the new item id or null.
  const insertSvgContentItem = (svgContent, name = 'SVG') => {
    if (!isLikelySvg(svgContent)) {
      alert('That does not look like a valid SVG file.');
      return null;
    }
    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0]);
    const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video';

    const intrinsic = getSvgIntrinsicSize(svgContent, 150);
    // Cap the initial on-canvas size while preserving aspect ratio.
    const MAX_DIM = 300;
    let w = intrinsic.width;
    let h = intrinsic.height;
    if (w > MAX_DIM || h > MAX_DIM) {
      const s = MAX_DIM / Math.max(w, h);
      w = Math.round(w * s);
      h = Math.round(h * s);
    }

    const newElement = {
      id: `svg-${Date.now()}`,
      type: 'svg',
      x: 100,
      y: 100,
      width: w,
      height: h,
      rotation: 0,
      opacity: 1,
      layer: maxLayer + 1,
      locked: false,
      svgContent,
      name,
      // Recolor is opt-in; native SVG colors are preserved by default.
      recolorSvg: false,
    };

    if (isVideoTemplate) {
      newElement.time = { start: previewTime || 0, duration: 5 };
    }

    settemplate_content(prev => ({
      ...prev,
      pages: prev.pages.map((page, index) =>
        index === currentPageIndex
          ? { ...page, items: [...page.items, newElement] }
          : page
      ),
    }));
    setSelectedElement(newElement.id);
    setActiveSecondarySidebar(null);
    markAsUnsaved();
    return newElement.id;
  };

  // Read a user-selected .svg File and place it on the canvas.
  const handleSvgFileImport = (file) => {
    if (!file) return;
    const isSvg = (file.type && file.type.includes('svg')) || /\.svg$/i.test(file.name || '');
    if (!isSvg) {
      alert('Please select an SVG file.');
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target?.result;
      if (typeof text === 'string') {
        insertSvgContentItem(text, (file.name || 'SVG').replace(/\.svg$/i, ''));
      }
    };
    reader.onerror = () => alert('Failed to read the SVG file.');
    reader.readAsText(file);
  };

  const handleVideoSelectForMask = (video) => {
    if (!(maskContentPicker && maskContentPicker.type === 'video' && maskContentPicker.elementId)) {
      return false
    }

    const targetElement = currentPage?.items?.find(item => item.id === maskContentPicker.elementId)
    const existingTransform = targetElement?.maskContent?.transform || {
      scale: 1,
      offsetX: 0,
      offsetY: 0,
      rotation: 0,
      fitMode: 'cover'
    }

    const videoDuration = video.duration || video.file?.duration || 5
    const videoUrl = video.directUrl || video.filePath || video.storageUrl || video.url || `/api/v1/videos/${video.id}/stream`

    updateElementProperty(maskContentPicker.elementId, 'maskContent', {
      id: video.id,
      type: 'video',
      url: videoUrl,
      thumbnailUrl: video.thumbnailUrl || video.poster || '',
      width: video.width,
      height: video.height,
      duration: videoDuration,
      trim: {
        start: 0,
        end: videoDuration
      },
      transform: existingTransform
    })
    setMaskContentPicker(null)
    setActiveSecondarySidebar(null)
    return true
  }

  // Handle clipart selection (clipart stored as photos with clipart tag)
  const handleClipartSelect = (clipart) => {
    const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0]);
    const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video';

    // Check if it's SVG data or regular image
    if (clipart.svgData) {
      // Handle SVG clipart
      const newElement = {
        id: `svg-clipart-${Date.now()}`,
        type: 'svg-graphic',
        x: 100,
        y: 100,
        width: clipart.width || 150,
        height: clipart.height || 150,
        rotation: 0,
        svgData: clipart.svgData,
        originalSvgData: clipart.svgData,
        fill: '#000000',
        stroke: '#000000',
        strokeWidth: 1,
        opacity: 1,
        layer: maxLayer + 1,
        name: clipart.name || 'Clipart',
        locked: false,
        hidden: false,
        clipartId: clipart.id
      };

      // Add default timing for video templates
      if (isVideoTemplate) {
        newElement.time = {
          start: previewTime || 0,
          duration: 5
        };
      }

      settemplate_content(prev => ({
        ...prev,
        pages: prev.pages.map((page, index) =>
          index === currentPageIndex
            ? { ...page, items: [...(page.items || []), newElement] }
            : page
        )
      }));
    } else {
      // Handle regular image clipart (stored as photo)
      const newElement = {
        id: `image-clipart-${Date.now()}`,
        type: 'image',
        x: 100,
        y: 100,
        width: clipart.width || 150,
        height: clipart.height || 150,
        rotation: 0,
        src: clipart.storageUrl || clipart.thumbnailUrl,
        opacity: 1,
        layer: maxLayer + 1,
        name: clipart.name || 'Clipart',
        locked: false,
        hidden: false,
        clipartId: clipart.id
      };

      // Add default timing for video templates
      if (isVideoTemplate) {
        newElement.time = {
          start: previewTime || 0,
          duration: 5
        };
      }

      settemplate_content(prev => ({
        ...prev,
        pages: prev.pages.map((page, index) =>
          index === currentPageIndex
            ? { ...page, items: [...(page.items || []), newElement] }
            : page
        )
      }));
    }

    setActiveSecondarySidebar(null);
  };

  // Handle sound effect selection
  const handleSoundEffectSelect = (soundEffect) => {
    // Add sound effect as a page item (unified structure)
    if ((template_content?.type || template_content?.mediaType) === 'video') {
      settemplate_content(prev => {
        const currentPage = prev.pages?.[currentPageIndex] || {};
        const currentItems = currentPage.items || [];

        // Find audio items to determine the last track
        const audioItems = currentItems.filter(item => item.type === 'audio' || item.type === 'sound-effect');
        const trackIds = audioItems.map(item => item.trackId || 0);
        const lastTrackId = trackIds.length > 0 ? Math.max(...trackIds) : 0;

        const soundEffectDuration = soundEffect.duration || 5;

        // Create new sound effect item as page item
        const newSoundEffectItem = {
          id: `sound-effect-${Date.now()}`,
          type: 'sound-effect',
          name: soundEffect.filename || soundEffect.originalName || soundEffect.name || 'Sound Effect',
          // Sound effects don't have visual position/size but have timeline properties
          time: {
            start: 0,
            duration: soundEffectDuration
          },
          // Sound effect-specific properties
          file: {
            name: soundEffect.filename || soundEffect.originalName || soundEffect.name || 'Sound Effect',
            url: soundEffect.storageUrl || soundEffect.url,
            duration: soundEffectDuration
          },
          trackId: lastTrackId, // Add to last track
          trim: {
            start: 0,
            end: soundEffectDuration
          },
          settings: {
            volume: 1,
            fadeIn: 0,
            fadeOut: 0,
            pan: 0
          },
          // Mark as non-visual item
          isVisual: false,
          layer: -1 // Use negative layer for audio items
        };

        console.log('🎵 Adding sound effect to page items:', {
          name: newSoundEffectItem.name,
          trackId: lastTrackId,
          duration: soundEffectDuration
        });

        return {
          ...prev,
          pages: prev.pages.map((page, idx) =>
            idx === currentPageIndex
              ? { ...page, items: [...currentItems, newSoundEffectItem] }
              : page
          )
        };
      });

      console.log('Sound effect added to page items:', soundEffect.name);
    }

    setActiveSecondarySidebar(null);
  };

  // Handle sidebar toggle
  const toggleSecondarySidebar = (sidebarType) => {
    if (sidebarType === 'graphics') {
      setGraphicsSidebarTab('graphics')
    }
    setActiveSecondarySidebar(activeSecondarySidebar === sidebarType ? null : sidebarType)
  }

  const openMaskLibrary = () => {
    setGraphicsSidebarTab('masking')
    setActiveSecondarySidebar('graphics')
  }

  const startMaskContentPicker = (elementId, pickerType = 'image') => {
    setMaskContentPicker({ elementId, type: pickerType })
    if (pickerType === 'image') {
      setActiveSecondarySidebar('photos')
    } else {
      setActiveSecondarySidebar('video')
    }
  }

  // Handle fonts sidebar open with preview text
  const handleOpenFontsSidebar = (previewText) => {
    setFontsSidebarPreviewText(previewText || 'Hello World')
    setActiveSecondarySidebar('fonts')
  }

  // Handle font selection from fonts sidebar
  const handleFontSelect = async (fontFamily) => {
    // Ensure font is loaded before applying it
    try {
      const { catalogAPI } = await import('../services/api')
      const { injectFontFamilyVariants } = await import('../utils/fontLoader')
      
      // Fetch fonts if not already loaded
      const response = await catalogAPI.getFonts()
      if (response.data?.success && response.data.data?.fonts) {
        // Inject all variants for the selected font family
        injectFontFamilyVariants(response.data.data.fonts, fontFamily, 20)
      }
    } catch (error) {
      console.warn('Failed to preload font variants:', error)
    }
    
    // Apply font to element
    if (selectedElement && window.currentTextEditor && window.currentTextEditor.applyFormatting) {
      window.currentTextEditor.restoreSelection && window.currentTextEditor.restoreSelection()
      window.currentTextEditor.applyFormatting('fontFamily', fontFamily)
    } else if (selectedElement) {
      updateElementProperty(selectedElement, 'fontFamily', fontFamily)
    }
    setActiveSecondarySidebar(null)
  }

  // Function to open category in dialog mode
  const openCategoryDialog = (categoryType) => {
    setCategoryDialogType(categoryType)
    setShowCategoryDialog(true)
    // Close any open secondary sidebar when dialog opens
    setActiveSecondarySidebar(null)
  }

  // Context Menu Functions
  const getCanvasContextMenuItems = () => {
    const items = [
      {
        label: 'Paste',
        icon: 'paste',
        action: () => {
          pasteElement();
        },
        disabled: !clipboardData,
        shortcut: 'Ctrl+V'
      },
      { type: 'separator' },
      {
        label: 'Add Text',
        icon: 'edit',
        action: () => {
          handleTextSelect({ content: 'New Text', fontSize: 24, color: '#000000' });
        }
      },
      {
        label: 'Add Shape',
        icon: 'layers',
        action: () => {
          handleElementSelect({ type: 'shape', shapeType: 'rectangle' });
        }
      },
      { type: 'separator' },
      {
        label: 'Page Properties',
        icon: 'properties',
        action: () => {
          setShowPagePropertiesDialog(true);
        }
      }
    ];

    // Add Group option when multiple items are selected
    if (selectedElements.length >= 2) {
      items.push(
        { type: 'separator' },
        {
          label: 'Group',
          icon: 'group',
          action: () => {
            const currentItems = template_content?.pages?.[currentPageIndex]?.items || [];
            const itemsToGroup = currentItems.filter(item => selectedElements.includes(item.id));
            if (itemsToGroup.length >= 2) {
              const { group, updatedItems } = createGroup(itemsToGroup, currentItems);
              if (group) {
                settemplate_content(prev => ({
                  ...prev,
                  pages: prev.pages.map((page, index) =>
                    index === currentPageIndex ? { ...page, items: updatedItems } : page
                  )
                }));
                setSelectedElement(group.id);
                setSelectedElements([]);
                markAsUnsaved();
              }
            }
          },
          shortcut: 'Ctrl+G'
        }
      );
    }

    return items;
  };

  const getItemContextMenuItems = (item) => {
    const isLocked = item?.locked;
    const isVisible = !item?.hidden;

    const menuItems = [
      {
        label: 'Copy',
        icon: 'copy',
        action: () => {
          copyElement(item.id);
        },
        shortcut: 'Ctrl+C'
      },
      {
        label: 'Cut',
        icon: 'cut',
        action: () => {
          cutElement(item.id);
        },
        shortcut: 'Ctrl+X'
      },
      {
        label: 'Duplicate',
        icon: 'duplicate',
        action: () => {
          duplicateElement(item.id);
        },
        shortcut: 'Ctrl+D'
      },
      { type: 'separator' }
    ];

    // Add PowerClip options
    if (!item.isPowerClipContainer && !powerClipMode) {
      menuItems.push({
        label: 'PowerClip Inside',
        icon: 'package',
        action: () => {
          startPowerClip(item.id);
        }
      });
    }

    if (powerClipMode && powerClipContent && item.type === 'shape') {
      menuItems.push({
        label: 'PowerClip Inside Me',
        icon: 'package',
        action: () => {
          applyPowerClip(item.id);
        }
      });
    }

    if (item.isPowerClipContainer) {
      menuItems.push({
        label: 'Edit PowerClip',
        icon: 'edit',
        action: () => {
          editPowerClip(item.id);
        }
      });
      menuItems.push({
        label: 'Extract PowerClip Contents',
        icon: 'arrowUpRight',
        action: () => {
          extractPowerClipContents(item.id);
        }
      });
    }

    // Add Ungroup option for group items
    if (item.type === 'group') {
      menuItems.push({
        label: 'Ungroup',
        icon: 'ungroup',
        action: () => {
          const currentItems = template_content?.pages?.[currentPageIndex]?.items || [];
          const updatedItems = ungroupItem(item, currentItems);
          settemplate_content(prev => ({
            ...prev,
            pages: prev.pages.map((page, index) =>
              index === currentPageIndex ? { ...page, items: updatedItems } : page
            )
          }));
          setSelectedElement(null);
          setEditingGroup(null);
          markAsUnsaved();
        },
        shortcut: 'Ctrl+Shift+G'
      });
    }

    menuItems.push(
      { type: 'separator' },
      {
        label: 'Move Up',
        icon: 'bringForward',
        action: () => {
          moveElementUp(item.id);
        }
      },
      {
        label: 'Move Down',
        icon: 'sendBackward',
        action: () => {
          moveElementDown(item.id);
        }
      },
      { type: 'separator' },
      {
        label: isLocked ? 'Unlock' : 'Lock',
        icon: isLocked ? 'unlock' : 'lock',
        action: () => {
          toggleElementLock(item.id);
        }
      },
      {
        label: isVisible ? 'Hide' : 'Show',
        icon: isVisible ? 'hide' : 'show',
        action: () => {
          toggleElementVisibility(item.id);
        }
      },
      { type: 'separator' },
      {
        label: 'Delete',
        icon: 'delete',
        action: () => {
          deleteElement(item.id);
        },
        danger: true,
        shortcut: 'Delete'
      }
    );

    return menuItems;
  };

  // Show loading state while template is loading
  if (isLoading || !template_content) {
    const urlParams = window.location.pathname.split('/')
    const template_idFromUrl = urlParams[urlParams.length - 1]
    const isLoadingSpecificTemplate = template_idFromUrl && template_idFromUrl !== 'editor' && template_idFromUrl.length > 5

    return (
      <div className="h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center bg-white rounded-xl shadow-lg p-8 max-w-md mx-4">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-200 border-t-blue-600 mx-auto mb-6"></div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            {isLoadingSpecificTemplate ? 'Loading Template' : 'Initializing Editor'}
          </h2>
          <p className="text-gray-600 mb-4">
            {isLoadingSpecificTemplate
              ? `Loading template configuration for ID: ${template_idFromUrl}`
              : 'Setting up your design workspace...'
            }
          </p>
          <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
            <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
            <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="h-screen flex flex-col bg-gray-100 overflow-hidden">
      {/* Top Navigation */}
      <EditorNavigation
        // File menu props
        showFileMenu={showFileMenu}
        setShowFileMenu={setShowFileMenu}
        handleSave={handleSave}
        navigate={navigate}
        handleDownload={handleDownload}
        template_content={template_content}
        settemplate_content={settemplate_content}
        setHasUnsavedChanges={setHasUnsavedChanges}
        templateAPI={templateAPI}
        templateMetadata={templateMetadata}

        // Import menu props
        showImportMenu={showImportMenu}
        setShowImportMenu={setShowImportMenu}
        handleImportPDF={handleImportPDF}
        handleImportPSD={handleImportPSD}
        handleImportPowerPoint={handleImportPowerPoint}
        handleImportCDR={handleImportCDR}
        handleImportLegacyPlatform={handleImportLegacyPlatform}

        // Grid and settings props
        showGrid={showGrid}
        setShowGrid={setShowGrid}
        showMouseCoords={showMouseCoords}
        setShowMouseCoords={setShowMouseCoords}
        showPropertiesBarAtBottom={showPropertiesBarAtBottom}
        setShowPropertiesBarAtBottom={setShowPropertiesBarAtBottom}
        showVideoExportProgress={showVideoExportProgress}
        setShowVideoExportProgress={setShowVideoExportProgress}
        showRulers={showRulers}
        setShowRulers={setShowRulers}
        showFooterBar={showFooterBar}
        setShowFooterBar={setShowFooterBar}
        isFullscreen={isFullscreen}
        setIsFullscreen={setIsFullscreen}

        // Undo/Redo props
        undo={undo}
        redo={redo}
        historyIndex={historyIndex}
        history={history}

        // Save props
        saveTemplate={handleSave}
        isSaving={isSaving}
        isSaved={isSaved}
        hasUnsavedChanges={hasUnsavedChanges}

        // PowerClip props
        powerClipMode={powerClipMode}
        setPowerClipMode={setPowerClipMode}
        setPowerClipContent={setPowerClipContent}

        // Share props
        showShareDialog={showShareDialog}
        setShowShareDialog={setShowShareDialog}
        shareDropdownRef={shareDropdownRef}
        copyLinkToClipboard={copyLinkToClipboard}
        handleDownloadCurrent={handleDownloadCurrent}
        handleDownloadFull={handleDownloadFull}
        handleTifDownloadCurrent={handleTifDownloadCurrent}
        handleTifDownloadFull={handleTifDownloadFull}
        handleDownloadCurrentWithColorMode={handleDownloadCurrentWithColorMode}
        handleDownloadFullWithColorMode={handleDownloadFullWithColorMode}
        downloadingStates={downloadingStates}
        onUploadClick={() => setShowPhotoUploadDialog(true)}
        handleVideoExport={handleVideoExport}
        isExportingVideo={isExportingVideo}
        showVideoExportDialog={showVideoExportDialog}
        setShowVideoExportDialog={setShowVideoExportDialog}

        // Alter Video Duration (global time scaling)
        setShowDurationScaleDialog={setShowDurationScaleDialog}

        // Bulk AI Image Generate
        onBulkGenerateAIImages={bulkGenerateAIImages}

        // Export Progress panel toggle (adjacent to Export button)
        isExportProgressExpanded={isExportProgressExpanded}
        onToggleExportProgress={() => setIsExportProgressExpanded(v => !v)}
        exportProgressJobCount={exportProgressJobs.length}
        exportProgressActiveCount={exportProgressJobs.filter(j => ['starting', 'processing', 'queued', 'pending'].includes(String(j.status).toLowerCase())).length}

        // Template rename (inline edit in the toolbar)
        onRenameTemplate={handleRenameTemplate}
        // Note: auto-fit after resize is handled by an effect in WorkspacePage that
        // watches page dimension changes, so no explicit onAfterResize wiring is needed.

        // Resize props
        currentPageIndex={currentPageIndex}
        currentPage={currentPage}

        // Action menu props
        showActionMenu={showActionMenu}
        setShowActionMenu={setShowActionMenu}
        handleMakePrivate={handleMakePrivate}
        handleMakePublic={handleMakePublic}
        handleGenerateSample={handleGenerateSample}
        handleApprove={handleApprove}
        handleReject={handleReject}
        handleCloneAndOpen={handleCloneAndOpen}
        handleTriggerSync={handleTriggerSync}
        isAdmin={isAdmin}

        // View menu props
        showViewMenu={showViewMenu}
        setShowViewMenu={setShowViewMenu}
        handleGenerate9Samples={handleGenerate9Samples}
        showSampleGenerationDialog={showSampleGenerationDialog}
        setShowSampleGenerationDialog={setShowSampleGenerationDialog}
        showPastSamplesDialog={showPastSamplesDialog}
        setShowPastSamplesDialog={setShowPastSamplesDialog}
        showAiQueueDialog={showAiQueueDialog}
        setShowAiQueueDialog={setShowAiQueueDialog}
      />

      {/* Properties Bar (shown when element or audio track is selected) */}
      {(selectedElement || selectedAudioTrack !== null) && (() => {
        // Find element - could be regular element, PowerClip content, or audio track
        let element = currentPage?.items?.find(item => item.id === selectedElement)
        let isEditingPowerClipContent = false
        let powerClipContainer = null

        // If not found as regular element, check PowerClip contents
        if (!element && selectedElement) {
          for (const item of currentPage?.items || []) {
            if (item.isPowerClipContainer && item.powerClipContents) {
              const foundContent = item.powerClipContents.find(content => content.id === selectedElement)
              if (foundContent) {
                element = foundContent
                isEditingPowerClipContent = true
                powerClipContainer = item
                break
              }
            }
          }
        }

        // If no element found but audio track is selected, find the audio item
        if (!element && selectedAudioTrack !== null) {
          const nonVisualItems = currentPage?.items?.filter(item => item.isVisual === false) || []
          element = nonVisualItems[selectedAudioTrack]
        }

        if (!element) return null

        return (
          <div className="fixed right-0 top-0 h-full w-80 bg-white border-l border-gray-200 shadow-lg z-[1000] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold capitalize">
                {element.type === 'text' ? 'Text' : 
                 element.type === 'image' ? 'Image' :
                 element.type === 'video' ? 'Video' :
                 element.type === 'shape' ? 'Shape' :
                 element.type === 'svg-graphic' ? 'SVG' :
                 element.type === 'svg' ? 'SVG' :
                 element.type === 'drawing' ? 'Drawing' :
                 element.type === 'freehand' ? 'Freehand' :
                 element.type === 'tts' ? 'TTS' :
                 element.type === 'audio' ? 'Audio' :
                 element.type === 'sound-effect' ? 'Sound Effect' :
                 element.type} Properties
              </h2>
              <button
                onClick={() => {
                  setSelectedElement(null)
                  setSelectedAudioTrack(null)
                }}
                className="p-1 hover:bg-gray-100 rounded"
                title="Close Properties"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-4 space-y-4">

              {/* Common Element Properties (Layers and Timeline) */}
              <CommonElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                templateType={template_content?.type || template_content?.mediaType}
              />

              {/* Image Element Properties */}
              <ImageElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                currentPage={currentPage}
              />

              {/* Video Element Properties */}
              <VideoElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                currentPage={currentPage}
              />

              {/* Image Filters Button for Images */}
              {element.type === 'image' && (
                <div className="mt-2">
                  <button
                    onClick={() => setActiveSecondarySidebar('filters')}
                    className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-500 to-teal-500 text-white rounded-lg hover:from-green-600 hover:to-teal-600 transition-all duration-200 shadow-md hover:shadow-lg w-full justify-center"
                  >
                    <Sliders className="w-4 h-4" />
                    <span className="font-medium">Image Filters</span>
                  </button>
                </div>
              )}

              {/* Text Element Properties */}
              <TextElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                showAdvancedTextProperties={showAdvancedTextProperties}
                splitTextIntoWords={splitTextIntoWords}
                splitTextIntoCharacters={splitTextIntoCharacters}
                currentPage={currentPage}
                onOpenFontsSidebar={handleOpenFontsSidebar}
                onOpenAnimatePanel={() => setShowAnimateSecondaryBar(true)}
              />

              {/* TTS Element Properties */}
              <TTSElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                currentPage={currentPage}
              />

              {/* Audio Element Properties */}
              <AudioElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                currentPage={currentPage}
                templateType={(template_content?.type || template_content?.mediaType)}
              />

              {/* Animate + Motion + Effects buttons (text, shape, image items). */}
              {(((template_content?.type || template_content?.mediaType) === 'video') || ['text', 'shape', 'image'].includes(element.type)) && (
                <div className="mt-2 flex items-center gap-2 flex-wrap">
                  {((template_content?.type || template_content?.mediaType) === 'video') && (
                    <button
                      onClick={() => setShowAnimateSecondaryBar(true)}
                      className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg hover:from-purple-600 hover:to-blue-600 transition-all duration-200 shadow-md hover:shadow-lg"
                    >
                      <Wrench className="w-4 h-4" />
                      <span className="font-medium">Animate</span>
                    </button>
                  )}
                  {/* Motion is general (not video-only); applies to text, shape and image items. */}
                  {['text', 'shape', 'image'].includes(element.type) && (
                    <button
                      onClick={() => setShowMotionSecondaryBar(true)}
                      className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-indigo-500 to-fuchsia-500 text-white rounded-lg hover:from-indigo-600 hover:to-fuchsia-600 transition-all duration-200 shadow-md hover:shadow-lg"
                    >
                      <Wrench className="w-4 h-4" />
                      <span className="font-medium">Motion</span>
                    </button>
                  )}
                  {/* Effects (always-on styling) applies to text, shape and image items. */}
                  {['text', 'shape', 'image'].includes(element.type) && (
                    <button
                      onClick={() => setShowTextEffectsSecondaryBar(true)}
                      className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-fuchsia-500 to-pink-500 text-white rounded-lg hover:from-fuchsia-600 hover:to-pink-600 transition-all duration-200 shadow-md hover:shadow-lg"
                    >
                      <Wrench className="w-4 h-4" />
                      <span className="font-medium">Effects</span>
                    </button>
                  )}
                </div>
              )}

              {/* Image color grade / Ken Burns / transition controls */}
              {element.type === 'image' && (
                <div className="mt-2">
                  <ImageEffectsPanel
                    element={element}
                    selectedElement={selectedElement}
                    updateElementProperty={updateElementProperty}
                  />
                </div>
              )}

              {/* Motion properties (shown when a motion is applied to text/shape/image) */}
              {['text', 'shape', 'image'].includes(element.type) && element.motion && (
                <div className="mt-2">
                  <MotionPropertiesPanel
                    element={element}
                    selectedElement={selectedElement}
                    updateElementProperty={updateElementProperty}
                  />
                </div>
              )}

              {/* Effects properties (shown when effects are applied to text/shape/image) */}
              {['text', 'shape', 'image'].includes(element.type) && Array.isArray(element.textEffects) && element.textEffects.length > 0 && (
                <div className="mt-2">
                  <TextEffectsPropertiesPanel
                    element={element}
                    selectedElement={selectedElement}
                    updateElementProperty={updateElementProperty}
                  />
                </div>
              )}

              {/* Shape Element Properties */}
              <ShapeElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                currentPage={currentPage}
              />

              {/* Shape geometry controls (deform / border / repeater / morph) */}
              {element.type === 'shape' && (
                <div className="mt-2">
                  <ShapeEffectsPanel
                    element={element}
                    selectedElement={selectedElement}
                    updateElementProperty={updateElementProperty}
                  />
                </div>
              )}

              {/* Freehand Element Properties */}
              <FreehandElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                currentPage={currentPage}
              />

              {/* Graphics Element Properties */}
              <GraphicsElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                currentPage={currentPage}
              />

              {/* SVG (inline svgContent) Element Properties */}
              <SvgElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                currentPage={currentPage}
              />

              <MaskElementProperties
                element={element}
                selectedElement={selectedElement}
                updateElementProperty={updateElementProperty}
                openMaskLibrary={openMaskLibrary}
                startMaskContentPicker={startMaskContentPicker}
              />

              {/* PowerClip and Advanced Controls - Show for all elements */}
              <PowerClipAdvancedControls
                element={element}
                powerClipMode={powerClipMode}
                powerClipContent={powerClipContent}
                showAdvancedTextProperties={showAdvancedTextProperties}
                setShowAdvancedTextProperties={setShowAdvancedTextProperties}
                startPowerClip={startPowerClip}
                applyPowerClip={applyPowerClip}
                editPowerClip={editPowerClip}
                extractPowerClipContents={extractPowerClipContents}
              />

              {/* PowerClip Contents List - Show for PowerClip containers (only when editing) */}
              {element.isPowerClipContainer && element.powerClipContents && element.powerClipContents.length > 0 && editingPowerClip === element.id && (
                <div className="border-t border-gray-200 pt-3 mt-3">
                  <div className="mb-3 flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-700">PowerClip Contents ({element.powerClipContents.length}):</span>
                    <button
                      onClick={() => finishEditingPowerClip()}
                      className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100 transition-colors"
                    >
                      Done
                    </button>
                  </div>
                  <div className="space-y-2 max-h-96 overflow-y-auto">
                    {element.powerClipContents
                      .slice()
                      .sort((a, b) => (a.layer || 0) - (b.layer || 0))
                      .map((content, index) => {
                        // Helper function to render preview thumbnail
                        const renderPowerClipPreview = (item) => {
                          const imageUrl = item.src || item.url || item.image_url || item.sample_url
                          if (item.type === 'image' && imageUrl) {
                            return (
                              <div className="w-16 h-16 rounded border overflow-hidden bg-gray-100 flex-shrink-0">
                                <img
                                  src={imageUrl}
                                  alt="Preview"
                                  className="w-full h-full object-cover"
                                  onError={(e) => {
                                    // Try fallback URLs if primary src fails
                                    const fallbackUrl = item.url || item.image_url || item.sample_url
                                    if (fallbackUrl && e.target.src !== fallbackUrl) {
                                      e.target.src = fallbackUrl
                                    } else {
                                      e.target.style.display = 'none';
                                      e.target.nextSibling.style.display = 'flex';
                                    }
                                  }}
                                />
                                <div className="w-full h-full bg-gray-200 items-center justify-center text-gray-500 text-xs hidden">
                                  🖼️
                                </div>
                              </div>
                            );
                          }
                          if (item.type === 'video' && (item.thumbnail || item.poster)) {
                            return (
                              <div className="w-16 h-16 rounded border overflow-hidden bg-gray-100 flex-shrink-0 relative">
                                <img
                                  src={item.thumbnail || item.poster}
                                  alt="Video preview"
                                  className="w-full h-full object-cover"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <div className="w-full h-full bg-gray-200 items-center justify-center text-gray-500 text-xs hidden">
                                  🎥
                                </div>
                                <div className="absolute inset-0 flex items-center justify-center">
                                  <div className="w-4 h-4 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
                                    <div className="w-0 h-0 border-l-[6px] border-l-white border-y-[4px] border-y-transparent ml-0.5"></div>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                          if (item.type === 'shape') {
                            const shapeType = item.shapeType || 'rectangle';
                            const fill = item.fill || '#3B82F6';
                            return (
                              <div className="w-16 h-16 rounded border bg-gray-50 flex items-center justify-center flex-shrink-0">
                                <div
                                  className="w-10 h-10 rounded-sm"
                                  style={{
                                    backgroundColor: fill,
                                    borderRadius: shapeType === 'circle' ? '50%' :
                                                 shapeType === 'triangle' ? '0' : '4px'
                                  }}
                                />
                              </div>
                            );
                          }
                          if (item.type === 'text') {
                            const contentText = item.content || 'Text';
                            return (
                              <div className="w-16 h-16 rounded border bg-gray-50 flex items-center justify-center flex-shrink-0 p-2">
                                <span className="text-xs font-medium text-blue-600 text-center line-clamp-2" title={contentText}>
                                  {contentText.length > 20 ? contentText.substring(0, 20) + '...' : contentText}
                                </span>
                              </div>
                            );
                          }
                          // Default icon
                          const getIcon = () => {
                            switch (item.type) {
                              case 'text': return '📝';
                              case 'image': return '🖼️';
                              case 'video': return '🎥';
                              case 'audio': return '🎵';
                              case 'shape': return '🔷';
                              case 'graphic': return '⭐';
                              default: return '📄';
                            }
                          };
                          return (
                            <div className="w-16 h-16 rounded border bg-gray-100 flex items-center justify-center text-2xl flex-shrink-0">
                              {getIcon()}
                            </div>
                          );
                        };

                        return (
                      <div
                        key={content.id}
                        className={`p-3 rounded-lg border transition-all ${
                          selectedElement === content.id
                            ? 'bg-blue-50 border-blue-300 shadow-sm'
                            : 'bg-white border-gray-200 hover:border-gray-300 hover:shadow-sm'
                        }`}
                      >
                        <div className="flex items-start gap-3 mb-2">
                          {/* Preview Thumbnail */}
                          <div className="flex-shrink-0">
                            {renderPowerClipPreview(content)}
                          </div>
                          
                          <div className="flex-1 min-w-0">
                            <div className="flex items-start justify-between mb-2">
                              <div 
                                className="flex-1 cursor-pointer"
                                onClick={() => {
                                  setSelectedElement(content.id)
                                }}
                              >
                                <div className="flex items-center space-x-2 mb-1">
                                  <div className={`w-2 h-2 rounded-full ${
                                    content.isPowerClipContainer ? 'bg-purple-500' : 'bg-green-500'
                                  }`}></div>
                                  <span className="font-medium text-sm text-gray-900">
                                    {content.name || content.content || `${content.type} ${index + 1}`}
                                  </span>
                                  {content.isPowerClipContainer && (
                                    <span className="text-purple-600 text-xs font-bold" title="Nested PowerClip Container">
                                      📦
                                    </span>
                                  )}
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500 ml-4">
                                  <span className="capitalize">{content.type}</span>
                                  <span>•</span>
                                  <span>{Math.round(content.width || 0)} × {Math.round(content.height || 0)}</span>
                                  {content.isPowerClipContainer && content.powerClipContents && (
                                    <>
                                      <span>•</span>
                                      <span className="text-purple-600" title={`Contains ${content.powerClipContents.length} nested items`}>
                                        +{content.powerClipContents.length} items
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation()
                                  if (window.confirm(`Delete ${content.name || content.type} from PowerClip?`)) {
                                    deletePowerClipContent(element.id, content.id)
                                  }
                                }}
                                className="ml-2 p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded transition-colors flex-shrink-0"
                                title="Delete item"
                              >
                                <X className="w-4 h-4" />
                              </button>
                            </div>
                            
                            {/* Layer Control */}
                            <div className="flex items-center space-x-2 mt-2 pt-2 border-t border-gray-100">
                              <label className="text-xs text-gray-600 font-medium min-w-[60px]">Layer:</label>
                              <div className="flex items-center space-x-1 flex-1">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    const currentLayer = content.layer || 0
                                    updatePowerClipContentLayer(element.id, content.id, Math.max(0, currentLayer - 1))
                                  }}
                                  className="p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded transition-colors"
                                  title="Decrease layer (move back)"
                                >
                                  <ChevronDown className="w-3 h-3" />
                                </button>
                                <input
                                  type="number"
                                  value={content.layer || 0}
                                  onChange={(e) => {
                                    const newLayer = parseInt(e.target.value) || 0
                                    updatePowerClipContentLayer(element.id, content.id, newLayer)
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  className="w-16 px-2 py-1 text-xs text-center border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  min="0"
                                />
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    const currentLayer = content.layer || 0
                                    updatePowerClipContentLayer(element.id, content.id, currentLayer + 1)
                                  }}
                                  className="p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded transition-colors"
                                  title="Increase layer (move forward)"
                                >
                                  <ChevronUp className="w-3 h-3" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        );
                      })}
                  </div>
                  <div className="mt-3 text-xs text-gray-500 bg-blue-50 p-2 rounded border border-blue-200">
                    💡 Click an item to select it. Use layer controls to change stacking order. Items are sorted by layer in this list.
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      })()}

      {/* PowerClip Edit Mode Finish Button - Top Left Corner */}
      {editingPowerClip && (
        <div className="fixed top-10 left-10 z-[900]">
          <button
            onClick={() => {
              setEditingPowerClip(null)
            }}
            className="flex items-center space-x-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg font-medium transition-colors"
          >
            <Check className="w-4 h-4" />
            <span>Finish PowerClip Edit</span>
          </button>
        </div>
      )}

      {/* Drawing Toolbar - Top Center */}
      {drawingMode && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[900]">
          <div className="bg-white border border-gray-300 rounded-lg shadow-lg p-4 flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <span className="text-sm font-medium text-gray-700">
                {drawingMode === 'pen' ? 'Pen' : drawingMode === 'marker' ? 'Marker' : drawingMode === 'highlighter' ? 'Highlighter' : drawingMode === 'line' ? 'Line' : drawingMode === 'eraser' ? 'Eraser' : 'Drawing'}
              </span>
              <button
                onClick={() => setDrawingMode(null)}
                className="p-1 hover:bg-gray-100 rounded"
                title="Exit drawing mode"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            {(drawingMode === 'pen' || drawingMode === 'marker' || drawingMode === 'highlighter' || drawingMode === 'line') && (
              <>
                <div className="flex items-center space-x-2">
                  <label className="text-sm text-gray-600">Color:</label>
                  <input
                    type="color"
                    value={brushColor}
                    onChange={(e) => setBrushColor(e.target.value)}
                    className="w-8 h-8 border border-gray-300 rounded cursor-pointer"
                  />
                </div>

                <div className="flex items-center space-x-2">
                  <label className="text-sm text-gray-600">Size:</label>
                  <input
                    type="range"
                    min="1"
                    max="50"
                    value={brushSize}
                    onChange={(e) => setBrushSize(parseInt(e.target.value))}
                    className="w-20"
                  />
                  <span className="text-sm text-gray-500 w-8">{brushSize}px</span>
                </div>

                {drawingMode !== 'line' && (
                  <div className="flex items-center space-x-2">
                    <label className="text-sm text-gray-600">Opacity:</label>
                    <input
                      type="range"
                      min="0.1"
                      max="1"
                      step="0.1"
                      value={brushOpacity}
                      onChange={(e) => setBrushOpacity(parseFloat(e.target.value))}
                      className="w-20"
                    />
                    <span className="text-sm text-gray-500 w-8">{Math.round(brushOpacity * 100)}%</span>
                  </div>
                )}
              </>
            )}

            {drawingMode === 'eraser' && (
              <div className="flex items-center space-x-2">
                <label className="text-sm text-gray-600">Size:</label>
                <input
                  type="range"
                  min="5"
                  max="100"
                  value={brushSize}
                  onChange={(e) => setBrushSize(parseInt(e.target.value))}
                  className="w-20"
                />
                <span className="text-sm text-gray-500 w-8">{brushSize}px</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Workspace rulers will now be rendered inside the workspace scroll area (see below) */}

      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar */}
        <div className="w-16 sm:w-24 md:w-32 bg-gray-800 text-white flex flex-col py-[5.6px] sm:py-[11.2px] px-1 sm:px-2">
          {/* Two-column grid layout for tools */}
          <div className="grid grid-cols-2 gap-1 sm:gap-2">
            {/* Templates */}
          <button
            onClick={() => toggleSecondarySidebar('templates')}
              className={`flex flex-col items-center p-1 sm:p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'templates' ? 'bg-gray-700' : ''}`}
          >
              <FileText className="w-[9.6px] h-[9.6px] sm:w-[12.8px] sm:h-[12.8px] md:w-4 md:h-4 mb-0.5 sm:mb-1" />
              <span className="text-xs text-center leading-tight hidden sm:block">Templates</span>
              <span className="text-xs text-center leading-tight sm:hidden">Tmpl</span>
          </button>

            {/* Items List */}
          <button
            onClick={() => toggleSecondarySidebar('items')}
              className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'items' ? 'bg-gray-700' : ''}`}
          >
              <List className="w-4 h-4 mb-1" />
              <span className="text-xs text-center leading-tight">Items</span>
          </button>

            {/* Photos */}
          <button
            onClick={() => toggleSecondarySidebar('photos')}
              className={`flex flex-col items-center p-1 sm:p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'photos' ? 'bg-gray-700' : ''}`}
          >
              <Image className="w-[9.6px] h-[9.6px] sm:w-[12.8px] sm:h-[12.8px] md:w-4 md:h-4 mb-0.5 sm:mb-1" />
              <span className="text-xs text-center leading-tight hidden sm:block">Photos</span>
          </button>

            {/* Elements */}
          <button
            onClick={() => toggleSecondarySidebar('elements')}
              className={`flex flex-col items-center p-1 sm:p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'elements' ? 'bg-gray-700' : ''}`}
          >
              <div className="w-[9.6px] h-[9.6px] sm:w-[12.8px] sm:h-[12.8px] md:w-4 md:h-4 border-2 border-white rounded mb-0.5 sm:mb-1"></div>
              <span className="text-xs text-center leading-tight hidden sm:block">Elements</span>
          </button>

            {/* Text */}
          <button
            onClick={() => toggleSecondarySidebar('text')}
              className={`flex flex-col items-center p-1 sm:p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'text' ? 'bg-gray-700' : ''}`}
          >
              <Type className="w-[9.6px] h-[9.6px] sm:w-[12.8px] sm:h-[12.8px] md:w-4 md:h-4 mb-0.5 sm:mb-1" />
              <span className="text-xs text-center leading-tight hidden sm:block">Text</span>
          </button>

            {/* Graphics */}
          <button
            onClick={() => toggleSecondarySidebar('graphics')}
              className={`flex flex-col items-center p-1 sm:p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'graphics' ? 'bg-gray-700' : ''}`}
          >
              <Shapes className="w-[9.6px] h-[9.6px] sm:w-[12.8px] sm:h-[12.8px] md:w-4 md:h-4 mb-0.5 sm:mb-1" />
              <span className="text-xs text-center leading-tight hidden sm:block">Graphics</span>
          </button>

            {/* Clipart */}
          <button
            onClick={() => toggleSecondarySidebar('clipart')}
              className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'clipart' ? 'bg-gray-700' : ''}`}
          >
              <svg className="w-4 h-4 mb-1" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
            </svg>
              <span className="text-xs text-center leading-tight">Clipart</span>
          </button>

            {/* Category Fields */}
          <button
            onClick={() => toggleSecondarySidebar('categoryFields')}
              className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'categoryFields' ? 'bg-gray-700' : ''}`}
          >
              <Tag className="w-4 h-4 mb-1" />
              <span className="text-xs text-center leading-tight">Fields</span>
          </button>

            {/* Audio (video mode only) */}
          {((template_content?.type || template_content?.mediaType) === 'video') && (
            <button
              onClick={() => toggleSecondarySidebar('audio')}
                className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'audio' ? 'bg-gray-700' : ''}`}
            >
                <Volume2 className="w-4 h-4 mb-1" />
                <span className="text-xs text-center leading-tight">Audio</span>
            </button>
          )}

            {/* Sound Effects (video mode only) */}
          {((template_content?.type || template_content?.mediaType) === 'video') && (
            <button
              onClick={() => toggleSecondarySidebar('sound-effects')}
                className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'sound-effects' ? 'bg-gray-700' : ''}`}
            >
                <Zap className="w-4 h-4 mb-1" />
                <span className="text-xs text-center leading-tight">SFX</span>
            </button>
          )}

            {/* Video (video mode only) */}
          {((template_content?.type || template_content?.mediaType) === 'video') && (
            <button
              onClick={() => toggleSecondarySidebar('video')}
                className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'video' ? 'bg-gray-700' : ''}`}
            >
                <svg className="w-4 h-4 mb-1" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17 10.5V7a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h12a1 1 0 001-1v-3.5l4 4v-11l-4 4z"/>
                </svg>
                <span className="text-xs text-center leading-tight">Video</span>
            </button>
          )}

            {/* TTS (video mode only) */}
          {((template_content?.type || template_content?.mediaType) === 'video') && (
            <button
              onClick={() => toggleSecondarySidebar('tts')}
                className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'tts' ? 'bg-gray-700' : ''}`}
            >
                <Type className="w-4 h-4 mb-1" />
                <span className="text-xs text-center leading-tight">TTS</span>
            </button>
          )}

            {/* Filters */}
          <button
            onClick={() => toggleSecondarySidebar('filters')}
              className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'filters' ? 'bg-gray-700' : ''}`}
          >
              <Filter className="w-4 h-4 mb-1" />
              <span className="text-xs text-center leading-tight">Filters</span>
          </button>

          

            {/* Item Effects & Motions */}
          <button
            onClick={() => toggleSecondarySidebar('effects')}
              className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'effects' ? 'bg-gray-700' : ''}`}
          >
              <Sparkles className="w-4 h-4 mb-1" />
              <span className="text-xs text-center leading-tight">Item Effects</span>
          </button>

            {/* Adjustment Layers (video mode only) */}
          {((template_content?.type || template_content?.mediaType) === 'video') && (
            <button
              onClick={() => toggleSecondarySidebar('adjustment-layers')}
                className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'adjustment-layers' ? 'bg-gray-700' : ''}`}
            >
                <Layers className="w-4 h-4 mb-1" />
                <span className="text-xs text-center leading-tight">Adj Layers</span>
            </button>
          )}

            {/* Video Overlays (video mode only) */}
          {((template_content?.type || template_content?.mediaType) === 'video') && (
            <button
              onClick={() => toggleSecondarySidebar('video-overlays')}
                className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'video-overlays' ? 'bg-gray-700' : ''}`}
            >
                <Layers className="w-4 h-4 mb-1" />
                <span className="text-xs text-center leading-tight">Overlays</span>
            </button>
          )}

            {/* Freehand Drawing */}
          <button
            onClick={() => {
              setFreehandToolActive(!freehandToolActive)
              if (!freehandToolActive) {
                // Deactivate other tools
                setDrawingMode(null)
                setSelectedElement(null)
                toggleSecondarySidebar('freehand')
              } else {
                setActiveSecondarySidebar(null)
              }
            }}
              className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${freehandToolActive ? 'bg-gray-700' : ''}`}
          >
              <PenTool className="w-4 h-4 mb-1" />
              <span className="text-xs text-center leading-tight">Draw</span>
          </button>


            {/* History */}
          <button
            onClick={() => toggleSecondarySidebar('history')}
              className={`flex flex-col items-center p-2 hover:bg-gray-700 rounded transition-colors ${activeSecondarySidebar === 'history' ? 'bg-gray-700' : ''}`}
          >
              <History className="w-4 h-4 mb-1" />
              <span className="text-xs text-center leading-tight">History</span>
          </button>
          </div>
        </div>

        {/* Vertical ruler moved inside workspace scroll area (see below) */}

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col relative" ref={workspaceRef}>
          {/* Fixed Rulers */}
          <Rulers
            zoomLevel={zoomLevel}
            currentPageIndex={currentPageIndex}
            template_content={template_content}
            workspaceSize={workspaceSize}
            scrollPosition={scrollPosition}
            showRulers={showRulers}
          />

          {/* Canvas Area - Scrollable workspace */}
          <div
            ref={scrollAreaRef}
            className="flex-1 bg-gray-200 overflow-auto canvas-area relative"
            style={{ marginTop: showRulers ? '20px' : '0px', marginLeft: showRulers ? '20px' : '0px' }}
            onScroll={(e) => {
              setScrollPosition({
                x: e.target.scrollLeft,
                y: e.target.scrollTop
              })
            }}
            onMouseMove={(e) => {
              handleMouseMove(e)
              if (showMouseCoords) {
                if (canvasRef.current) {
                  const rect = canvasRef.current.getBoundingClientRect()
                  const scale = zoomLevel / 100

                  // Calculate page coordinates (relative to page)
                  const pageX = Math.round((e.clientX - rect.left) / scale)
                  const pageY = Math.round((e.clientY - rect.top) / scale)
                  setMouseCoords({ x: pageX, y: pageY })

                  // Calculate workspace coordinates (relative to workspace)
                  const workspaceRect = workspaceRef.current?.getBoundingClientRect()
                  if (workspaceRect) {
                    const workspaceX = Math.round((e.clientX - workspaceRect.left) / scale)
                    const workspaceY = Math.round((e.clientY - workspaceRect.top) / scale)
                    setWorkspaceMouseCoords({ x: workspaceX, y: workspaceY })
                  }
                }
              }
            }}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onClick={(e) => {
              // Handle text editing exit first
              handleWorkspaceClick(e)

              // Deselect when clicking on blank workspace (outside any element)
              const clickedElement = e.target.closest('[data-element-id]')
              if (!clickedElement) {
                setSelectedElement(null)
                setSelectedElements([])
              }
            }}
          >
            {/* Freehand Drawing Overlay - Positioned to cover entire canvas area */}
            {freehandToolActive && (
              <div
                className="absolute inset-0 z-50 pointer-events-auto"
                style={{
                  width: '100%',
                  height: '100%'
                }}
              >
                <FreehandComponent
                  isActive={freehandToolActive}
                  canvasSize={{
                    width: scrollAreaRef.current?.scrollWidth || 2000,
                    height: scrollAreaRef.current?.scrollHeight || 2000
                  }}
                  config={{
                    snap: {
                      enabled: true,
                      grid: showGrid,
                      angles: true,
                      objects: true,
                      tolerance: 8,
                      angleStep: 45
                    },
                    smoothing: {
                      enabled: true,
                      tolerance: 2.0,
                      maxError: 2.0,
                      minDistance: 2,
                      minTime: 8
                    },
                    defaultStroke: freehandStrokeStyle,
                    showHandles: true,
                    showNodes: true,
                    autoClose: true,
                    closeThreshold: 10
                  }}
                  onPathCreated={(path) => {
                    console.log('Path created:', path)
                  }}
                  onPathUpdated={(path) => {
                    console.log('Path updated:', path)
                  }}
                  onPathFinished={(path) => {
                    console.log('Path finished:', path)

                    // Calculate bounding box for the path
                    if (!path.nodes || path.nodes.length === 0) return;

                    // Get page position within canvas to transform coordinates
                    const canvasRect = scrollAreaRef.current?.getBoundingClientRect();
                    const pageRect = canvasRef.current?.getBoundingClientRect();

                    let pageOffsetX = 0;
                    let pageOffsetY = 0;

                    if (canvasRect && pageRect) {
                      // Calculate the page's position relative to the canvas area
                      pageOffsetX = (pageRect.left - canvasRect.left) + scrollAreaRef.current.scrollLeft;
                      pageOffsetY = (pageRect.top - canvasRect.top) + scrollAreaRef.current.scrollTop;

                      // Account for zoom scaling
                      const scale = zoomLevel / 100;
                      pageOffsetX = pageOffsetX / scale;
                      pageOffsetY = pageOffsetY / scale;
                    }

                    // Transform path coordinates from canvas space to page space
                    const transformedNodes = path.nodes.map(node => ({
                      ...node,
                      p: {
                        x: node.p.x - pageOffsetX,
                        y: node.p.y - pageOffsetY
                      },
                      h1: node.h1 ? {
                        x: node.h1.x - pageOffsetX,
                        y: node.h1.y - pageOffsetY
                      } : node.h1,
                      h2: node.h2 ? {
                        x: node.h2.x - pageOffsetX,
                        y: node.h2.y - pageOffsetY
                      } : node.h2
                    }));

                    let minX = transformedNodes[0].p.x;
                    let minY = transformedNodes[0].p.y;
                    let maxX = transformedNodes[0].p.x;
                    let maxY = transformedNodes[0].p.y;

                    transformedNodes.forEach(node => {
                      minX = Math.min(minX, node.p.x);
                      minY = Math.min(minY, node.p.y);
                      maxX = Math.max(maxX, node.p.x);
                      maxY = Math.max(maxY, node.p.y);

                      // Include handle points for accurate bounds
                      if (node.h1) {
                        minX = Math.min(minX, node.h1.x);
                        minY = Math.min(minY, node.h1.y);
                        maxX = Math.max(maxX, node.h1.x);
                        maxY = Math.max(maxY, node.h1.y);
                      }
                      if (node.h2) {
                        minX = Math.min(minX, node.h2.x);
                        minY = Math.min(minY, node.h2.y);
                        maxX = Math.max(maxX, node.h2.x);
                        maxY = Math.max(maxY, node.h2.y);
                      }
                    });

                    const width = Math.max(10, maxX - minX + 20); // Add padding
                    const height = Math.max(10, maxY - minY + 20);

                    // Convert absolute coordinates to relative coordinates
                    const elementX = minX - 10; // Account for padding
                    const elementY = minY - 10;

                    const relativePath = {
                      ...path,
                      nodes: transformedNodes.map(node => ({
                        ...node,
                        p: {
                          x: node.p.x - elementX,
                          y: node.p.y - elementY
                        },
                        h1: node.h1 ? {
                          x: node.h1.x - elementX,
                          y: node.h1.y - elementY
                        } : undefined,
                        h2: node.h2 ? {
                          x: node.h2.x - elementX,
                          y: node.h2.y - elementY
                        } : undefined
                      }))
                    };

                    const currentPage = template_content.pages[currentPageIndex];

                    // Convert path to template element and add to current page
                    const pathElement = {
                      id: `freehand_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`,
                      type: 'freehand',
                      x: elementX,
                      y: elementY,
                      width: width,
                      height: height,
                      pathData: relativePath,
                      stroke: freehandStrokeStyle,
                      layer: Math.max(0, ...currentPage.items.map(item => item.layer || 0)) + 1
                    }

                    // Add to current page
                    settemplate_content(prev => ({
                      ...prev,
                      pages: prev.pages.map((page, index) =>
                        index === currentPageIndex
                          ? { ...page, items: [...page.items, pathElement] }
                          : page
                      )
                    }))

                    // Add to freehand paths list
                    setFreehandPaths(prev => [...prev, path])

                    // Select the newly created element
                    setSelectedElement(pathElement.id)
                  }}
                  zoom={zoomLevel / 100}
                  pan={{ x: 0, y: 0 }}
                />
              </div>
            )}

            <div className="flex flex-col items-center min-h-full" style={{ paddingTop: '200px', paddingBottom: '50px' }}>
              {/* Show only current page */}
              {template_content?.pages?.[currentPageIndex] && (() => {
                const _pw = template_content.pages[currentPageIndex].page_config?.width || 800
                const _ph = template_content.pages[currentPageIndex].page_config?.height || 600
                const _scale = zoomLevel / 100
                return (
                <div
                  key={template_content.pages[currentPageIndex].id}
                  className="relative"
                  style={{
                    // Reserve the SCALED footprint so the scroll area's content matches what
                    // is visible. CSS `transform: scale()` does NOT shrink the layout box, so
                    // without this a large page (e.g. 5000x5000) blows out the layout, hides
                    // the bottom toolbar, and breaks scrolling. With a sized wrapper +
                    // top-left origin, scroll + centering work for any page size (up to 15000).
                    width: `${_pw * _scale}px`,
                    height: `${_ph * _scale}px`,
                    flex: '0 0 auto',
                  }}
                >
                  <div
                    ref={canvasRef}
                    className="shadow-lg relative ring-2 ring-blue-500"
                    style={{
                      width: `${_pw}px`,
                      height: `${_ph}px`,
                      backgroundColor: template_content.pages[currentPageIndex].page_config?.backgroundColor || '#ffffff',
                      transform: `scale(${_scale})`,
                      transformOrigin: 'top left',
                      transition: 'transform 0.2s ease-in-out'
                    }}
                    onClick={(e) => {
                      // In PowerClip edit mode, prevent page switching
                      if (editingPowerClip) {
                        e.preventDefault()
                        e.stopPropagation()
                        return
                      }

                      // Check if click was on an empty area (not on any element)
                      const clickedElement = e.target.closest('[data-element-id]')
                      if (!clickedElement) {
                        // If in group editing mode, exit editing mode and deselect
                        if (editingGroup) {
                          setEditingGroup(null)
                          setSelectedElement(null)
                          return
                        }
                        // Deselect any selected element when clicking on empty canvas area
                        setSelectedElement(null)
                        return
                      }

                      // If in group editing mode and clicking on an element outside the group, exit editing mode
                      if (editingGroup && clickedElement) {
                        const clickedId = clickedElement.getAttribute('data-element-id')
                        const editingGroupItem = currentPage?.items?.find(item => item.id === editingGroup)
                        const isClickOnEditingGroup = clickedId === editingGroup
                        const isClickOnEditingGroupChild = editingGroupItem?.children?.some(child => child.id === clickedId)
                        if (!isClickOnEditingGroup && !isClickOnEditingGroupChild) {
                          setEditingGroup(null)
                          setSelectedElement(null)
                        }
                      }
                    }}
                    onMouseDown={(e) => {
                      // Handle drawing tools (now handled by DrawingCanvas overlay)
                      if (drawingMode === 'pen' || drawingMode === 'marker' || drawingMode === 'highlighter' || drawingMode === 'eraser') {
                        // Drawing is now handled by the DrawingCanvas overlay
                        return
                      }
                      if (drawingMode === 'line') {
                        e.preventDefault()
                        e.stopPropagation()
                        if (!canvasRef.current) return
                        const rect = canvasRef.current.getBoundingClientRect()
                        const scale = zoomLevel / 100
                        setLineStart({ x: (e.clientX - rect.left) / scale, y: (e.clientY - rect.top) / scale })
                        setIsDrawing(true)
                        setDrawingPath([])
                        return
                      }
                    }}
                    onContextMenu={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      // Check if right-click was on an element
                      const clickedElement = e.target.closest('[data-element-id]');
                      if (clickedElement) {
                        const elementId = clickedElement.getAttribute('data-element-id');
                        const element = currentPage?.items?.find(item => item.id === elementId);
                        if (element) {
                          showContextMenu(e, getItemContextMenuItems(element), 'item');
                          return;
                        }
                      }

                      // Show canvas context menu
                      showContextMenu(e, getCanvasContextMenuItems(), 'canvas');
                    }}
                  >
                    {/* Grid overlay (scaled to zoom) */}
                    {showGrid && (
                      <div
                        className="absolute inset-0 pointer-events-none"
                        style={{
                          backgroundImage:
                            'linear-gradient(to right, rgba(0,0,0,0.07) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.07) 1px, transparent 1px)',
                          backgroundSize: `${20 * (zoomLevel / 100)}px ${20 * (zoomLevel / 100)}px`,
                        }}
                      />
                    )}
                    {/* Canvas Content */}
                    <div className="relative w-full h-full">
                      {/* Removed background decorations for a clean blank page */}

                      {/* Drawing Canvas Overlay */}
                      <DrawingCanvas
                        drawingMode={drawingMode}
                        brushSize={brushSize}
                        brushColor={brushColor}
                        brushOpacity={brushOpacity}
                        width={template_content.pages[currentPageIndex].page_config?.width || 800}
                        height={template_content.pages[currentPageIndex].page_config?.height || 600}
                        zoom={zoomLevel / 100}
                        onStrokeComplete={({ points, tool, brushSize: size, brushColor: color, brushOpacity: opacity, width: cw, height: ch }) => {
                          // Convert points to SVG path and insert as item in current page
                          if (!points || points.length < 2) return
                          const minX = Math.min(...points.map(p => p.x))
                          const minY = Math.min(...points.map(p => p.y))
                          const maxX = Math.max(...points.map(p => p.x))
                          const maxY = Math.max(...points.map(p => p.y))
                          const w = Math.max(1, Math.round(maxX - minX))
                          const h = Math.max(1, Math.round(maxY - minY))
                          const pathData = `M ${points.map(p => `${Math.round(p.x - minX)},${Math.round(p.y - minY)}`).join(' L ')}`

                          const maxLayer = Math.max(0, ...currentPage?.items?.map(item => item.layer || 0) || [0])
                          const id = `drawing-${Date.now()}`
                          const drawing = {
                            id,
                            type: 'drawing',
                            x: Math.round(minX),
                            y: Math.round(minY),
                            width: w,
                            height: h,
                            pathData,
                            stroke: color,
                            strokeWidth: tool === 'highlighter' ? size * 3 : tool === 'marker' ? size * 2 : size,
                            opacity: tool === 'highlighter' ? 0.35 : opacity,
                            layer: maxLayer + 1,
                            drawingMode: tool,
                          }
                          settemplate_content(prev => ({
                            ...prev,
                            pages: prev.pages.map((pg, idx) => idx === currentPageIndex ? { ...pg, items: [...(pg.items || []), drawing] } : pg)
                          }))
                          setSelectedElement(id)
                        }}
                      />

                      {/* Freehand Drawing Overlay moved to canvas area level for full workspace drawing */}

                      {/* Audio playback is now handled by Web Audio API via audioMixer */}

                      {/* Interactive Elements */}
                      {getElementsAtCurrentTime().filter(item => !item.hidden && item.visible !== false).map((item) => (
                        <div
                          key={item.id}
                          data-element-id={item.id}
                          className={`absolute ${template_content.pages[currentPageIndex].page_config?.locked || item.locked ? 'pointer-events-none opacity-75' : (isEditingText && editingTextId === item.id ? 'cursor-text' : 'cursor-move')
                            } ${editingPowerClip && item.id !== editingPowerClip ? 'filter blur-sm opacity-50 pointer-events-none' : ''
                            } ${isEditingText && editingTextId === item.id ? '' : 'select-none'}`}
                          style={(() => {
                            // Base styles
                            const baseStyles = {
                              left: item.x,
                              top: item.y,
                              width: item.width,
                              height: item.height,
                              transform: `rotate(${item.rotation || 0}deg) scaleX(${item.scaleX || 1}) scaleY(${item.scaleY || 1})`,
                              opacity: item.opacity ?? 1,
                              zIndex: selectedElement === item.id ? 1000 : selectedElements.includes(item.id) ? 999 : (item.layer || 0) + 10
                            }
                            
                            // For video templates, apply effects using stackEffects
                            const isVideo = (template_content?.type || template_content?.mediaType) === 'video'

                            // Apply animation transforms for video template preview
                            if (isVideo && ['text', 'shape', 'image'].includes(item.type) && item.animations?.length > 0) {
                              const animConfig = item.animations[0]
                              const itemTime = item.time || { start: 0, duration: 2 }

                              if (item.type === 'text' && isTextAnimation(animConfig.type)) {
                                // Text animations: compute text animation state and apply as container-level transforms
                                try {
                                  const textContent = item.content || item.richText?.content || ''
                                  const textAnim = computeTextAnimation(animConfig, previewTime, itemTime, textContent.length, textContent)
                                  
                                  if (textAnim.type === 'per-character' && textAnim.transforms && textAnim.transforms.length > 0) {
                                    // Plain text renders TRUE per-glyph transforms (see content IIFE below),
                                    // so the container must stay neutral in that case to avoid double-applying.
                                    // Rich text (spans) can't be split per-glyph here, so fall back to a
                                    // container-level approximation (avg opacity + first char transform).
                                    const isRichText = !!(item.richText && item.richText.spans && item.richText.spans.length > 0)
                                    if (isRichText) {
                                      const avgOpacity = textAnim.transforms.reduce((sum, t) => sum + t.opacity, 0) / textAnim.transforms.length
                                      const firstTransform = textAnim.transforms[0]
                                      baseStyles.opacity = (item.opacity ?? 1) * avgOpacity
                                      baseStyles.transform = `rotate(${(item.rotation || 0) + (firstTransform.rotation || 0)}deg) scaleX(${(item.scaleX || 1) * (firstTransform.scale || 1)}) scaleY(${(item.scaleY || 1) * (firstTransform.scale || 1)}) translate(${firstTransform.offsetX || 0}px, ${firstTransform.offsetY || 0}px)`
                                      baseStyles.transformOrigin = 'center center'
                                    }
                                  }
                                  
                                  if (textAnim.filter) {
                                    baseStyles.filter = textAnim.filter
                                  }

                                  // Marquee: apply horizontal offset and clip overflow
                                  if (textAnim.marqueeOffset != null) {
                                    baseStyles._marqueeOffset = textAnim.marqueeOffset
                                  }
                                } catch (e) {
                                  console.error('Text animation error:', e)
                                }
                              } else {
                                // Basic animations on any target item type
                                try {
                                  const animTransform = computeAnimationTransform(animConfig, previewTime, itemTime)
                                  baseStyles.left = (item.x || 0) + animTransform.offsetX
                                  baseStyles.top = (item.y || 0) + animTransform.offsetY
                                  baseStyles.opacity = (item.opacity ?? 1) * animTransform.opacity
                                  // 3D flip (flipIn) via rotateX/rotateY + perspective.
                                  const rotX = animTransform.rotationX || 0
                                  const rotY = animTransform.rotationY || 0
                                  const flip3d = (rotX || rotY)
                                    ? `perspective(800px) rotateX(${rotX}deg) rotateY(${rotY}deg) `
                                    : ''
                                  baseStyles.transform = `${flip3d}rotate(${(item.rotation || 0) + animTransform.rotation}deg) scaleX(${(item.scaleX || 1) * animTransform.scale}) scaleY(${(item.scaleY || 1) * animTransform.scale})`
                                  baseStyles.transformOrigin = 'center center'
                                  if (animTransform.filter) {
                                    baseStyles.filter = animTransform.filter
                                  }
                                  // Emphasis: shimmer highlight sweep / glitch RGB split.
                                  // Stashed here and consumed by the inner text style.
                                  if (animTransform.shimmer) {
                                    baseStyles._shimmer = animTransform.shimmer
                                  }
                                  if (animTransform.glitch) {
                                    baseStyles._glitch = animTransform.glitch
                                  }
                                } catch (e) {
                                  console.error('Animation transform error:', e)
                                }
                              }
                            }

                            // Text Motion (base transform). Applies whenever item.motion
                            // is set — motion is a general feature, not video-only — and
                            // composes UNDER any animation computed above: motion's offsets
                            // add to left/top, its opacity multiplies, and its scale/rotate/
                            // perspective are prepended to the existing transform string.
                            if (['text', 'shape', 'image'].includes(item.type) && item.motion && item.motion.type && isMotionType(item.motion.type)) {
                              try {
                                const itemTime = item.time || { start: 0, duration: 2 }
                                const mctx = {
                                  width: item.width || 0,
                                  height: item.height || 0,
                                  fontSize: item.fontSize || 16,
                                  text: item.content || item.richText?.content || '',
                                }
                                const m = computeMotion(item.motion, previewTime, itemTime, mctx)

                                // Positional offset (translate handled via left/top so it
                                // doesn't fight the box's own rotate/scale transform).
                                baseStyles.left = (typeof baseStyles.left === 'number' ? baseStyles.left : (item.x || 0)) + (m.x || 0)
                                baseStyles.top = (typeof baseStyles.top === 'number' ? baseStyles.top : (item.y || 0)) + (m.y || 0)

                                // Opacity multiplies onto whatever is already there.
                                baseStyles.opacity = (baseStyles.opacity ?? (item.opacity ?? 1)) * (m.opacity ?? 1)

                                // Build the motion transform fragment: 3D perspective tilt,
                                // rotation, and non-uniform scale around the anchor.
                                const mRotX = m.rotationX || 0
                                const mRotY = m.rotationY || 0
                                const m3d = (mRotX || mRotY)
                                  ? `perspective(800px) rotateX(${mRotX}deg) rotateY(${mRotY}deg) `
                                  : ''
                                const mScaleX = (m.scaleX ?? 1)
                                const mScaleY = (m.scaleY ?? 1)
                                const mRot = m.rotation || 0
                                const motionTransform = `${m3d}rotate(${mRot}deg) scaleX(${mScaleX}) scaleY(${mScaleY})`
                                // Prepend so animation (applied closer to the element) layers on top.
                                baseStyles.transform = `${motionTransform} ${baseStyles.transform || ''}`.trim()

                                // Transform origin from the motion anchor (normalized 0..1).
                                if (m.anchorX != null || m.anchorY != null) {
                                  const axp = ((m.anchorX != null ? m.anchorX : 0.5) * 100).toFixed(2)
                                  const ayp = ((m.anchorY != null ? m.anchorY : 0.5) * 100).toFixed(2)
                                  baseStyles.transformOrigin = `${axp}% ${ayp}%`
                                }

                                // Blur composes with any animation filter.
                                if ((m.blur || 0) > 0.01) {
                                  const blurCss = `blur(${m.blur}px)`
                                  baseStyles.filter = baseStyles.filter ? `${baseStyles.filter} ${blurCss}` : blurCss
                                }

                                // Spacing overrides (consumed by the inner text style).
                                if ((m.letterSpacing || 0) !== 0) {
                                  baseStyles._motionLetterSpacing = m.letterSpacing
                                }
                                if ((m.lineSpacing || 0) !== 0) {
                                  baseStyles._motionLineSpacing = m.lineSpacing
                                }

                                // Per-character transforms for the glyph renderer below.
                                if (m.perChar && m.perChar.length > 0) {
                                  baseStyles._motionPerChar = m.perChar
                                  baseStyles._motionPerCharAbsolute = !!m.perCharAbsolute
                                }
                              } catch (e) {
                                console.error('Motion transform error:', e)
                              }
                            }

                            // Text Effects on SHAPE items (preview approximation). Shapes
                            // render as a div/SVG (not glyph text), so we apply only the
                            // DOM-expressible subset onto the wrapper: drop/outer shadow &
                            // glow via drop-shadow()/box-shadow, blur, blend mode, opacity.
                            // The worker renders the full-fidelity stack (gradient fills,
                            // stroke rings, etc.) — see render_shape_item_video.
                            if (['shape', 'image'].includes(item.type) && Array.isArray(item.textEffects) && item.textEffects.length > 0) {
                              try {
                                const sfxRes = computeTextEffects(item.textEffects, item, previewTime, {
                                  width: item.width || 0, height: item.height || 0, fontSize: 0, text: '',
                                  time: item.time || { start: 0, duration: 2 },
                                })
                                const dropFilters = []
                                // Behind shadow/glow layers → drop-shadow() (follows the shape alpha).
                                for (const l of sfxRes.behind) {
                                  if (l.kind === 'shadow') {
                                    dropFilters.push(`drop-shadow(${l.offsetX || 0}px ${l.offsetY || 0}px ${l.blur || 0}px ${hexToRgba(l.color || '#000', l.opacity != null ? l.opacity : 0.6)})`)
                                  } else if (l.kind === 'glow') {
                                    dropFilters.push(`drop-shadow(0 0 ${l.blur || 8}px ${hexToRgba(l.color || '#fff', l.opacity != null ? l.opacity : 0.9)})`)
                                  }
                                }
                                // Whole-layer blur.
                                if (sfxRes.filters.blur) dropFilters.push(`blur(${sfxRes.filters.blur}px)`)
                                if (dropFilters.length) {
                                  baseStyles.filter = baseStyles.filter ? `${baseStyles.filter} ${dropFilters.join(' ')}` : dropFilters.join(' ')
                                }
                                if (sfxRes.filters.bgBlur) {
                                  baseStyles.backdropFilter = `blur(${sfxRes.filters.bgBlur}px)`
                                }
                                if (sfxRes.filters.blendMode && sfxRes.filters.blendMode.mode !== 'normal') {
                                  baseStyles.mixBlendMode = sfxRes.filters.blendMode.mode
                                  if (sfxRes.filters.blendMode.opacity != null) {
                                    baseStyles.opacity = (baseStyles.opacity ?? (item.opacity ?? 1)) * sfxRes.filters.blendMode.opacity
                                  }
                                }
                              } catch (e) {
                                console.error('Shape effects error:', e)
                              }
                            }

                            // Clip transition (item.transition): entrance/exit cross-fade,
                            // slide, wipe, zoom, iris, film-burn between adjacent clips.
                            // Folds opacity/offset/scale/clip onto the wrapper.
                            if (item.transition) {
                              try {
                                const tr = computeTransition(item, previewTime, { width: item.width || 0, height: item.height || 0 })
                                if (tr.active) {
                                  baseStyles.left = (typeof baseStyles.left === 'number' ? baseStyles.left : (item.x || 0)) + (tr.offsetX || 0)
                                  baseStyles.top = (typeof baseStyles.top === 'number' ? baseStyles.top : (item.y || 0)) + (tr.offsetY || 0)
                                  baseStyles.opacity = (baseStyles.opacity ?? (item.opacity ?? 1)) * (tr.opacity ?? 1)
                                  if (tr.scale && Math.abs(tr.scale - 1) > 0.001) {
                                    baseStyles.transform = `scale(${tr.scale}) ${baseStyles.transform || ''}`.trim()
                                    baseStyles.transformOrigin = baseStyles.transformOrigin || 'center center'
                                  }
                                  const cp = transitionClipPath(tr.clip)
                                  if (cp) baseStyles.clipPath = cp
                                }
                              } catch (e) {
                                console.error('Transition error:', e)
                              }
                            }

                            if (isVideo) {
                              return applyAdjustmentLayerEffects(item, baseStyles)
                            }
                            
                            return baseStyles
                          })()}
                          onMouseDown={(e) => {
                            // Disable dragging while text editing
                            if (isEditingText && editingTextId === item.id) {
                              e.stopPropagation()
                              return
                            }
                            // In PowerClip edit mode, only allow interaction with the PowerClip container
                            if (editingPowerClip && item.id !== editingPowerClip) {
                              e.preventDefault()
                              e.stopPropagation()
                              return
                            }
                            handleElementMouseDown(e, item.id)
                          }}
                          onDoubleClick={(e) => {
                            if (item.type === 'text') {
                              // Allow default so browser computes native caret; we then fine-tune
                              e.stopPropagation()
                              handleTextDoubleClick(item, e)
                            }
                            if (item.type === 'group') {
                              // Double-click on group → enter group editing mode
                              e.stopPropagation()
                              setEditingGroup(item.id)
                              setSelectedElement(item.id)
                            }
                          }}
                        >
                          {/* Element Content */}
                          {item.type === 'text' && (
                            <>
                              {/* Show original text only when NOT in edit mode */}
                              {!(isEditingText && editingTextId === item.id) && (
                                <AutoFitText
                                  item={item}
                                  baseFontSize={item.fontSize || 16}
                                  disabled={
                                    // Auto-fit runs in BOTH modes; the width/height-vs-width
                                    // constraint is decided inside AutoFitText from item.wrap
                                    // (wrap ON = fit width+height; wrap OFF = fit width only).
                                    // Skip only while inline-editing or for marquee scrolls.
                                    (isEditingText && editingTextId === item.id) ||
                                    (item.animations?.length > 0 && item.animations[0]?.type === 'marquee')
                                  }
                                >
                                  {(fittedFontSize, autoFitRef) => {
                                  // Text Effects (item.textEffects array). Compute once; the DOM
                                  // styles are merged into the inner text style below (textShadow
                                  // parts appended to the shadow list, the rest spread at the end).
                                  let __fx = null
                                  if (Array.isArray(item.textEffects) && item.textEffects.length > 0) {
                                    try {
                                      const __fxRes = computeTextEffects(item.textEffects, item, previewTime, {
                                        width: item.width || 0, height: item.height || 0,
                                        fontSize: item.fontSize || 16,
                                        text: item.content || item.richText?.content || '',
                                        time: item.time || { start: 0, duration: 2 },
                                      })
                                      __fx = textEffectsToDomStyles(__fxRes, item, { width: item.width, height: item.height })
                                    } catch (e) { console.error('TextEffects DOM error:', e); __fx = null }
                                  }
                                  return (
                                <div
                                  ref={autoFitRef}
                                  className={`w-full h-full flex ${item.verticalAlign === 'bottom' ? 'items-end' :
                                    item.verticalAlign === 'middle' ? 'items-center' : 'items-start'
                                    } ${item.textAlign === 'left' ? 'justify-start' :
                                      item.textAlign === 'right' ? 'justify-end' :
                                        item.textAlign === 'justify' ? 'justify-between' : 'justify-center'
                                    }`}
                                  style={{
                                    fontSize: fittedFontSize,
                                    fontFamily: item.fontFamily || 'Arial',
                                    color: (() => {
                                      const effectType = typeof item.textEffect === 'string' ? item.textEffect : item.textEffect?.type
                                      if (effectType === 'outlineTitle') {
                                        return 'transparent'
                                      }
                                      return item.color || item.fill || '#000000'
                                    })(),
                                    fontWeight: item.fontWeight || 'normal',
                                    fontStyle: item.fontStyle || 'normal',
                                    lineHeight: (() => {
                                      const base = item.lineHeight || 1
                                      // Motion lineSpacing (Category 1 lineSpacingMotion) composes onto base.
                                      if (item.motion && item.motion.type && isMotionType(item.motion.type)) {
                                        try {
                                          const itemTime = item.time || { start: 0, duration: 2 }
                                          const m = computeMotion(item.motion, previewTime, itemTime, {
                                            width: item.width || 0, height: item.height || 0,
                                            fontSize: item.fontSize || 16,
                                            text: item.content || item.richText?.content || '',
                                          })
                                          if ((m.lineSpacing || 0) !== 0) {
                                            // lineSpacing is reported as extra line-height units.
                                            return base + m.lineSpacing
                                          }
                                        } catch (e) { /* ignore */ }
                                      }
                                      return base
                                    })(),
                                    letterSpacing: (() => {
                                      let spacing = item.letterSpacing || 0
                                      // Add animation letter spacing (spread animation)
                                      const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video'
                                      if (isVideoTemplate && item.animations?.length > 0 && isTextAnimation(item.animations[0].type)) {
                                        const textContent = item.content || item.richText?.content || ''
                                        const itemTime = item.time || { start: 0, duration: 2 }
                                        const textAnim = computeTextAnimation(item.animations[0], previewTime, itemTime, textContent.length, textContent)
                                        if (textAnim.letterSpacing != null) {
                                          spacing += textAnim.letterSpacing
                                        }
                                      }
                                      // Add motion letter spacing (letterSpacingMotion / tracking motions).
                                      if (item.motion && item.motion.type && isMotionType(item.motion.type)) {
                                        try {
                                          const itemTime = item.time || { start: 0, duration: 2 }
                                          const m = computeMotion(item.motion, previewTime, itemTime, {
                                            width: item.width || 0, height: item.height || 0,
                                            fontSize: item.fontSize || 16,
                                            text: item.content || item.richText?.content || '',
                                          })
                                          if ((m.letterSpacing || 0) !== 0) spacing += m.letterSpacing
                                        } catch (e) { /* ignore */ }
                                      }
                                      return `${spacing}px`
                                    })(),
                                    wordSpacing: `${item.wordSpacing || 0}px`,
                                    fontKerning: item.fontKerning || 'auto',
                                    // Wrap mode: text wraps to multiple lines (obey width+height).
                                    // No-wrap (auto-resize): single line (obey max width only).
                                    whiteSpace: item.wrap === false ? 'nowrap' : 'pre-wrap',
                                    textAlign: item.textAlign || 'center',
                                    textDecoration: item.textDecoration || 'none',
                                    direction: item.direction || 'ltr',
                                    backgroundColor: item.textBackgroundColor || 'transparent',
                                    backgroundImage: (item.fillGradient && item.fillGradient !== 'none') ? item.fillGradient : 'none',
                                    WebkitBackgroundClip: (item.fillGradient && item.fillGradient !== 'none') ? 'text' : 'initial',
                                    WebkitTextFillColor: (() => {
                                      const effectType = typeof item.textEffect === 'string' ? item.textEffect : item.textEffect?.type
                                      if (effectType === 'outlineTitle') {
                                        return 'transparent'
                                      }
                                      if (item.fillGradient && item.fillGradient !== 'none') {
                                        return 'transparent'
                                      }
                                      return item.color || item.fill || '#000000'
                                    })(),
                                    // Combined text shadow for both stroke and shadow effects
                                    textShadow: (() => {
                                      const shadows = [];

                                      // Add stroke shadow if specified (behind fill effect with rounded corners)
                                      if (item.strokeWidth > 0) {
                                        const strokeColor = item.stroke || '#000000';
                                        const strokeWidth = item.strokeWidth;
                                        // Use more angles for smoother rounded corners
                                        for (let angle = 0; angle < 360; angle += 30) {
                                          const radian = (angle * Math.PI) / 180;
                                          const x = Math.cos(radian) * strokeWidth;
                                          const y = Math.sin(radian) * strokeWidth;
                                          shadows.push(`${x}px ${y}px ${strokeWidth * 0.3}px ${strokeColor}`);
                                        }
                                      }

                                      // Add regular shadow if specified
                                      if (item.textShadow?.enabled) {
                                        const { offsetX, offsetY, blur, color, opacity, gradient } = item.textShadow;

                                        if (gradient && gradient.stops?.length > 0) {
                                          // For gradient text shadows, use the first color with opacity blending
                                          const gradientColor = gradient.stops[0].color || '#000000';
                                          const shadowOpacity = opacity || 0.5;
                                          const rgbaColor = gradientColor.startsWith('#')
                                            ? `rgba(${parseInt(gradientColor.slice(1, 3), 16)}, ${parseInt(gradientColor.slice(3, 5), 16)}, ${parseInt(gradientColor.slice(5, 7), 16)}, ${shadowOpacity})`
                                            : gradientColor;
                                          shadows.push(`${offsetX || 2}px ${offsetY || 2}px ${blur || 4}px ${rgbaColor}`);
                                        } else {
                                          // Solid color shadow
                                          const shadowOpacity = opacity || 0.5;
                                          const shadowColor = color || '#000000';
                                          const rgbaColor = shadowColor.startsWith('#')
                                            ? `rgba(${parseInt(shadowColor.slice(1, 3), 16)}, ${parseInt(shadowColor.slice(3, 5), 16)}, ${parseInt(shadowColor.slice(5, 7), 16)}, ${shadowOpacity})`
                                            : shadowColor;
                                          shadows.push(`${offsetX || 2}px ${offsetY || 2}px ${blur || 4}px ${rgbaColor}`);
                                        }
                                      }
                                      // Fallback to legacy shadow system
                                      // else if (item.shadowBlur > 0) {
                                      //   shadows.push(`${item.shadowOffsetX || 0}px ${item.shadowOffsetY || 0}px ${item.shadowBlur || 0}px ${item.shadowColor || '#000000'}`);
                                      // }
                                      
                                      // Add glow effect if enabled
                                      if (item.textGlow?.enabled || item.glowEnabled) {
                                        const { blur = 10, color = '#FFFFFF', intensity = 0.8, spread = 5 } = item.textGlow || {};
                                        
                                        // Create glow effect using multiple text-shadows in all directions
                                        const layers = Math.max(3, Math.floor(spread / 2));
                                        for (let i = 1; i <= layers; i++) {
                                          const layerBlur = (blur * i) / layers;
                                          const layerOpacity = intensity * (1 - (i / layers) * 0.5);
                                          const layerColor = color.startsWith('#')
                                            ? `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, ${layerOpacity})`
                                            : color;
                                          
                                          // Create glow in all directions (circular)
                                          for (let angle = 0; angle < 360; angle += 45) {
                                            const radian = (angle * Math.PI) / 180;
                                            const offsetX = Math.cos(radian) * (spread * i / layers);
                                            const offsetY = Math.sin(radian) * (spread * i / layers);
                                            shadows.push(`${offsetX}px ${offsetY}px ${layerBlur}px ${layerColor}`);
                                          }
                                        }
                                      }

                                      // Text Effects shadow/glow/stroke-outline parts (dropShadow,
                                      // outerGlow, longShadow, extrude, multipleOutlines, etc.) are
                                      // appended so they compose with the legacy stroke/shadow/glow.
                                      if (__fx && Array.isArray(__fx.textShadow) && __fx.textShadow.length) {
                                        shadows.push(...__fx.textShadow)
                                      }

                                      return shadows.length > 0 ? shadows.join(', ') : 'none';
                                    })(),
                                    strokeLinejoin: item.strokeLineJoin || 'miter',
                                    strokeLinecap: item.strokeLineCap || 'butt',
                                    mixBlendMode: item.blendMode || 'normal',
                                    clipPath: item.clipPath !== 'none' ? item.clipPath : 'none',
                                    transform: `
                                      scaleX(${item.scaleX || 1})
                                      scaleY(${item.scaleY || 1})
                                      skewX(${item.skewX || 0}deg)
                                      skewY(${item.skewY || 0}deg)
                                    `,
                                    opacity: item.opacity || 1,
                                    padding: '0px',
                                    // ---- Category 2 emphasis overrides (placed last so they win) ----
                                    // Glitch: RGB-split textShadow during burst windows.
                                    ...(() => {
                                      const isVideoTpl = (template_content?.type || template_content?.mediaType) === 'video'
                                      if (!isVideoTpl || !(item.animations?.length > 0) || item.animations[0].type !== 'glitchLoop') return {}
                                      try {
                                        const itemTime = item.time || { start: 0, duration: 2 }
                                        const tf = computeAnimationTransform(item.animations[0], previewTime, itemTime)
                                        if (tf.glitch && tf.glitch.active) {
                                          const o = tf.glitch.rgbOffset || 0
                                          return { textShadow: `${o}px 0 rgba(255,0,0,0.6), ${-o}px 0 rgba(0,255,255,0.6)` }
                                        }
                                      } catch (e) { /* ignore */ }
                                      return {}
                                    })(),
                                    // Shimmer: moving highlight band clipped to the text (skipped if a
                                    // custom fill gradient is already set, to avoid clobbering it).
                                    ...(() => {
                                      const isVideoTpl = (template_content?.type || template_content?.mediaType) === 'video'
                                      if (!isVideoTpl || !(item.animations?.length > 0) || item.animations[0].type !== 'shimmer') return {}
                                      if (item.fillGradient && item.fillGradient !== 'none') return {}
                                      try {
                                        const itemTime = item.time || { start: 0, duration: 2 }
                                        const tf = computeAnimationTransform(item.animations[0], previewTime, itemTime)
                                        const sh = tf.shimmer
                                        if (sh) {
                                          const base = item.color || item.fill || '#000000'
                                          const center = Math.round(sh.position * 100)
                                          const half = Math.max(2, Math.round((sh.width || 0.25) * 50))
                                          const hi = sh.color || '#ffffff'
                                          return {
                                            backgroundImage: `linear-gradient(${90 - (sh.angle || 20)}deg, ${base} ${Math.max(0, center - half)}%, ${hi} ${center}%, ${base} ${Math.min(100, center + half)}%)`,
                                            WebkitBackgroundClip: 'text',
                                            backgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                          }
                                        }
                                      } catch (e) { /* ignore */ }
                                      return {}
                                    })(),
                                    // Advanced reveals (Category 6): curtain / liquid / wipe mask via clip-path.
                                    ...(() => {
                                      const isVideoTpl = (template_content?.type || template_content?.mediaType) === 'video'
                                      if (!isVideoTpl || !(item.animations?.length > 0)) return {}
                                      const t = item.animations[0].type
                                      if (t !== 'curtainReveal' && t !== 'liquidReveal' && t !== 'textDrawOn' && t !== 'textBehindObject') return {}
                                      try {
                                        const itemTime = item.time || { start: 0, duration: 2 }
                                        const txt = item.content || item.richText?.content || ''
                                        const ta = computeTextAnimation(item.animations[0], previewTime, itemTime, txt.length, txt)
                                        const rv = ta && ta.reveal
                                        if (!rv) return {}
                                        const p = Math.max(0, Math.min(1, rv.progress))
                                        if (rv.mode === 'curtain') {
                                          // Two panels open from the center outward.
                                          const inset = (1 - p) * 50 // % from each side toward center
                                          return rv.direction === 'vertical'
                                            ? { clipPath: `inset(${inset}% 0 ${inset}% 0)` }
                                            : { clipPath: `inset(0 ${inset}% 0 ${inset}%)` }
                                        }
                                        // wipe / liquid: directional reveal. (Liquid's wavy edge is
                                        // approximated by a straight soft edge in the DOM preview; the
                                        // worker renders the true wavy boundary.)
                                        const pct = Math.round(p * 100)
                                        switch (rv.direction) {
                                          case 'right': return { clipPath: `inset(0 0 0 ${100 - pct}%)` }
                                          case 'up': return { clipPath: `inset(${100 - pct}% 0 0 0)` }
                                          case 'down': return { clipPath: `inset(0 0 ${100 - pct}% 0)` }
                                          case 'left':
                                          default: return { clipPath: `inset(0 ${100 - pct}% 0 0)` }
                                        }
                                      } catch (e) { /* ignore */ }
                                      return {}
                                    })(),
                                    // ---- Text Effects DOM styles (fill/stroke/filter/blend) ----
                                    // Spread LAST so explicit effect choices win over base styling.
                                    // textShadow is omitted here — it's already merged into the
                                    // combined shadow list above so it composes with stroke/glow.
                                    ...(() => {
                                      if (!__fx || !__fx.style) return {}
                                      const { textShadow: _ts, ...rest } = __fx.style
                                      return rest
                                    })(),
                                  }}
                                >
                                  {__fx && __fx.boxStyle && (
                                    <div style={{ position: 'absolute', inset: 0, zIndex: -1, ...__fx.boxStyle }} aria-hidden="true" />
                                  )}
                                  {(() => {
                                    const { effectType, effectClass, effectStyle } = getTextEffectPresentation(item)
                                    
                                    // Compute text animation state for typing/block truncation
                                    let textAnimState = null
                                    const isVideoTemplate = (template_content?.type || template_content?.mediaType) === 'video'
                                    if (isVideoTemplate && item.animations?.length > 0 && isTextAnimation(item.animations[0].type)) {
                                      try {
                                        const textContent = item.content || item.richText?.content || ''
                                        const itemTime = item.time || { start: 0, duration: 2 }
                                        textAnimState = computeTextAnimation(item.animations[0], previewTime, itemTime, textContent.length, textContent)
                                      } catch (e) { /* ignore */ }
                                    }
                                    
                                    // Motion per-character transforms (Category 1/3 char motions).
                                    // Computed here so plain text can render true per-glyph motion.
                                    // Entries use {x,y,scaleX,scaleY,rotation,rotationX,rotationY,opacity}.
                                    let motionPerChar = null
                                    let motionPerCharAbsolute = false
                                    if (item.motion && item.motion.type && isMotionType(item.motion.type)) {
                                      try {
                                        const itemTime = item.time || { start: 0, duration: 2 }
                                        const mctx = {
                                          width: item.width || 0,
                                          height: item.height || 0,
                                          fontSize: item.fontSize || 16,
                                          text: item.content || item.richText?.content || '',
                                        }
                                        const mRes = computeMotion(item.motion, previewTime, itemTime, mctx)
                                        if (mRes && mRes.perChar && mRes.perChar.length > 0) {
                                          motionPerChar = mRes.perChar
                                          motionPerCharAbsolute = !!mRes.perCharAbsolute
                                        }
                                      } catch (e) { /* ignore */ }
                                    }

                                    // For typing: get visible character count
                                    const typewriterVisibleCount = (textAnimState && textAnimState.type === 'full-text' && textAnimState.visibleCount != null)
                                      ? textAnimState.visibleCount
                                      : null
                                    
                                    // Marquee offset
                                    const marqueeData = (textAnimState && textAnimState.marqueeLoop)
                                      ? textAnimState
                                      : null
                                    
                                    const baseContent = item.richText && item.richText.spans && item.richText.spans.length > 0
                                      ? (
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: (function () {
                                              const translatedContent = getTranslatedContent(item, true)
                                              let content = translatedContent
                                              // Typewriter truncation for rich text
                                              if (typewriterVisibleCount != null) {
                                                content = content.slice(0, typewriterVisibleCount)
                                              }
                                              const spans = [...item.richText.spans].sort((a, b) => a.start - b.start)
                                              // Element "Size" control is authoritative for uniform text:
                                              // if every span shares one fontSize, drop the per-span fontSize
                                              // so the container (item.fontSize / fittedFontSize) wins. Only
                                              // truly mixed per-span sizes keep their own. (Spans may store
                                              // styling under `styles` or `style`.)
                                              const _normSz = (v) => {
                                                if (v == null) return null
                                                const n = parseFloat(String(v).replace('px', ''))
                                                return Number.isNaN(n) ? null : n
                                              }
                                              const _spanSizes = spans
                                                .map((sp) => _normSz((sp.styles || sp.style || {}).fontSize))
                                                .filter((n) => n != null)
                                              const _uniformSpanFont = new Set(_spanSizes).size <= 1
                                              let html = ''
                                              let cursor = 0
                                              spans.forEach((sp) => {
                                                const { start, end } = sp
                                                let styles = sp.styles || sp.style || {}
                                                if (_uniformSpanFont && styles && styles.fontSize != null) {
                                                  const { fontSize: _omit, ...rest } = styles
                                                  styles = rest
                                                }
                                                const clampedStart = Math.min(start, content.length)
                                                const clampedEnd = Math.min(end, content.length)
                                                if (clampedStart > cursor) html += content.slice(cursor, clampedStart).replace(/\n/g, '<br/>')
                                                if (clampedEnd > clampedStart) {
                                                  const text = content.slice(clampedStart, clampedEnd).replace(/\n/g, '<br/>')
                                                  const styleStr = Object.entries(styles || {}).map(([k, v]) => `${k.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}:${v}`).join(';')
                                                  html += `<span style="${styleStr}">${text}</span>`
                                                }
                                                cursor = clampedEnd
                                              })
                                              if (cursor < content.length) html += content.slice(cursor).replace(/\n/g, '<br/>')
                                              // Typing pop effect: wrap last visible char in scaled span
                                              if (typewriterVisibleCount != null && textAnimState.lastCharScale && textAnimState.lastCharScale > 1.01 && html.length > 0) {
                                                // Find and wrap the last visible character with scale transform
                                                const lastCharMatch = html.match(/([\s\S]*)([\s\S])$/)
                                                if (lastCharMatch) {
                                                  const beforeLast = html.slice(0, -1)
                                                  const lastChar = html.slice(-1)
                                                  if (lastChar !== '>' && lastChar !== ';') {
                                                    html = beforeLast + `<span style="display:inline-block;transform:scale(${textAnimState.lastCharScale.toFixed(3)});transform-origin:center bottom">${lastChar}</span>`
                                                  }
                                                }
                                              }
                                              // Typing cursor
                                              if (typewriterVisibleCount != null && textAnimState.showCursor && typewriterVisibleCount < (item.content || '').length) {
                                                html += '<span style="animation:textAnimCursorBlink 1s step-end infinite">|</span>'
                                              }
                                              return html
                                            })()
                                          }}
                                        />
                                      )
                                      : (
                                        <span>
                                          {(() => {
                                            let displayText = getTranslatedContent(item)

                                            // TRUE per-glyph rendering for per-character animations
                                            // (letterReveal, ascend, shift, merge, burst, bounceText, roll,
                                            // skate). Each character gets its own transform + opacity.
                                            const animPerChar = (textAnimState && textAnimState.type === 'per-character' && Array.isArray(textAnimState.transforms))
                                              ? textAnimState.transforms
                                              : null
                                            // Motion per-glyph transforms map to the same tf shape
                                            // (x->offsetX, y->offsetY, scaleX/scaleY->scale geometric mean).
                                            // Animation per-char takes priority when both are present.
                                            const motionPerCharTf = (!animPerChar && motionPerChar)
                                              ? motionPerChar.map(p => ({
                                                  offsetX: p.x || 0,
                                                  offsetY: p.y || 0,
                                                  scale: Math.sqrt(Math.max(0.0001, Math.abs(p.scaleX != null ? p.scaleX : 1) * Math.abs(p.scaleY != null ? p.scaleY : 1))),
                                                  rotation: p.rotation || 0,
                                                  rotationX: p.rotationX || 0,
                                                  rotationY: p.rotationY || 0,
                                                  opacity: p.opacity != null ? p.opacity : 1,
                                                }))
                                              : null
                                            const perChar = animPerChar || motionPerCharTf
                                            if (perChar) {
                                              const lines = displayText.split('\n')
                                              let charIdx = 0
                                              return (
                                                <>
                                                  {lines.map((line, lineIdx) => (
                                                    <React.Fragment key={`${item.id}-pc-line-${lineIdx}`}>
                                                      {Array.from(line).map((ch, i) => {
                                                        const tf = perChar[charIdx] || { offsetX: 0, offsetY: 0, scale: 1, rotation: 0, opacity: 1 }
                                                        charIdx++
                                                        return (
                                                          <span
                                                            key={`${item.id}-pc-${lineIdx}-${i}`}
                                                            style={{
                                                              display: 'inline-block',
                                                              whiteSpace: 'pre',
                                                              opacity: tf.opacity,
                                                              transform: `${(tf.rotationX || tf.rotationY) ? `perspective(600px) rotateX(${tf.rotationX || 0}deg) rotateY(${tf.rotationY || 0}deg) ` : ''}translate(${tf.offsetX || 0}px, ${tf.offsetY || 0}px) scale(${tf.scale != null ? tf.scale : 1}) rotate(${tf.rotation || 0}deg)`,
                                                              transformOrigin: 'center center',
                                                              // Per-char color (wordHighlightCascade). Overrides fill via
                                                              // both color and -webkit-text-fill-color so it wins over gradients.
                                                              ...(tf.color ? { color: tf.color, WebkitTextFillColor: tf.color } : {}),
                                                            }}
                                                          >
                                                            {ch === ' ' ? '\u00A0' : ch}
                                                          </span>
                                                        )
                                                      })}
                                                      {lineIdx < lines.length - 1 && <br />}
                                                    </React.Fragment>
                                                  ))}
                                                </>
                                              )
                                            }

                                            // Typing truncation for plain text
                                            if (typewriterVisibleCount != null) {
                                              displayText = displayText.slice(0, typewriterVisibleCount)
                                            }
                                            // Typing pop effect: split last char for scale
                                            const hasPopEffect = typewriterVisibleCount != null && textAnimState.lastCharScale && textAnimState.lastCharScale > 1.01 && displayText.length > 0
                                            const mainText = hasPopEffect ? displayText.slice(0, -1) : displayText
                                            const popChar = hasPopEffect ? displayText.slice(-1) : null
                                            const mainLines = mainText.split('\n')
                                            return (
                                              <>
                                                {mainLines.map((line, idx) => (
                                                  <React.Fragment key={`${item.id}-line-${idx}`}>
                                                    {line || (idx < mainLines.length - 1 || !hasPopEffect ? '\u00A0' : '')}
                                                    {idx < mainLines.length - 1 && <br />}
                                                  </React.Fragment>
                                                ))}
                                                {popChar && (
                                                  <span style={{ display: 'inline-block', transform: `scale(${textAnimState.lastCharScale.toFixed(3)})`, transformOrigin: 'center bottom' }}>{popChar}</span>
                                                )}
                                              </>
                                            )
                                          })()}
                                          {typewriterVisibleCount != null && textAnimState.showCursor && typewriterVisibleCount < (item.content || '').length && (
                                            <span style={{ animation: 'textAnimCursorBlink 1s step-end infinite' }}>|</span>
                                          )}
                                        </span>
                                      )

                                    // Wrap content with marquee scrolling if active
                                    const wrappedContent = marqueeData != null
                                      ? (() => {
                                        // Seamless marquee: render text twice with a gap, scroll in a loop.
                                        // We measure the container width from the item and use the raw
                                        // pixel offset modulo (textWidth + gap) to create the loop.
                                        const containerWidth = item.width || 300
                                        const gap = marqueeData.marqueeGap || 60
                                        const rawOffset = marqueeData.marqueeOffset || 0
                                        const dir = marqueeData.marqueeDirection || 'left'

                                        // Estimate text width: for long text it exceeds container.
                                        // We use a rough estimate; the browser will lay it out with whiteSpace:nowrap.
                                        // The cycle length = containerWidth + gap (text scrolls fully out then re-enters).
                                        const cycleLen = containerWidth + gap
                                        const phase = cycleLen > 0 ? (rawOffset % cycleLen) : 0
                                        const tx = dir === 'left' ? -phase : phase - cycleLen

                                        const innerContent = effectType
                                          ? <span className={effectClass} style={effectStyle}>{baseContent}</span>
                                          : baseContent

                                        return (
                                          <div style={{ overflow: 'hidden', width: '100%', height: '100%', position: 'relative' }}>
                                            <div style={{
                                              display: 'flex',
                                              whiteSpace: 'nowrap',
                                              transform: `translateX(${tx}px)`,
                                              willChange: 'transform',
                                            }}>
                                              <span style={{ flexShrink: 0 }}>{innerContent}</span>
                                              <span style={{ flexShrink: 0, paddingLeft: `${gap}px` }}>{innerContent}</span>
                                            </div>
                                          </div>
                                        )
                                      })()
                                      : effectType
                                        ? <span className={effectClass} style={effectStyle}>{baseContent}</span>
                                        : baseContent

                                    return wrappedContent
                                  })()}
                                </div>
                                  )
                                  }}
                                </AutoFitText>
                              )}

                              {/* Show inline editor when in edit mode */}
                              {isEditingText && editingTextId === item.id && (
                                <InlineTextEditor
                                  element={item}
                                  onUpdate={handleTextUpdate}
                                  onClose={handleTextEditClose}
                                  onTextSelect={handleTextSelection}
                                  isVisible={true}
                                  caretPoint={textEditCaretPoint}
                                />
                              )}
                            </>
                          )}

                          {/* Freehand drawing */}
                          {item.type === 'drawing' && (
                            <svg width={item.width} height={item.height} className="absolute inset-0">
                              <path d={item.pathData} stroke={item.stroke} strokeWidth={item.strokeWidth} fill="none" opacity={item.opacity ?? 1} />
                            </svg>
                          )}
                          {/* Straight line */}
                          {item.type === 'line' && (
                            <svg width={item.width} height={item.height} className="absolute inset-0">
                              <path d={item.pathData} stroke={item.stroke} strokeWidth={item.strokeWidth} fill="none" opacity={item.opacity ?? 1} />
                            </svg>
                          )}

                          {/* Freehand path */}
                          {item.type === 'freehand' && item.pathData && (
                            <svg width={item.width} height={item.height} className="absolute inset-0">
                              <defs>
                                {/* Arrow markers if needed */}
                                {item.stroke?.startArrow && item.stroke.startArrow !== 'none' && (
                                  <marker
                                    id={`arrow-start-${item.id}`}
                                    markerWidth="10"
                                    markerHeight="10"
                                    refX="10"
                                    refY="5"
                                    orient="auto"
                                    markerUnits="strokeWidth"
                                  >
                                    <path d="M 0 0 L 10 5 L 0 10 Z" fill={item.stroke.color} />
                                  </marker>
                                )}
                                {item.stroke?.endArrow && item.stroke.endArrow !== 'none' && (
                                  <marker
                                    id={`arrow-end-${item.id}`}
                                    markerWidth="10"
                                    markerHeight="10"
                                    refX="10"
                                    refY="5"
                                    orient="auto"
                                    markerUnits="strokeWidth"
                                  >
                                    <path d="M 0 0 L 10 5 L 0 10 Z" fill={item.stroke.color} />
                                  </marker>
                                )}
                              </defs>

                              {/* Fill path (only for closed shapes) */}
                              {item.pathData.closed && item.pathData.fill && (
                                <path
                                  d={(() => {
                                    // Create complete path for fill
                                    if (!item.pathData.nodes || item.pathData.nodes.length === 0) return '';

                                    let pathD = `M ${item.pathData.nodes[0].p.x} ${item.pathData.nodes[0].p.y}`;

                                    item.pathData.segments?.forEach(segment => {
                                      const fromNode = item.pathData.nodes[segment.from];
                                      const toNode = item.pathData.nodes[segment.to];
                                      if (!fromNode || !toNode) return;

                                      if (segment.type === 'line') {
                                        pathD += ` L ${toNode.p.x} ${toNode.p.y}`;
                                      } else if (segment.type === 'cubic') {
                                        const c1 = fromNode.h2 || fromNode.p;
                                        const c2 = toNode.h1 || toNode.p;
                                        pathD += ` C ${c1.x} ${c1.y}, ${c2.x} ${c2.y}, ${toNode.p.x} ${toNode.p.y}`;
                                      }
                                    });

                                    pathD += ' Z'; // Close the path
                                    return pathD;
                                  })()}
                                  fill={item.pathData.fill}
                                  fillOpacity={item.pathData.fillOpacity || 1}
                                  stroke="none"
                                />
                              )}
                              {/* Render complete stroke path */}
                              <path
                                d={(() => {
                                  // Create complete path for stroke
                                  if (!item.pathData.nodes || item.pathData.nodes.length === 0) return '';

                                  let pathD = `M ${item.pathData.nodes[0].p.x} ${item.pathData.nodes[0].p.y}`;

                                  item.pathData.segments?.forEach(segment => {
                                    const fromNode = item.pathData.nodes[segment.from];
                                    const toNode = item.pathData.nodes[segment.to];
                                    if (!fromNode || !toNode) return;

                                    if (segment.type === 'line') {
                                      pathD += ` L ${toNode.p.x} ${toNode.p.y}`;
                                    } else if (segment.type === 'cubic') {
                                      const c1 = fromNode.h2 || fromNode.p;
                                      const c2 = toNode.h1 || toNode.p;
                                      pathD += ` C ${c1.x} ${c1.y}, ${c2.x} ${c2.y}, ${toNode.p.x} ${toNode.p.y}`;
                                    }
                                  });

                                  if (item.pathData.closed) {
                                    pathD += ' Z'; // Close the path
                                  }

                                  return pathD;
                                })()}
                                stroke={item.stroke?.color || '#000000'}
                                strokeWidth={item.stroke?.width || 2}
                                strokeLinecap={item.stroke?.lineCap || 'round'}
                                strokeLinejoin={item.stroke?.lineJoin || 'round'}
                                strokeDasharray={item.stroke?.dash ? item.stroke.dash.join(' ') : 'none'}
                                strokeOpacity={item.stroke?.opacity || 1}
                                fill="none"
                                markerStart={item.stroke?.startArrow !== 'none' ? `url(#arrow-start-${item.id})` : undefined}
                                markerEnd={item.stroke?.endArrow !== 'none' ? `url(#arrow-end-${item.id})` : undefined}
                              />
                            </svg>
                          )}

                          {item.type === 'image' && (() => {
                            const baseStyles = {
                              opacity: item.opacity ?? 1,
                              filter: (() => {
                                // Base filter: new filters.cssFilter if present, else legacy.
                                let base
                                if (item.filters?.cssFilter) {
                                  base = item.filters.cssFilter;
                                } else {
                                  base = `
                                  brightness(${(item.brightness ?? 0) + 100}%)
                                  contrast(${(item.contrast ?? 0) + 100}%)
                                  saturate(${(item.intensity ?? 0) + 100}%)
                                  hue-rotate(${item.hueRotate || 0}deg)
                                  sepia(${Math.max(0, item.sepia || 0)}%)
                                  grayscale(${Math.max(0, item.grayscale || 0)}%)
                                  blur(${Math.max(0, item.blur || 0)}px)
                                `;
                                }
                                // Color grade (item.colorGrade): preview approximation via
                                // CSS filter. The worker renders the full numeric grade.
                                const g = item.colorGrade
                                if (g) {
                                  const parts = []
                                  const presetCss = {
                                    cinematic: 'contrast(115%) saturate(110%) sepia(10%)',
                                    warm: 'sepia(25%) saturate(120%) brightness(103%)',
                                    cool: 'hue-rotate(185deg) saturate(108%) brightness(102%)',
                                    blackWhite: 'grayscale(100%)', bw: 'grayscale(100%)',
                                    sepia: 'sepia(90%)', vintage: 'sepia(35%) contrast(110%) saturate(85%)',
                                    faded: 'contrast(85%) saturate(80%) brightness(108%)',
                                    matte: 'contrast(88%) saturate(82%) brightness(106%)',
                                    vivid: 'saturate(160%) contrast(108%)', hdr: 'contrast(125%) saturate(130%) brightness(105%)',
                                  }
                                  if (g.preset && presetCss[g.preset]) parts.push(presetCss[g.preset])
                                  const bExp = (g.brightness || 0) + (g.exposure || 0)
                                  if (bExp) parts.push(`brightness(${100 + bExp}%)`)
                                  if (g.contrast) parts.push(`contrast(${100 + g.contrast}%)`)
                                  if (g.saturation || g.vibrance) parts.push(`saturate(${100 + (g.saturation || 0) + (g.vibrance || 0) * 0.6}%)`)
                                  if (g.hue) parts.push(`hue-rotate(${g.hue}deg)`)
                                  // Temperature approximated with sepia (warm) / hue (cool).
                                  if (g.temperature > 0) parts.push(`sepia(${Math.min(60, g.temperature)}%)`)
                                  else if (g.temperature < 0) parts.push(`hue-rotate(${g.temperature * 0.6}deg)`)
                                  if (parts.length) base = `${base} ${parts.join(' ')}`
                                }
                                return base
                              })(),
                              transform: `scaleX(${item.flipX ? -1 : 1}) scaleY(${item.flipY ? -1 : 1})`,
                              transformOrigin: 'center center',
                            };
                            
                            // Apply adjustment layer effects
                            const finalStyles = applyAdjustmentLayerEffects(item, baseStyles);
                            
                            // Build a CSS mask for gradient transparency. The mask's
                            // alpha channel controls per-pixel opacity: rgba(0,0,0,a)
                            // => alpha a. Falls back to the legacy item.gradientMask.
                            const gradientMaskImage = (() => {
                              const gt = item.gradientTransparency;
                              if (gt?.enabled) {
                                const s = gt.startOpacity ?? 1;
                                const e2 = gt.endOpacity ?? 0;
                                if (gt.type === 'radial') {
                                  return `radial-gradient(circle, rgba(0,0,0,${s}) 0%, rgba(0,0,0,${e2}) 100%)`;
                                }
                                return `linear-gradient(${gt.angle || 0}deg, rgba(0,0,0,${s}) 0%, rgba(0,0,0,${e2}) 100%)`;
                              }
                              return item.gradientMask || undefined;
                            })();

                            return (
                              <div className="w-full h-full" style={{
                                ...finalStyles,
                              // Clip the scaled-up image when a crop is applied.
                              overflow: item.crop ? 'hidden' : undefined,
                              WebkitMaskImage: gradientMaskImage,
                              maskImage: gradientMaskImage,
                              WebkitMaskSize: '100% 100%',
                              maskSize: '100% 100%',
                              WebkitMaskRepeat: 'no-repeat',
                              maskRepeat: 'no-repeat',
                              boxShadow: (() => {
                                // Enhanced shadow system
                                if (item.shadow?.enabled) {
                                  const { offsetX, offsetY, blur, spread, color, opacity, inset, gradient } = item.shadow;

                                  if (gradient) {
                                    // For gradient shadows, we'll use a pseudo-element approach via CSS filter
                                    // This is a simplified version - full gradient shadows would need more complex implementation
                                    const gradientColor = gradient.stops?.[0]?.color || color || '#000000';
                                    const shadowOpacity = opacity || 0.25;
                                    const rgbaColor = gradientColor.startsWith('#')
                                      ? `rgba(${parseInt(gradientColor.slice(1, 3), 16)}, ${parseInt(gradientColor.slice(3, 5), 16)}, ${parseInt(gradientColor.slice(5, 7), 16)}, ${shadowOpacity})`
                                      : gradientColor;
                                    return `${inset ? 'inset ' : ''}${offsetX || 4}px ${offsetY || 4}px ${blur || 8}px ${spread || 0}px ${rgbaColor}`;
                                  } else {
                                    // Solid color shadow
                                    const shadowOpacity = opacity || 0.25;
                                    const shadowColor = color || '#000000';
                                    const rgbaColor = shadowColor.startsWith('#')
                                      ? `rgba(${parseInt(shadowColor.slice(1, 3), 16)}, ${parseInt(shadowColor.slice(3, 5), 16)}, ${parseInt(shadowColor.slice(5, 7), 16)}, ${shadowOpacity})`
                                      : shadowColor;
                                    return `${inset ? 'inset ' : ''}${offsetX || 4}px ${offsetY || 4}px ${blur || 8}px ${spread || 0}px ${rgbaColor}`;
                                  }
                                }
                                // Fallback to legacy boxShadow
                                return item.boxShadow || 'none';
                              })()
                              }}>
                                <img
                                  // Key on the resolved URL so that when the src
                                  // changes (e.g. an AI image is applied) React
                                  // mounts a FRESH <img>. Without this, a prior
                                  // onError that imperatively set display:none on
                                  // the reused node would persist and keep the new
                                  // image hidden until a full reload.
                                  key={item.src || item.url || item.image_url || item.sample_url || 'empty'}
                                  src={item.src || item.url || item.image_url || item.sample_url || ''}
                                  alt="Element"
                                  className="w-full h-full object-fill rounded"
                                  draggable={false}
                                  style={{
                                    mixBlendMode: item.blendMode || 'normal',
                                    // Crop: show only item.crop {x,y,width,height} (normalized
                                    // 0..1) by scaling the region up to fill the box and
                                    // shifting it into view. The wrapper clips the overflow.
                                    ...(item.crop && item.crop.width > 0 && item.crop.height > 0 ? {
                                      transform: `scale(${1 / item.crop.width}, ${1 / item.crop.height}) translate(${-item.crop.x * 100}%, ${-item.crop.y * 100}%)`,
                                      transformOrigin: 'top left',
                                    } : {})
                                  }}
                                  onLoad={(e) => {
                                    // A successful load must always be visible, even
                                    // if a previous error had hidden the node.
                                    e.target.style.display = ''
                                  }}
                                  onError={(e) => {
                                    // Try fallback URLs if primary src fails
                                    const fallbackUrl = item.url || item.image_url || item.sample_url
                                    if (fallbackUrl && e.target.src !== fallbackUrl) {
                                      e.target.src = fallbackUrl
                                    } else {
                                      // Hide image if all URLs fail
                                      e.target.style.display = 'none'
                                    }
                                  }}
                                />
                              </div>
                            );
                          })()}

                          {/* Video Element */}
                          {item.type === 'video' && (
                            <VideoPreview
                              item={item}
                              previewTime={previewTime}
                              isPlaying={isPlaying}
                              isVideoTemplate={(template_content?.type || template_content?.mediaType) === 'video'}
                              onTimeUpdate={setPreviewTime}
                              getAdjustmentLayersForItem={getAdjustmentLayersForItem}
                            />
                          )}


                          {item.type === 'mask' && (() => {
                            const maskAssetUrl = item.maskAsset?.url || item.maskAsset?.storageUrl
                            const maskContent = item.maskContent
                            const transform = maskContent?.transform || {
                              scale: 1,
                              offsetX: 0,
                              offsetY: 0,
                              rotation: 0,
                              fitMode: 'cover'
                            }
                            const maskOpacity = item.maskSettings?.opacity ?? 1

                            const contentTransformStyle = {
                              position: 'absolute',
                              left: '50%',
                              top: '50%',
                              transform: `translate(-50%, -50%) translate(${transform.offsetX || 0}px, ${transform.offsetY || 0}px) scale(${transform.scale || 1}) rotate(${transform.rotation || 0}deg)`,
                              transformOrigin: 'center center',
                              width: transform.fitMode === 'fill' ? '100%' : 'auto',
                              height: transform.fitMode === 'fill' ? '100%' : 'auto',
                              minWidth: transform.fitMode === 'cover' ? '100%' : undefined,
                              minHeight: transform.fitMode === 'cover' ? '100%' : undefined
                            }

                            const renderMaskContent = () => {
                              if (!maskContent) {
                                return (
                                  <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-400">
                                    Select a photo/video to reveal through this mask
                                    {(() => {
                                      const { effectType, effectClass, effectStyle } = getTextEffectPresentation(item)
                                      const placeholder = (
                                        <span>
                                          {getTranslatedContent(item).split('\n').map((line, idx, arr) => (
                                            <React.Fragment key={`${item.id}-mask-line-${idx}`}>
                                              {line || '\u00A0'}
                                              {idx < arr.length - 1 && <br />}
                                            </React.Fragment>
                                          ))}
                                        </span>
                                      )
                                      if (effectType) {
                                        return (
                                          <span className={effectClass} style={effectStyle}>
                                            {placeholder}
                                          </span>
                                        )
                                      }
                                      return placeholder
                                    })()}
                                  </div>
                                )
                              }

                              if (maskContent.type === 'video') {
                                const maskVideoItem = {
                                  ...maskContent,
                                  type: 'video',
                                  src: maskContent.url,
                                  file: {
                                    url: maskContent.url,
                                    duration: maskContent.duration
                                  },
                                  time: item.time || { start: 0, duration: maskContent.duration || 5 },
                                  trim: maskContent.trim || { start: 0, end: maskContent.duration || 5 }
                                }

                                return (
                                  <div style={contentTransformStyle} className="w-full h-full">
                                    <VideoPreview
                                      item={maskVideoItem}
                                      previewTime={previewTime}
                                      isPlaying={isPlaying}
                                      isVideoTemplate={(template_content?.type || template_content?.mediaType) === 'video'}
                                      onTimeUpdate={null}
                                      maskMode
                                    />
                                  </div>
                                )
                              }

                              return (
                                <div style={{ ...contentTransformStyle }}>
                                  <img
                                    src={maskContent.url || maskContent.thumbnailUrl}
                                    alt="Masked content"
                                    className="object-cover"
                                    style={{
                                      width: transform.fitMode === 'fill' ? '100%' : 'auto',
                                      height: transform.fitMode === 'fill' ? '100%' : 'auto',
                                      minWidth: transform.fitMode === 'cover' ? '100%' : undefined,
                                      minHeight: transform.fitMode === 'cover' ? '100%' : undefined
                                    }}
                                  />
                                </div>
                              )
                            }

                            const hasMaskAsset = !!maskAssetUrl
                            const maskContainerClass = hasMaskAsset
                              ? "w-full h-full relative overflow-hidden bg-transparent"
                              : "w-full h-full relative overflow-hidden bg-slate-50 border border-dashed border-slate-200"

                            return (
                              <div className={maskContainerClass} style={{ backgroundColor: hasMaskAsset ? 'transparent' : undefined }}>
                                {hasMaskAsset ? (
                                  <div
                                    className="absolute inset-0"
                                    style={{
                                      WebkitMaskImage: `url(${maskAssetUrl})`,
                                      maskImage: `url(${maskAssetUrl})`,
                                      WebkitMaskRepeat: 'no-repeat',
                                      maskRepeat: 'no-repeat',
                                      WebkitMaskSize: '100% 100%',
                                      maskSize: '100% 100%',
                                      opacity: maskOpacity
                                    }}
                                  >
                                    {renderMaskContent()}
                                  </div>
                                ) : (
                                  <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-400">
                                    Select a mask frame to begin
                                  </div>
                                )}
                              </div>
                            )
                          })()}

                          {item.type === 'wordart' && (
                            <div className="w-full h-full flex items-center justify-center text-center p-2 rounded">
                              {(() => {
                                const style = item.style || {}
                                const fontSize = style.fontSize || 36
                                const fontWeight = style.fontWeight || 'bold'
                                const fontStyle = style.fontStyle || 'normal'
                                const fontFamily = style.fontFamily || 'Arial'
                                const fill = style.fill || item.color || item.fill || '#000'
                                const outline = style.outline || null
                                const shadow = style.shadow || null
                                const extrude = style.extrude || null
                                const gradient = style.gradient || null
                                const content = getTranslatedContent(item) || 'WordArt'

                                const baseTextStyle = {
                                  fontSize: `${fontSize}px`,
                                  fontWeight,
                                  fontStyle,
                                  fontFamily,
                                  lineHeight: 1,
                                  display: 'inline-block',
                                  position: 'relative',
                                  // Behind fill stroke effect for wordart
                                  textShadow: (() => {
                                    const shadows = [];
                                    // Add existing shadow if present AND enabled
                                    if (shadow && shadow.enabled !== false) {
                                      shadows.push(`${shadow.offsetX || 0}px ${shadow.offsetY || 0}px ${shadow.blur || 0}px ${shadow.color || 'rgba(0,0,0,0.4)'}`);
                                    }
                                    // Add stroke shadow if outline exists (rounded corners)
                                    // Note: Stroke shadow is part of the stroke effect, not the text shadow
                                    if (outline && outline.width > 0) {
                                      const strokeColor = outline.color || '#000';
                                      const strokeWidth = outline.width;
                                      // Use more angles for smoother rounded corners
                                      for (let angle = 0; angle < 360; angle += 30) {
                                        const radian = (angle * Math.PI) / 180;
                                        const x = Math.cos(radian) * strokeWidth;
                                        const y = Math.sin(radian) * strokeWidth;
                                        shadows.push(`${x}px ${y}px ${strokeWidth * 0.3}px ${strokeColor}`);
                                      }
                                    }
                                    
                                    // Add glow effect if enabled
                                    if (item.textGlow?.enabled || item.glowEnabled) {
                                      const { blur = 10, color = '#FFFFFF', intensity = 0.8, spread = 5 } = item.textGlow || {};
                                      
                                      // Create glow effect using multiple text-shadows in all directions
                                      const layers = Math.max(3, Math.floor(spread / 2));
                                      for (let i = 1; i <= layers; i++) {
                                        const layerBlur = (blur * i) / layers;
                                        const layerOpacity = intensity * (1 - (i / layers) * 0.5);
                                        const layerColor = color.startsWith('#')
                                          ? `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, ${layerOpacity})`
                                          : color;
                                        
                                        // Create glow in all directions (circular)
                                        for (let angle = 0; angle < 360; angle += 45) {
                                          const radian = (angle * Math.PI) / 180;
                                          const offsetX = Math.cos(radian) * (spread * i / layers);
                                          const offsetY = Math.sin(radian) * (spread * i / layers);
                                          shadows.push(`${offsetX}px ${offsetY}px ${layerBlur}px ${layerColor}`);
                                        }
                                      }
                                    }
                                    
                                    return shadows.length > 0 ? shadows.join(', ') : undefined;
                                  })(),
                                  color: gradient ? 'transparent' : (fill || '#000'),
                                  background: gradient ? `linear-gradient(${(gradient.angle || 45)}deg, ${(gradient.stops || []).map(([c, s]) => `${c} ${(s * 100) || 0}%`).join(', ')})` : undefined,
                                  WebkitBackgroundClip: gradient ? 'text' : undefined,
                                  backgroundClip: gradient ? 'text' : undefined,
                                  WebkitTextFillColor: gradient ? 'transparent' : undefined,
                                }

                                const layers = []
                                if (extrude && extrude.depth > 0) {
                                  const depth = Math.max(1, Math.floor(extrude.depth))
                                  const angle = (extrude.angleDeg || extrude.angle || 225) * Math.PI / 180
                                  const dx = Math.cos(angle)
                                  const dy = Math.sin(angle)
                                  const color = extrude.color || '#000'
                                  const opacity = typeof extrude.opacity === 'number' ? Math.max(0, Math.min(1, extrude.opacity)) : 1
                                  for (let i = depth; i >= 1; i--) {
                                    layers.push(
                                      <span
                                        key={`ex-${i}`}
                                        className="absolute inset-0 select-none"
                                        style={{
                                          transform: `translate(${dx * i}px, ${dy * i}px)`,
                                          color,
                                          opacity: opacity * (i / depth),
                                          pointerEvents: 'none',
                                        }}
                                      >{content}</span>
                                    )
                                  }
                                }

                                return (
                                  <div className="relative" style={{ height: fontSize * 1.2 }}>
                                    {/* Extrude layers */}
                                    {layers}
                                    {/* Top text */}
                                    <span className="relative select-none" style={baseTextStyle}>{content}</span>
                                  </div>
                                )
                              })()}
                            </div>
                          )}

                          {item.type === 'table' && (
                            <svg width={item.width} height={item.height} className="absolute inset-0">
                              <rect x="0" y="0" width={item.width} height={item.height} fill="transparent" stroke={item.stroke || '#000'} />
                              {Array.from({ length: item.cols - 1 }).map((_, i) => (
                                <line key={`v-${i}`} x1={(i + 1) * item.cellWidth} y1="0" x2={(i + 1) * item.cellWidth} y2={item.height} stroke={item.stroke || '#000'} />
                              ))}
                              {Array.from({ length: item.rows - 1 }).map((_, i) => (
                                <line key={`h-${i}`} x1="0" y1={(i + 1) * item.cellHeight} x2={item.width} y2={(i + 1) * item.cellHeight} stroke={item.stroke || '#000'} />
                              ))}
                            </svg>
                          )}

                          {item.type === 'shape' && !item.isPowerClipContainer && shapeNeedsEngine(item) && (
                            // Geometry-engine shape: vector deformations, border
                            // mechanics (dash/marching-ants/draw-on/trim/multiple
                            // outlines), repeater, and shape morph. Rendered as an
                            // inline SVG whose paths come from buildShapeGeometry.
                            (() => {
                              try {
                                const geo = buildShapeGeometry(item, previewTime)
                                const bx = item.x || 0, by = item.y || 0
                                const b = geo.border
                                const fill = (!item.fill || item.fill === 'transparent' || item.fill === 'none') ? 'none' : item.fill
                                const strokeCol = (!item.stroke || item.stroke === 'transparent' || item.stroke === 'none') ? null : item.stroke
                                const strokeW = item.strokeWidth || 0
                                const outlineSpecs = (b && Array.isArray(b.outlines) && b.outlines.length)
                                  ? [...b.outlines].sort((a, c) => (c.width || 0) - (a.width || 0))
                                  : (strokeCol && strokeW > 0 ? [{ color: strokeCol, width: strokeW }] : [])
                                const fullOutline = !b || (b.trimStart <= 0.001 && b.trimEnd >= 0.999)
                                const dashArr = b && b.dash ? b.dash.join(' ') : null
                                return (
                                  <svg
                                    width={item.width} height={item.height}
                                    viewBox={`0 0 ${item.width} ${item.height}`}
                                    style={{ overflow: 'visible', position: 'absolute', left: 0, top: 0 }}
                                  >
                                    {geo.subpaths.map((sub, si) => {
                                      // Translate absolute pts into the wrapper's local space.
                                      const local = sub.map((p) => ({ x: p.x - bx, y: p.y - by }))
                                      const d = pointsToSvgPath(local, geo.closed && fullOutline)
                                      return (
                                        <g key={`sp-${si}`}>
                                          {fill !== 'none' && fullOutline && (
                                            <path d={pointsToSvgPath(local, geo.closed)} fill={fill} stroke="none" />
                                          )}
                                          {outlineSpecs.map((os, oi) => (
                                            <path
                                              key={`ol-${oi}`}
                                              d={d}
                                              fill="none"
                                              stroke={os.color || strokeCol || '#000'}
                                              strokeWidth={os.width || strokeW}
                                              strokeDasharray={dashArr || undefined}
                                              strokeDashoffset={b && b.dashOffset ? -b.dashOffset : undefined}
                                              strokeLinejoin="round"
                                              strokeLinecap="round"
                                            />
                                          ))}
                                        </g>
                                      )
                                    })}
                                  </svg>
                                )
                              } catch (e) {
                                console.error('Shape engine render error:', e)
                                return null
                              }
                            })()
                          )}

                          {item.type === 'shape' && !item.isPowerClipContainer && !shapeNeedsEngine(item) && (
                            <div
                              className={`w-full h-full flex items-center justify-center rounded`}
                            >
                              {item.shapeType === 'rectangle' && (
                                <div
                                  className="w-full h-full"
                                  style={{
                                    backgroundColor: item.fill,
                                    border: `${(item.strokeWidth || 0)}px solid ${item.stroke || 'transparent'}`,
                                    borderRadius: `${(item.borderRadius ?? item.cornerRadius ?? 0)}px`,
                                    boxShadow: (() => {
                                      // Enhanced shadow system for shapes
                                      if (item.shadow?.enabled) {
                                        const { offsetX, offsetY, blur, spread, color, opacity, inset } = item.shadow;
                                        const shadowOpacity = opacity || 0.25;
                                        const shadowColor = color || '#000000';
                                        const rgbaColor = shadowColor.startsWith('#')
                                          ? `rgba(${parseInt(shadowColor.slice(1, 3), 16)}, ${parseInt(shadowColor.slice(3, 5), 16)}, ${parseInt(shadowColor.slice(5, 7), 16)}, ${shadowOpacity})`
                                          : shadowColor;
                                        return `${inset ? 'inset ' : ''}${offsetX || 4}px ${offsetY || 4}px ${blur || 8}px ${spread || 0}px ${rgbaColor}`;
                                      }
                                      // Fallback to legacy boxShadow
                                      return item.boxShadow || 'none';
                                    })()
                                  }}
                                />
                              )}
                              {item.shapeType === 'square' && (
                                <div
                                  className="aspect-square"
                                  style={{
                                    backgroundColor: item.fill,
                                    border: `${(item.strokeWidth || 0)}px solid ${item.stroke || 'transparent'}`,
                                    borderRadius: `${(item.borderRadius ?? item.cornerRadius ?? 0)}px`,
                                    boxShadow: (() => {
                                      // Enhanced shadow system for shapes
                                      if (item.shadow?.enabled) {
                                        const { offsetX, offsetY, blur, spread, color, opacity, inset } = item.shadow;
                                        const shadowOpacity = opacity || 0.25;
                                        const shadowColor = color || '#000000';
                                        const rgbaColor = shadowColor.startsWith('#')
                                          ? `rgba(${parseInt(shadowColor.slice(1, 3), 16)}, ${parseInt(shadowColor.slice(3, 5), 16)}, ${parseInt(shadowColor.slice(5, 7), 16)}, ${shadowOpacity})`
                                          : shadowColor;
                                        return `${inset ? 'inset ' : ''}${offsetX || 4}px ${offsetY || 4}px ${blur || 8}px ${spread || 0}px ${rgbaColor}`;
                                      }
                                      // Fallback to legacy boxShadow
                                      return item.boxShadow || 'none';
                                    })(),
                                    width: Math.min(item.width, item.height),
                                    height: Math.min(item.width, item.height),
                                  }}
                                />
                              )}
                              {item.shapeType === 'circle' && (
                                <div
                                  className="rounded-full aspect-square"
                                  style={{
                                    backgroundColor: item.fill,
                                    border: `${(item.strokeWidth || 0)}px solid ${item.stroke || 'transparent'}`,
                                    width: Math.min(item.width, item.height),
                                    height: Math.min(item.width, item.height),
                                  }}
                                />
                              )}
                              {/* Complex shapes using comprehensive shapes data */}
                              {item.shapeType && item.shapeType !== 'rectangle' && item.shapeType !== 'square' && item.shapeType !== 'circle' && (
                                <svg
                                  width="100%"
                                  height="100%"
                                  viewBox="0 0 100 100"
                                  style={{ overflow: 'visible' }}
                                >
                                  {renderShapeByType(item.shapeType, item.fill, item.stroke, item.strokeWidth)}
                                </svg>
                              )}
                            </div>
                          )}

                          {item.type === 'graphic' && (
                            <div
                              className={`w-full h-full flex items-center justify-center ${selectedElement === item.id ? 'ring-2 ring-blue-500' : ''
                                }`}
                              style={{
                                backgroundColor: item.backgroundColor || 'transparent',
                                borderRadius: `${item.borderRadius || 0}px`,
                                filter: item.filter || 'none',
                                opacity: item.opacity || 1
                              }}
                            >
                              <div
                                className="w-full h-full"
                                style={{
                                  fill: item.fill || 'currentColor',
                                  stroke: item.stroke || 'none',
                                  strokeWidth: item.strokeWidth || 1
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: item.svgData?.replace(
                                    /<svg([^>]*)>/,
                                    (_m, attrs) => {
                                      const idMatch = attrs.match(/\sid=\"([^\"]+)\"/)
                                      const id = idMatch ? idMatch[1] : `svg-${item.id}`
                                      const withId = idMatch ? `<svg${attrs}>` : `<svg${attrs} id="${id}">`
                                      const style = `<style>#${id} path,#${id} rect,#${id} circle,#${id} ellipse,#${id} line,#${id} polyline,#${id} polygon,#${id} text{fill:${item.fill || 'currentColor'} !important;stroke:${item.stroke || 'none'} !important;stroke-width:${item.strokeWidth || 1}px !important;vector-effect:non-scaling-stroke;}</style>`
                                      return withId.replace(/<svg([^>]*)>/, `<svg$1 width=\"100%\" height=\"100%\" preserveAspectRatio=\"none\" style=\"overflow: visible;\">${style}`)
                                    }
                                  )
                                }}
                              />
                            </div>
                          )}

                          {/* First-class inline SVG item (type:"svg" + svgContent) */}
                          {item.type === 'svg' && (
                            <div
                              className={`w-full h-full ${selectedElement === item.id ? 'ring-2 ring-blue-500' : ''
                                }`}
                              style={{
                                backgroundColor: item.backgroundColor || 'transparent',
                                borderRadius: `${item.borderRadius || 0}px`,
                                filter: item.filter || 'none',
                                opacity: item.opacity ?? 1
                              }}
                              dangerouslySetInnerHTML={{
                                __html: prepareSvgContent(item.svgContent, {
                                  scopeId: `svg-${item.id}`,
                                  preserveAspectRatio: item.preserveAspectRatio || (item.stretch ? 'none' : 'xMidYMid meet'),
                                  recolor: !!item.recolorSvg,
                                  fill: item.fill,
                                  stroke: item.stroke,
                                  strokeWidth: item.strokeWidth,
                                })
                              }}
                            />
                          )}

                          {item.type === 'svg-graphic' && (
                            <div
                              className={`w-full h-full flex items-center justify-center ${selectedElement === item.id ? 'ring-2 ring-blue-500' : ''
                                }`}
                              style={{
                                backgroundColor: item.backgroundColor || 'transparent',
                                borderRadius: `${item.borderRadius || 0}px`,
                                filter: item.filter || 'none',
                                opacity: item.opacity || 1
                              }}
                            >
                              <div
                                className="w-full h-full"
                                style={{
                                  fill: item.fill || 'currentColor',
                                  stroke: item.stroke || 'none',
                                  strokeWidth: item.strokeWidth || 1
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: item.svgData?.replace(
                                    /<svg([^>]*)>/,
                                    (_m, attrs) => {
                                      const idMatch = attrs.match(/\sid=\"([^\"]+)\"/)
                                      const id = idMatch ? idMatch[1] : `svg-${item.id}`
                                      const withId = idMatch ? `<svg${attrs}>` : `<svg${attrs} id="${id}">`
                                      const style = `<style>#${id} path,#${id} rect,#${id} circle,#${id} ellipse,#${id} line,#${id} polyline,#${id} polygon,#${id} text{fill:${item.fill || 'currentColor'} !important;stroke:${item.stroke || 'none'} !important;stroke-width:${item.strokeWidth || 1}px !important;vector-effect:non-scaling-stroke;}</style>`
                                      return withId.replace(/<svg([^>]*)>/, `<svg$1 width=\"100%\" height=\"100%\" preserveAspectRatio=\"none\" style=\"overflow: visible;\">${style}`)
                                    }
                                  )
                                }}
                              />
                            </div>
                          )}

                          {item.type === 'drawing' && (
                            <div
                              className={`w-full h-full ${selectedElement === item.id ? 'ring-2 ring-blue-500' : ''
                                }`}
                              style={{
                                opacity: item.opacity || 1
                              }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                viewBox={`0 0 ${item.width} ${item.height}`}
                                style={{ overflow: 'visible' }}
                              >
                                <path
                                  d={item.pathData}
                                  stroke={item.stroke}
                                  strokeWidth={item.strokeWidth}
                                  fill={item.fill}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          )}

                          {/* Group Item Rendering */}
                          {item.type === 'group' && item.children && (
                            <div
                              className="w-full h-full relative"
                              style={{
                                pointerEvents: item.locked ? 'none' : 'auto',
                              }}
                            >
                              {/* Render children sorted by layer */}
                              {item.children
                                .slice()
                                .sort((a, b) => (a.layer || 0) - (b.layer || 0))
                                .map((child) => (
                                  <div
                                    key={child.id}
                                    data-element-id={child.id}
                                    className={`absolute ${editingGroup === item.id ? 'cursor-move' : 'pointer-events-none'
                                      } ${editingGroup === item.id && selectedElement === child.id ? 'ring-2 ring-green-500' : ''
                                      }`}
                                    style={{
                                      left: child.x,
                                      top: child.y,
                                      width: child.width,
                                      height: child.height,
                                      transform: `rotate(${child.rotation || 0}deg)`,
                                      transformOrigin: 'center center',
                                      opacity: child.opacity ?? 1,
                                      zIndex: (child.layer || 0) + 10,
                                    }}
                                    onClick={(e) => {
                                      if (editingGroup === item.id) {
                                        e.stopPropagation()
                                        setSelectedElement(child.id)
                                      }
                                    }}
                                    onMouseDown={(e) => {
                                      if (editingGroup === item.id) {
                                        e.stopPropagation()
                                        handleElementMouseDown(e, child.id)
                                      }
                                    }}
                                  >
                                    {renderCanvasItem(child, item)}
                                  </div>
                                ))}

                              {/* Dashed border around group bounding box when in editing mode */}
                              {editingGroup === item.id && (
                                <div
                                  className="absolute inset-0 pointer-events-none"
                                  style={{
                                    border: '2px dashed #3b82f6',
                                    borderRadius: '2px',
                                  }}
                                />
                              )}
                            </div>
                          )}

                          {/* PowerClip Container Rendering */}
                          {item.isPowerClipContainer && item.powerClipContents && (
                            <div
                              className={`w-full h-full relative ${selectedElement === item.id ? 'ring-2 ring-blue-500' : ''}`}
                            >
                              {/* Clipped content container */}
                              <div
                                className={`w-full h-full relative ${editingPowerClip === item.id ? '' : 'overflow-hidden'}`}
                                style={{
                                  backgroundColor: item.fill || 'transparent',
                                  borderRadius: `${(item.borderRadius ?? item.cornerRadius ?? 0)}px`,
                                  clipPath: (() => {
                                    // Don't clip when in edit mode so user can see and interact with content outside the shape boundary
                                    if (editingPowerClip === item.id) return 'none';
                                    // Shape-aware clipping: generate clipPath from shapeType
                                    const shapeClip = getShapeClipPath(item.shapeType);
                                    if (shapeClip !== 'none') return shapeClip;
                                    // Fall back to explicit clipPath property
                                    return item.clipPath !== 'none' ? item.clipPath : 'none';
                                  })()
                                }}
                              >
                              {/* SVG clipPath definitions for complex shapes */}
                              {renderSvgClipDefs(item.shapeType)}

                              {/* Render clipped contents */}
                              {item.powerClipContents.map((content, contentIndex) => (
                                <div
                                  key={`${content.id}-${contentIndex}`}
                                  className={`absolute ${editingPowerClip === item.id ? 'cursor-move' : ''
                                    } ${editingPowerClip === item.id && selectedElement === content.id ? 'ring-2 ring-green-500' : ''
                                    }`}
                                  style={{
                                    left: content.x,
                                    top: content.y,
                                    width: content.width,
                                    height: content.height,
                                    transform: `rotate(${content.rotation || 0}deg)`,
                                    opacity: content.opacity || 1,
                                    zIndex: content.layer || 0
                                  }}
                                  onClick={(e) => {
                                    if (editingPowerClip === item.id) {
                                      e.stopPropagation()
                                      setSelectedElement(content.id)
                                    }
                                  }}
                                  onMouseDown={(e) => {
                                    if (editingPowerClip === item.id) {
                                      e.stopPropagation()
                                      handleElementMouseDown(e, content.id)
                                    }
                                  }}
                                >
                                  {/* Render content based on type */}
                                  {content.type === 'text' && (
                                    <div
                                      className="w-full h-full flex items-center justify-center"
                                      style={{
                                        fontSize: content.fontSize || 16,
                                        fontFamily: content.fontFamily || 'Arial',
                                        color: content.color || '#000000',
                                        fontWeight: content.fontWeight || 'normal',
                                        textAlign: content.textAlign || 'center'
                                      }}
                                    >
                                      {content.content}
                                    </div>
                                  )}

                                  {/* Nested PowerClip Container Support */}
                                  {content.type === 'shape' && content.isPowerClipContainer && content.powerClipContents && (
                                    <div
                                      className={`w-full h-full relative ${editingPowerClip === content.id ? '' : 'overflow-hidden'
                                        } ${selectedElement === content.id ? 'ring-2 ring-blue-500' : ''
                                        }`}
                                      style={{
                                        backgroundColor: content.fill || 'transparent',
                                        border: `${(content.strokeWidth || 0)}px solid ${content.stroke || 'transparent'}`,
                                        borderRadius: `${(content.borderRadius ?? content.cornerRadius ?? 0)}px`,
                                        boxShadow: (() => {
                                          if (content.shadow?.enabled) {
                                            const { offsetX, offsetY, blur, spread, color, opacity, inset } = content.shadow;
                                            const shadowOpacity = opacity || 0.25;
                                            const shadowColor = color || '#000000';
                                            const rgbaColor = shadowColor.startsWith('#')
                                              ? `${shadowColor}${Math.round(shadowOpacity * 255).toString(16).padStart(2, '0')}`
                                              : `rgba(0, 0, 0, ${shadowOpacity})`;
                                            return `${inset ? 'inset ' : ''}${offsetX || 0}px ${offsetY || 0}px ${blur || 0}px ${spread || 0}px ${rgbaColor}`;
                                          }
                                          return 'none';
                                        })(),
                                        clipPath: getShapeClipPath(content.shapeType)
                                      }}
                                    >
                                      {/* SVG clipPath definitions for complex shapes */}
                                      {renderSvgClipDefs(content.shapeType)}
                                      {/* Render nested clipped contents recursively */}
                                      {content.powerClipContents.map((nestedContent, nestedIndex) => (
                                        <div
                                          key={`${nestedContent.id}-nested-${nestedIndex}`}
                                          className={`absolute ${editingPowerClip === content.id ? 'cursor-move' : ''
                                            } ${editingPowerClip === content.id && selectedElement === nestedContent.id ? 'ring-2 ring-green-500' : ''
                                            }`}
                                          style={{
                                            left: nestedContent.x,
                                            top: nestedContent.y,
                                            width: nestedContent.width,
                                            height: nestedContent.height,
                                            transform: `rotate(${nestedContent.rotation || 0}deg)`,
                                            opacity: nestedContent.opacity || 1,
                                            zIndex: nestedContent.layer || 0
                                          }}
                                          onClick={(e) => {
                                            if (editingPowerClip === content.id) {
                                              e.stopPropagation()
                                              setSelectedElement(nestedContent.id)
                                            }
                                          }}
                                          onMouseDown={(e) => {
                                            if (editingPowerClip === content.id) {
                                              e.stopPropagation()
                                              handleElementMouseDown(e, nestedContent.id)
                                            }
                                          }}
                                        >
                                          {/* Recursively render nested content - this enables infinite nesting */}
                                          {renderPowerClipContent(nestedContent, content.id)}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {content.type === 'image' && (
                                    <div
                                      className="w-full h-full"
                                      style={{
                                        opacity: content.opacity ?? 1,
                                        filter: (() => {
                                          // New filter system - use filters.cssFilter if available
                                          if (content.filters?.cssFilter) {
                                            return content.filters.cssFilter;
                                          }
                                          // Fallback to legacy filter system for backward compatibility
                                          return `
                                            brightness(${(content.brightness ?? 0) + 100}%)
                                            contrast(${(content.contrast ?? 0) + 100}%)
                                            saturate(${(content.intensity ?? 0) + 100}%)
                                            hue-rotate(${content.hueRotate || 0}deg)
                                            sepia(${Math.max(0, content.sepia || 0)}%)
                                            grayscale(${Math.max(0, content.grayscale || 0)}%)
                                            blur(${Math.max(0, content.blur || 0)}px)
                                          `;
                                        })(),
                                        transform: `scaleX(${content.flipX ? -1 : 1}) scaleY(${content.flipY ? -1 : 1})`,
                                        transformOrigin: 'center center',
                                        WebkitMaskImage: content.gradientMask || undefined,
                                        maskImage: content.gradientMask || undefined,
                                        WebkitMaskSize: '100% 100%',
                                        maskSize: '100% 100%',
                                        WebkitMaskRepeat: 'no-repeat',
                                        maskRepeat: 'no-repeat',
                                        boxShadow: (() => {
                                          // Enhanced shadow system for PowerClip content
                                          if (content.shadow?.enabled) {
                                            const { offsetX, offsetY, blur, spread, color, opacity, inset } = content.shadow;
                                            const shadowOpacity = opacity || 0.25;
                                            const shadowColor = color || '#000000';
                                            const rgbaColor = shadowColor.startsWith('#')
                                              ? `${shadowColor}${Math.round(shadowOpacity * 255).toString(16).padStart(2, '0')}`
                                              : `rgba(0, 0, 0, ${shadowOpacity})`;
                                            return `${inset ? 'inset ' : ''}${offsetX || 0}px ${offsetY || 0}px ${blur || 0}px ${spread || 0}px ${rgbaColor}`;
                                          }
                                          return undefined;
                                        })()
                                      }}
                                    >
                                      <img
                                        src={content.src}
                                        alt={content.alt || 'PowerClip content'}
                                        className="w-full h-full object-fill"
                                        style={{ mixBlendMode: content.blendMode || 'normal' }}
                                        draggable={false}
                                      />
                                    </div>
                                  )}

                                  {content.type === 'shape' && (
                                    <>
                                      {/* Basic shapes: rectangle and circle */}
                                      {(content.shapeType === 'rectangle' || !content.shapeType) && (
                                        <div
                                          className="w-full h-full"
                                          style={{
                                            backgroundColor: content.fill || '#3B82F6',
                                            border: `${content.strokeWidth || 0}px solid ${content.stroke || 'transparent'}`,
                                            borderRadius: `${content.borderRadius || 0}px`
                                          }}
                                        />
                                      )}
                                      {content.shapeType === 'circle' && (
                                        <div
                                          className="w-full h-full"
                                          style={{
                                            backgroundColor: content.fill || '#3B82F6',
                                            border: `${content.strokeWidth || 0}px solid ${content.stroke || 'transparent'}`,
                                            borderRadius: '50%'
                                          }}
                                        />
                                      )}
                                      {/* Complex shapes using comprehensive shapes data */}
                                      {content.shapeType && content.shapeType !== 'rectangle' && content.shapeType !== 'circle' && (
                                        <svg
                                          width="100%"
                                          height="100%"
                                          viewBox="0 0 100 100"
                                          style={{ overflow: 'visible' }}
                                        >
                                          {renderShapeByType(content.shapeType, content.fill, content.stroke, content.strokeWidth)}
                                        </svg>
                                      )}
                                    </>
                                  )}

                                  {(content.type === 'graphic' || content.type === 'svg-graphic') && (
                                    <div
                                      className="w-full h-full"
                                      dangerouslySetInnerHTML={{
                                        __html: content.svgData?.replace(
                                          /<svg([^>]*)>/,
                                          `<svg$1 width="100%" height="100%" preserveAspectRatio="none"><style>path,rect,circle,ellipse,line,polyline,polygon,text{fill:${content.fill || 'currentColor'} !important;stroke:${content.stroke || 'none'} !important;vector-effect:non-scaling-stroke;}</style>`
                                        )
                                      }}
                                    />
                                  )}

                                  {/* Group inside PowerClip - render group children within the clipping region */}
                                  {content.type === 'group' && content.children && (
                                    <div
                                      className="w-full h-full relative"
                                      style={{
                                        pointerEvents: content.locked ? 'none' : 'auto',
                                      }}
                                    >
                                      {content.children
                                        .slice()
                                        .sort((a, b) => (a.layer || 0) - (b.layer || 0))
                                        .map((groupChild, groupChildIndex) => (
                                          <div
                                            key={`${groupChild.id}-pcgroup-${groupChildIndex}`}
                                            className="absolute"
                                            style={{
                                              left: groupChild.x,
                                              top: groupChild.y,
                                              width: groupChild.width,
                                              height: groupChild.height,
                                              transform: `rotate(${groupChild.rotation || 0}deg)`,
                                              transformOrigin: 'center center',
                                              opacity: groupChild.opacity ?? 1,
                                              zIndex: (groupChild.layer || 0) + 10,
                                            }}
                                          >
                                            {renderPowerClipContent(groupChild, content.id)}
                                          </div>
                                        ))}
                                    </div>
                                  )}

                                  {/* Resize handles for PowerClip content in edit mode */}
                                  {editingPowerClip === item.id && selectedElement === content.id && (
                                    <div className="absolute -inset-1">
                                      {/* Corner resize handles (Blue, same as outside) */}
                                      <div className="absolute -top-1 -left-1 w-3 h-3 bg-blue-500 rounded-full cursor-nw-resize hover:bg-blue-600" onMouseDown={(e) => handleResizeMouseDown(e, 'nw')}></div>
                                      <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full cursor-ne-resize hover:bg-blue-600" onMouseDown={(e) => handleResizeMouseDown(e, 'ne')}></div>
                                      <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-blue-500 rounded-full cursor-sw-resize hover:bg-blue-600" onMouseDown={(e) => handleResizeMouseDown(e, 'sw')}></div>
                                      <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-blue-500 rounded-full cursor-se-resize hover:bg-blue-600" onMouseDown={(e) => handleResizeMouseDown(e, 'se')}></div>

                                      {/* Edge resize handles */}
                                      <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-blue-500 rounded-full cursor-n-resize hover:bg-blue-600" onMouseDown={(e) => handleResizeMouseDown(e, 'n')}></div>
                                      <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-blue-500 rounded-full cursor-s-resize hover:bg-blue-600" onMouseDown={(e) => handleResizeMouseDown(e, 's')}></div>
                                      <div className="absolute -left-1 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-blue-500 rounded-full cursor-w-resize hover:bg-blue-600" onMouseDown={(e) => handleResizeMouseDown(e, 'w')}></div>
                                      <div className="absolute -right-1 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-blue-500 rounded-full cursor-e-resize hover:bg-blue-600" onMouseDown={(e) => handleResizeMouseDown(e, 'e')}></div>
                                    </div>
                                  )}
                                </div>
                              ))}

                              {/* PowerClip indicator */}
                              {/* {editingPowerClip !== item.id && (
                                <div className="absolute top-1 right-1 bg-blue-500 text-white text-xs px-1 rounded">
                                  PowerClip
                                </div>
                              )} */}

                              {/* Edit mode: Show blue boundary and finish button */}
                              {editingPowerClip === item.id && (
                                <>
                                  {/* Blue boundary outline */}
                                  <div className="absolute inset-0 border-2 border-blue-400 pointer-events-none"
                                    style={{ borderRadius: `${item.borderRadius || 0}px` }} />
                                </>
                              )}
                              </div>

                              {/* Stroke/border overlay - rendered outside clipPath so it's not clipped */}
                              {/* Uses negative offset + expanded size so the border grows outward instead of inward */}
                              {(item.strokeWidth > 0 && item.stroke && item.stroke !== 'transparent') && (
                                <div
                                  className="absolute pointer-events-none"
                                  style={{
                                    top: `-${item.strokeWidth}px`,
                                    left: `-${item.strokeWidth}px`,
                                    width: `calc(100% + ${item.strokeWidth * 2}px)`,
                                    height: `calc(100% + ${item.strokeWidth * 2}px)`,
                                    border: `${item.strokeWidth}px solid ${item.stroke}`,
                                    borderRadius: `${(item.borderRadius ?? item.cornerRadius ?? 0) + item.strokeWidth}px`,
                                    clipPath: (() => {
                                      const shapeClip = getShapeClipPath(item.shapeType);
                                      if (shapeClip !== 'none') return shapeClip;
                                      return undefined;
                                    })(),
                                    boxSizing: 'border-box',
                                  }}
                                />
                              )}

                              {/* Shadow overlay */}
                              {item.shadow?.enabled && (
                                <div
                                  className="absolute inset-0 pointer-events-none"
                                  style={{
                                    borderRadius: `${(item.borderRadius ?? item.cornerRadius ?? 0)}px`,
                                    boxShadow: (() => {
                                      const { offsetX, offsetY, blur, spread, color, opacity, inset } = item.shadow;
                                      const shadowOpacity = opacity || 0.25;
                                      const shadowColor = color || '#000000';
                                      const rgbaColor = shadowColor.startsWith('#')
                                        ? `rgba(${parseInt(shadowColor.slice(1, 3), 16)}, ${parseInt(shadowColor.slice(3, 5), 16)}, ${parseInt(shadowColor.slice(5, 7), 16)}, ${shadowOpacity})`
                                        : shadowColor;
                                      return `${inset ? 'inset ' : ''}${offsetX || 4}px ${offsetY || 4}px ${blur || 8}px ${spread || 0}px ${rgbaColor}`;
                                    })(),
                                    clipPath: (() => {
                                      const shapeClip = getShapeClipPath(item.shapeType);
                                      if (shapeClip !== 'none') return shapeClip;
                                      return undefined;
                                    })(),
                                  }}
                                />
                              )}
                            </div>
                          )}

                          {/* Multi-selection indicator */}
                          {selectedElements.includes(item.id) && selectedElement !== item.id && (
                            <div className="absolute -inset-1 border-2 border-dashed border-blue-400 rounded pointer-events-none" />
                          )}

                          {/* Element Controls - Show when selected and not locked */}
                          {selectedElement === item.id && !template_content.pages[currentPageIndex].page_config?.locked && !item.locked && (
                            <>
                              {/* Action Buttons */}
                              <div className="absolute -top-10 left-0 flex items-center space-x-1 bg-white rounded shadow-lg p-1">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    duplicateElement(item.id)
                                  }}
                                  className="p-1 hover:bg-gray-100 rounded"
                                  title="Duplicate"
                                >
                                  <Copy className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setSelectedElementComment(item.comment || '')
                                    setShowCommentDialog(true)
                                  }}
                                  className="p-1 hover:bg-gray-100 rounded"
                                  title="Add comment"
                                >
                                  <StickyNote className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    toggleElementLock(item.id)
                                  }}
                                  className={`p-1 hover:bg-gray-100 rounded ${item.locked ? 'text-red-600' : 'text-gray-600'}`}
                                  title={item.locked ? 'Unlock element' : 'Lock element'}
                                >
                                  <Lock className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    moveElementUp(item.id)
                                  }}
                                  className="p-1 hover:bg-gray-100 rounded"
                                  title="Move layer up"
                                >
                                  <ChevronUp className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    moveElementDown(item.id)
                                  }}
                                  className="p-1 hover:bg-gray-100 rounded"
                                  title="Move layer down"
                                >
                                  <ChevronDown className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    fitElementToContent(item.id)
                                  }}
                                  className="p-1 hover:bg-gray-100 rounded"
                                  title="Fit container to content"
                                >
                                  <Maximize2 className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setShowReplaceDialog(true)
                                  }}
                                  className="p-1 hover:bg-gray-100 rounded"
                                  title="Replace"
                                >
                                  <Upload className="w-4 h-4" />
                                </button>
                                <button
                                  onMouseDown={(e) => handleRotateMouseDown(e, item.id)}
                                  className="p-1 hover:bg-gray-100 rounded cursor-grab active:cursor-grabbing"
                                  title="Hold and drag to rotate"
                                >
                                  <RotateCw className="w-4 h-4" />
                                </button>

                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    deleteElement(item.id)
                                  }}
                                  className="p-1 hover:bg-red-100 rounded text-red-600"
                                  title="Delete"
                                >
                                  <X className="w-4 h-4" />
                                </button>
                              </div>

                              {/* Resize Handles */}
                              <div className="absolute -inset-1">
                                {/* Selection dotted outline */}
                                <div className="absolute inset-0 border border-dashed border-gray-300 pointer-events-none" />
                                {/* Corner handles */}
                                <div
                                  className="absolute -top-1 -left-1 w-3 h-3 bg-blue-500 rounded-full cursor-nw-resize hover:bg-blue-600"
                                  onMouseDown={(e) => handleResizeMouseDown(e, 'nw')}
                                ></div>
                                <div
                                  className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full cursor-ne-resize hover:bg-blue-600"
                                  onMouseDown={(e) => handleResizeMouseDown(e, 'ne')}
                                ></div>
                                <div
                                  className="absolute -bottom-1 -left-1 w-3 h-3 bg-blue-500 rounded-full cursor-sw-resize hover:bg-blue-600"
                                  onMouseDown={(e) => handleResizeMouseDown(e, 'sw')}
                                ></div>
                                <div
                                  className="absolute -bottom-1 -right-1 w-3 h-3 bg-blue-500 rounded-full cursor-se-resize hover:bg-blue-600"
                                  onMouseDown={(e) => handleResizeMouseDown(e, 'se')}
                                ></div>

                                {/* Edge handles with dotted connectors */}
                                <div
                                  className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-blue-500 rounded-full cursor-n-resize hover:bg-blue-600"
                                  onMouseDown={(e) => handleResizeMouseDown(e, 'n')}
                                ></div>
                                <div className="absolute top-0 left-0 right-0 border-t border-dashed border-gray-300 pointer-events-none" />
                                <div
                                  className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-blue-500 rounded-full cursor-s-resize hover:bg-blue-600"
                                  onMouseDown={(e) => handleResizeMouseDown(e, 's')}
                                ></div>
                                <div className="absolute bottom-0 left-0 right-0 border-t border-dashed border-gray-300 pointer-events-none" />
                                <div
                                  className="absolute -left-1 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-blue-500 rounded-full cursor-w-resize hover:bg-blue-600"
                                  onMouseDown={(e) => handleResizeMouseDown(e, 'w')}
                                ></div>
                                <div className="absolute top-0 bottom-0 left-0 border-l border-dashed border-gray-300 pointer-events-none" />
                                <div
                                  className="absolute -right-1 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-blue-500 rounded-full cursor-e-resize hover:bg-blue-600"
                                  onMouseDown={(e) => handleResizeMouseDown(e, 'e')}
                                ></div>
                                <div className="absolute top-0 bottom-0 right-0 border-l border-dashed border-gray-300 pointer-events-none" />
                              </div>
                            </>
                          )}
                        </div>
                      ))}

                      {/* No default content overlay for empty pages */}
                    </div>
                  </div>
                </div>
                )
              })()}
            </div>
          </div>

          {/* Bottom Navigation */}
          <div className="bg-white border-t border-gray-200 px-4 py-1 flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button className="flex items-center space-x-2 text-gray-600 hover:text-gray-800">
                <StickyNote className="w-4 h-4" />
                <span className="text-sm">Notes</span>
              </button>
              <button
                onClick={() => setShowContentDialog(true)}
                className="flex items-center space-x-2 text-blue-600 hover:text-blue-800"
              >
                <Eye className="w-4 h-4" />
                <span className="text-sm">View Content</span>
              </button>

              {/* Page Navigation */}
              <div className="flex items-center space-x-2 border-l border-gray-200 pl-4">
                {/* Scroll Left Button */}
                <button
                  onClick={() => {
                    const container = document.querySelector('.page-nav-container')
                    if (container) {
                      container.scrollBy({ left: -200, behavior: 'smooth' })
                    }
                  }}
                  className="p-1 hover:bg-gray-100 rounded transition-colors"
                  title="Scroll left"
                >
                  <ChevronLeft className="w-4 h-4 text-gray-600" />
                </button>

                {/* Pages Container */}
                <div
                  className="flex-1 overflow-x-auto page-nav-container max-w-md"
                  style={{
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    WebkitScrollbar: { display: 'none' }
                  }}
                >
                  <div className="flex items-center space-x-1 min-w-max">
                    {template_content?.pages?.map((page, index) => (
                      <div key={page.id} className="relative">
                        <div
                          className={`flex items-center px-3 py-1 rounded cursor-pointer transition-all min-w-0 ${
                            index === currentPageIndex
                              ? 'bg-blue-100 border border-blue-300 text-blue-700'
                              : 'bg-gray-50 hover:bg-gray-100 border border-gray-200 text-gray-700'
                          }`}
                          onClick={() => setCurrentPageIndex(index)}
                        >
                          <span className="text-xs font-medium truncate max-w-20">
                            {page.page_config?.name || `Page ${index + 1}`}
                          </span>

                          {/* Page Lock Indicator */}
                          {page.page_config?.locked && (
                            <Lock className="w-3 h-3 ml-1 text-red-500" />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Scroll Right Button */}
                <button
                  onClick={() => {
                    const container = document.querySelector('.page-nav-container')
                    if (container) {
                      container.scrollBy({ left: 200, behavior: 'smooth' })
                    }
                  }}
                  className="p-1 hover:bg-gray-100 rounded transition-colors"
                  title="Scroll right"
                >
                  <ChevronRight className="w-4 h-4 text-gray-600" />
                </button>

                {/* Add Page Button */}
                <button
                  onClick={addNewPage}
                  className="p-1 bg-blue-500 hover:bg-blue-600 text-white rounded transition-colors flex items-center space-x-1"
                  title="Add new page"
                >
                  <Plus className="w-3 h-3" />
                  <span className="text-xs font-medium">Add</span>
                </button>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              {/* Pages View Button */}
              <button
                onClick={() => setShowPagesViewDialog(true)}
                className="p-1 hover:bg-gray-100 rounded"
                title="View all pages"
              >
                <div className="w-5 h-5 grid grid-cols-2 gap-0.5">
                  <div className="w-2 h-2 bg-gray-400 rounded-sm"></div>
                  <div className="w-2 h-2 bg-gray-400 rounded-sm"></div>
                  <div className="w-2 h-2 bg-gray-400 rounded-sm"></div>
                  <div className="w-2 h-2 bg-gray-400 rounded-sm"></div>
                </div>
              </button>

              {/* Zoom Control */}
              <select
                value={zoomLevel}
                onChange={(e) => setZoomLevel(parseInt(e.target.value))}
                className="text-sm text-gray-600 bg-white border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                title="Select zoom level"
              >
                {zoomOptions.map(zoom => (
                  <option key={zoom} value={zoom}>
                    {zoom}%
                  </option>
                ))}
              </select>

              {/* Fit Button */}
              <button
                onClick={zoomToFit}
                className="text-sm text-gray-600 bg-white border border-gray-300 rounded px-3 py-1 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                title="Fit page to screen (Ctrl+1)"
              >
                Fit
              </button>

              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-600">Pages</span>
                <div className="flex items-center space-x-1">
                  <button
                    onClick={() => setCurrentPageIndex(Math.max(0, currentPageIndex - 1))}
                    disabled={currentPageIndex === 0}
                    className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded"
                  >
                    ←
                  </button>
                  <span className="text-sm font-semibold px-2">
                    {currentPageIndex + 1} / {template_content?.pages?.length || 0}
                  </span>
                  <button
                    onClick={() => setCurrentPageIndex(Math.min((template_content?.pages?.length || 1) - 1, currentPageIndex + 1))}
                    disabled={currentPageIndex === (template_content?.pages?.length || 1) - 1}
                    className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded"
                  >
                    →
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Bottom status bar */}
      {showFooterBar && (
      <div className="h-6 bg-gray-900 text-gray-200 text-xs px-3 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {showMouseCoords && (
            <span>
              Page: X {mouseCoords.x}, Y {mouseCoords.y} |
              Workspace: X {workspaceMouseCoords.x}, Y {workspaceMouseCoords.y}
            </span>
          )}
        </div>
        {/* Show version number of the application from package.json */}
        <div className="opacity-60">
          Version: {version}
        </div>
        <div className="opacity-60">
          {isSaved && !isSaving && !hasUnsavedChanges ? 'All changes saved' : isSaving ? 'Saving...' : hasUnsavedChanges ? 'Unsaved changes' : ''}
        </div>
      </div>
      )}





      <ContentDialog
        showContentDialog={showContentDialog}
        setShowContentDialog={setShowContentDialog}
        template_content={template_content}
        copyToClipboard={copyToClipboard}
        onRearrangeItems={rearrangeItemsByLayer}
      />

      <CommentDialog
        showCommentDialog={showCommentDialog}
        setShowCommentDialog={setShowCommentDialog}
        selectedElementComment={selectedElementComment}
        setSelectedElementComment={setSelectedElementComment}
        selectedElement={selectedElement}
        saveElementComment={saveElementComment}
      />

      <ErrorDialog
        isOpen={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        title={errorDialogConfig.title}
        message={errorDialogConfig.message}
        showContactInfo={errorDialogConfig.showContactInfo}
      />

      {/* Replace Dialog */}
      {showReplaceDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96 max-w-90vw">
            <h3 className="text-lg font-semibold mb-4">Replace Element</h3>
            <div className="text-center py-8">
              <div className="text-4xl mb-4">🚧</div>
              <p className="text-gray-600">Feature coming soon</p>
            </div>
            {/* Audio panel removed - now using unified timeline structure */}

            <div className="flex justify-end mt-4">
              <button
                onClick={() => setShowReplaceDialog(false)}
                className="px-4 py-2 bg-gray-500 text-white hover:bg-gray-600 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <PagePropertiesDialog
        showPagePropertiesDialog={showPagePropertiesDialog}
        setShowPagePropertiesDialog={setShowPagePropertiesDialog}
        pageProperties={pageProperties}
        setPageProperties={setPageProperties}
        savePageProperties={savePageProperties}
        fromPx={fromPx}
        toPx={toPx}
      />

      <PagesViewDialog
        showPagesViewDialog={showPagesViewDialog}
        setShowPagesViewDialog={setShowPagesViewDialog}
        template_content={template_content}
        currentPageIndex={currentPageIndex}
        setCurrentPageIndex={setCurrentPageIndex}
        addNewPage={addNewPage}
        settemplate_content={settemplate_content}
      />

      {/* Secondary Sidebars */}
      <TemplatesSidebar
        isOpen={activeSecondarySidebar === 'templates'}
        onClose={() => setActiveSecondarySidebar(null)}
        onTemplateSelect={handleTemplateSelect}
      />

      {/* Animate Secondary Bar */}
      {showAnimateSecondaryBar && (
        <div className="fixed top-0 right-0 h-full z-[1000]">
          <AnimatePanelSecondaryBar
            selectedElement={selectedElement}
            template_content={template_content}
            settemplate_content={settemplate_content}
            onClose={() => setShowAnimateSecondaryBar(false)}
          />
        </div>
      )}

      {/* Motion Secondary Bar (Text Motion picker) */}
      {showMotionSecondaryBar && (
        <div className="fixed top-0 right-0 h-full z-[1000]">
          <MotionPanelSecondaryBar
            selectedElement={selectedElement}
            template_content={template_content}
            settemplate_content={settemplate_content}
            onClose={() => setShowMotionSecondaryBar(false)}
          />
        </div>
      )}

      {/* Text Effects Secondary Bar (78-preset picker) */}
      {showTextEffectsSecondaryBar && (
        <div className="fixed top-0 right-0 h-full z-[1000]">
          <TextEffectsSecondaryBar
            selectedElement={selectedElement}
            template_content={template_content}
            settemplate_content={settemplate_content}
            onClose={() => setShowTextEffectsSecondaryBar(false)}
          />
        </div>
      )}



      {/* Timeline (video mode) */}
      {((template_content?.type || template_content?.mediaType) === 'video') && (
        <Timeline
          template_content={template_content}
          currentPageIndex={currentPageIndex}
          settemplate_content={settemplate_content}
          zoom={1}
          height={timelineHeight}
          onHeightChange={handleTimelineHeightChange}
          onPlayheadChange={(t) => {
            setPreviewTime(t)
          }}
          onPlayingChange={(playing) => {
            setIsPlaying(playing)
          }}
          onExpandedChange={setIsTimelineExpanded}
          selectedElement={selectedElement}
          setSelectedElement={setSelectedElement}
          selectedAudioTrack={selectedAudioTrack}
          setSelectedAudioTrack={setSelectedAudioTrack}
        />
      )}

      <PhotosSidebar
        isOpen={activeSecondarySidebar === 'photos'}
        onClose={() => setActiveSecondarySidebar(null)}
        onPhotoSelect={handlePhotoSelect}
        onOpenDialog={() => openCategoryDialog('photos')}
      />

      <ElementsSidebar
        isOpen={activeSecondarySidebar === 'elements'}
        onClose={() => setActiveSecondarySidebar(null)}
        onElementSelect={handleElementSelect}
      />

      <TextSidebar
        isOpen={activeSecondarySidebar === 'text'}
        onClose={() => setActiveSecondarySidebar(null)}
        onTextSelect={handleTextSelect}
        onOpenDialog={() => openCategoryDialog('text')}
      />

      <FontsSecondarySidebar
        isOpen={activeSecondarySidebar === 'fonts'}
        onClose={() => setActiveSecondarySidebar(null)}
        onFontSelect={handleFontSelect}
        previewText={fontsSidebarPreviewText}
      />

      <GraphicsSidebar
        isOpen={activeSecondarySidebar === 'graphics'}
        onClose={() => setActiveSecondarySidebar(null)}
        onGraphicSelect={handleGraphicSelect}
        onImportSvgToCanvas={handleSvgFileImport}
        onMaskSelect={handleMaskAssetSelect}
        onOpenDialog={() => openCategoryDialog('graphics')}
        defaultTab={graphicsSidebarTab}
      />

      <ClipartSidebar
        isOpen={activeSecondarySidebar === 'clipart'}
        onClose={() => setActiveSecondarySidebar(null)}
        onClipartSelect={handleClipartSelect}
      />

      <AudioSidebar
        isOpen={activeSecondarySidebar === 'audio'}
        onClose={() => setActiveSecondarySidebar(null)}
        template_content={template_content}
        settemplate_content={settemplate_content}
        currentPageIndex={currentPageIndex}
      />

      <SoundEffectsSidebar
        isOpen={activeSecondarySidebar === 'sound-effects'}
        onClose={() => setActiveSecondarySidebar(null)}
        onSoundEffectSelect={handleSoundEffectSelect}
        template_content={template_content}
        settemplate_content={settemplate_content}
      />

      <VideoSidebar
        isOpen={activeSecondarySidebar === 'video'}
        onClose={() => setActiveSecondarySidebar(null)}
        onVideoSelect={handleVideoSelectForMask}
        template_content={template_content}
        settemplate_content={settemplate_content}
        currentPageIndex={currentPageIndex}
      />

      <TTSSidebar
        isOpen={activeSecondarySidebar === 'tts'}
        onClose={() => setActiveSecondarySidebar(null)}
        template_content={template_content}
        settemplate_content={settemplate_content}
        currentPageIndex={currentPageIndex}
      />

      {/* Freehand Tool Sidebar */}
      {activeSecondarySidebar === 'freehand' && (
        <div className="fixed left-16 top-0 h-full w-80 bg-white border-r border-gray-200 shadow-lg z-[1000] flex flex-col">
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold flex items-center">
              <PenTool className="w-5 h-5 mr-2" />
              Freehand Drawing
            </h2>
            <button
              onClick={() => setActiveSecondarySidebar(null)}
              className="p-1 hover:bg-gray-100 rounded"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-4">
            <StrokePropertiesPanel
              strokeStyle={freehandStrokeStyle}
              onChange={setFreehandStrokeStyle}
              className="mb-4"
            />

            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-semibold text-gray-800 mb-2">Instructions</h3>
                <div className="text-xs text-gray-600 space-y-1">
                  <p>• Click to start drawing</p>
                  <p>• Drag for freehand curves</p>
                  <p>• Click-click for straight lines</p>
                  <p>• Double-click or Enter to finish</p>
                  <p>• Escape to cancel</p>
                  <p>• Hold Ctrl for angle snap</p>
                  <p>• Hold Shift for orthogonal</p>
                  <p>• Hold Alt for precision mode</p>
                </div>
              </div>

              {freehandPaths.length > 0 && (
                <div>
                  <h3 className="text-sm font-semibold text-gray-800 mb-2">
                    Paths ({freehandPaths.length})
                  </h3>
                  <div className="space-y-2 max-h-40 overflow-y-auto">
                    {freehandPaths.map((path, index) => (
                      <div key={path.id} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                        <span className="text-xs text-gray-700">Path {index + 1}</span>
                        <button
                          onClick={() => {
                            const newPaths = freehandPaths.filter(p => p.id !== path.id)
                            setFreehandPaths(newPaths)
                          }}
                          className="p-1 hover:bg-red-100 rounded text-red-600"
                          title="Delete path"
                        >
                          <X className="w-3 h-3" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Filter Panel */}
      {activeSecondarySidebar === 'filters' && (() => {
        // Find the selected element object
        let element = currentPage?.items?.find(item => item.id === selectedElement)

        // If not found as regular element, check PowerClip contents
        if (!element && selectedElement) {
          for (const item of currentPage?.items || []) {
            if (item.isPowerClipContainer && item.powerClipContents) {
              const foundContent = item.powerClipContents.find(content => content.id === selectedElement)
              if (foundContent) {
                element = foundContent
                break
              }
            }
          }
        }

        return (
          <div className="fixed left-16 top-0 h-full w-80 bg-white border-r border-gray-200 shadow-lg z-[1000] flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold">Filters</h2>
              <button onClick={() => setActiveSecondarySidebar(null)} className="p-1 hover:bg-gray-100 rounded">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="flex-1 overflow-hidden">
              <FilterPanel
                selectedElement={element}
                template_content={template_content}
                settemplate_content={settemplate_content}
                onClose={() => setActiveSecondarySidebar(null)}
              />
            </div>
          </div>
        )
      })()}

      <ItemsListSidebar
        isOpen={activeSecondarySidebar === 'items'}
        onClose={() => setActiveSecondarySidebar(null)}
        items={currentPage?.items || []}
        selectedElement={selectedElement}
        onElementSelect={handleElementSelectFromList}
        onElementToggleVisibility={toggleElementVisibility}
        onElementToggleLock={toggleElementLock}
        onElementMoveUp={moveElementUp}
        onElementMoveDown={moveElementDown}
        onElementDelete={deleteElement}
        onGroupChildSelect={handleGroupChildSelectFromList}
        template_content={template_content}
        onTemplateUpdate={settemplate_content}
        template_category_id={template_category_id}
      />

      <EffectsPanel
        isOpen={activeSecondarySidebar === 'effects'}
        onClose={() => setActiveSecondarySidebar(null)}
        selectedElement={selectedElement}
        template_content={template_content}
        settemplate_content={settemplate_content}
      />

      <AdjustmentLayerPanel
        isOpen={activeSecondarySidebar === 'adjustment-layers'}
        onClose={() => setActiveSecondarySidebar(null)}
        template_content={template_content}
        settemplate_content={settemplate_content}
        currentPageIndex={currentPageIndex}
      />

      <VideoOverlaysPanel
        isOpen={activeSecondarySidebar === 'video-overlays'}
        onClose={() => setActiveSecondarySidebar(null)}
        template_content={template_content}
        settemplate_content={settemplate_content}
      />

      <CategoryFieldsSidebar
        isOpen={activeSecondarySidebar === 'categoryFields'}
        onClose={() => setActiveSecondarySidebar(null)}
        template_content={template_content}
      />

      <HistorySidebar
        isOpen={activeSecondarySidebar === 'history'}
        onClose={() => setActiveSecondarySidebar(null)}
        template_content={template_content}
        onLoadVersion={(versionContent) => {
          // Replace current template content with the selected version
          settemplate_content(prev => ({
            ...prev,
            ...versionContent
          }));
        }}
      />

      {/* ToolsSidebar disabled - will be implemented later
      <ToolsSidebar
        activeSecondarySidebar={activeSecondarySidebar}
        setActiveSecondarySidebar={setActiveSecondarySidebar}
        drawingMode={drawingMode}
        setDrawingMode={setDrawingMode}
        brushSize={brushSize}
        setBrushSize={setBrushSize}
        brushColor={brushColor}
        setBrushColor={setBrushColor}
        brushOpacity={brushOpacity}
        setBrushOpacity={setBrushOpacity}
        addTable={addTable}
      />
      */}

      <AddPageDialog
        showAddPageDialog={showAddPageDialog}
        setShowAddPageDialog={setShowAddPageDialog}
        addPageConfig={addPageConfig}
        setAddPageConfig={setAddPageConfig}
        template_content={template_content}
        settemplate_content={settemplate_content}
        currentPageIndex={currentPageIndex}
        setCurrentPageIndex={setCurrentPageIndex}
      />

      {/* Photo Upload Dialog */}
      <PhotoUploadDialog
        isOpen={showPhotoUploadDialog}
        onClose={() => setShowPhotoUploadDialog(false)}
        onUploadComplete={() => {
          // Refresh photos in sidebar if it's open
          // The PhotosSidebar will handle its own refresh
        }}
      />

      {/* Sample Generation Dialog */}
      <SampleGenerationDialog
        isOpen={showSampleGenerationDialog}
        onClose={() => setShowSampleGenerationDialog(false)}
        templateId={templateMetadata?.id}
        templateContent={template_content}
        onGenerate9Samples={handleGenerate9Samples}
      />

      {/* Past Samples Dialog */}
      <PastSamplesDialog
        isOpen={showPastSamplesDialog}
        onClose={() => setShowPastSamplesDialog(false)}
        templateId={templateMetadata?.id}
        templateName={templateMetadata?.name || template_content?.name}
      />

      {/* AI Generation Queue Dialog */}
      <AiQueueDialog
        isOpen={showAiQueueDialog}
        onClose={() => setShowAiQueueDialog(false)}
        templateId={templateMetadata?.id}
        templateName={templateMetadata?.name || template_content?.name}
        onApply={applyAiJobToTemplate}
        onRetry={retryAiJob}
      />

      {/* Category Dialog */}
      {showCategoryDialog && categoryDialogType === 'photos' && (
        <CategoryDialog
          isOpen={showCategoryDialog}
          onClose={() => setShowCategoryDialog(false)}
          categoryType="photos"
          title="Photos"
          onItemSelect={handlePhotoSelect}
        >
          <PhotosSidebar
            isOpen={true}
            isDialog={true}
            onClose={() => {}}
            onPhotoSelect={handlePhotoSelect}
          />
        </CategoryDialog>
      )}

      {showCategoryDialog && categoryDialogType === 'graphics' && (
        <CategoryDialog
          isOpen={showCategoryDialog}
          onClose={() => setShowCategoryDialog(false)}
          categoryType="graphics"
          title="Graphics"
          onItemSelect={handleGraphicSelect}
        >
          <GraphicsSidebar
            isOpen={true}
            isDialog={true}
            onClose={() => {}}
            onGraphicSelect={handleGraphicSelect}
          />
        </CategoryDialog>
      )}

      {showCategoryDialog && categoryDialogType === 'text' && (
        <CategoryDialog
          isOpen={showCategoryDialog}
          onClose={() => setShowCategoryDialog(false)}
          categoryType="text"
          title="Text"
          onItemSelect={handleTextSelect}
        >
          <TextSidebar
            isOpen={true}
            isDialog={true}
            onClose={() => {}}
            onTextSelect={handleTextSelect}
          />
        </CategoryDialog>
      )}

      {/* Context Menu */}
      <ContextMenu
        isVisible={contextMenu.isVisible}
        position={contextMenu.position}
        menuItems={contextMenu.menuItems}
        contextType={contextMenu.contextType}
        onClose={hideContextMenu}
      />

      {/* Video Export Progress */}
      {showVideoExportProgress && (
        <VideoExportProgress
          jobs={videoExportJobs}
          onDownload={handleVideoDownload}
          onCancel={handleJobCancel}
          onRemove={handleJobDismiss}
        />
      )}

      {/* Background Removal Snackbar */}
      <BackgroundRemovalSnackbar
        jobs={backgroundRemovalJobs}
        onComplete={(imageUrl, filename) => {
          // Apply the new image to the corresponding element
          const job = backgroundRemovalJobs.find(j => j.new_image_url === imageUrl) || backgroundRemovalJobs.find(j => j.filename === filename)
          if (job && job.elementId && imageUrl) {
            updateElementProperty(job.elementId, 'src', imageUrl)
            // Also attempt updating other common fields to keep consistency
            updateElementProperty(job.elementId, 'url', imageUrl)
            updateElementProperty(job.elementId, 'storageUrl', imageUrl)
          }
          // Remove snackbar entry after applying
          setBackgroundRemovalJobs(prev => prev.filter(j => j.new_image_url !== imageUrl))
        }}
        onCancel={(jobId) => {
          // Jobs run on the workflow queue; we just stop tracking locally.
          setBackgroundRemovalJobs(prev => prev.filter(job => job.id !== jobId))
        }}
        onDownload={(imageUrl, filename) => {
          // Handle download
          const link = document.createElement('a');
          link.href = imageUrl;
          link.download = filename || 'background-removed.png';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
      />

      {/* AI Image Generation Snackbar */}
      <AIImageGenerationSnackbar
        jobs={aiImageGenerationJobs}
        onCancel={(jobId) => setAiImageGenerationJobs(prev => prev.filter(j => j.id !== jobId))}
        onDismiss={(jobId) => setAiImageGenerationJobs(prev => prev.filter(j => j.id !== jobId))}
        onReapply={(job) => {
          if (job?.elementId && job?.output_url) {
            applyImageToElement(job.elementId, job.output_url)
            window.dispatchEvent(new CustomEvent('app:notify', { detail: { type: 'success', message: 'Image re-applied.' } }))
          }
        }}
        onRegenerate={(job) => {
          const p = job?.params
          if (!p) return
          // Re-run using the same job row so the snackbar updates in place.
          runAIImageGeneration({ ...p, jobId: job.id })
        }}
      />


      {/* Export Progress (PDF and Image exports) — toggled from the toolbar button next to Export */}
      <ExportProgress
        jobs={exportProgressJobs}
        onDownload={handleExportDownload}
        onCancel={handleExportCancel}
        onClose={handleExportClose}
        onSync={handleExportSync}
        onSyncAll={handleExportSyncAll}
        onClearQueue={handleExportClearQueue}
        isExpanded={isExportProgressExpanded}
        onCollapse={() => setIsExportProgressExpanded(false)}
      />

      {/* Video Export Dialog */}
      <VideoExportDialog
        isOpen={showVideoExportDialog}
        onClose={() => setShowVideoExportDialog(false)}
        onConfirm={handleVideoExport}
        currentWidth={currentPage?.page_config?.width || 720}
        currentHeight={currentPage?.page_config?.height || 1280}
      />

      {/* Alter Video Duration Dialog */}
      <DurationScaleDialog
        isOpen={showDurationScaleDialog}
        onClose={() => setShowDurationScaleDialog(false)}
        onConfirm={({ ratio, scaleEffects }) => scaleTemplateDuration({ ratio, scaleEffects })}
        currentDuration={computeTemplateDuration()}
      />

      {/* TIF Color Mode Dialog */}
      <TifColorModeDialog
        isOpen={showTifColorDialog}
        onClose={() => setShowTifColorDialog(false)}
        onConfirm={handleTifColorModeConfirm}
        isDownloading={tifDownloadType === 'current' ? downloadingStates.currentTif : downloadingStates.fullTif}
        downloadType={tifDownloadType}
      />

      {/* Universal Color Mode Dialog */}
      <ColorModeDialog
        isOpen={showColorModeDialog}
        onClose={() => setShowColorModeDialog(false)}
        onConfirm={handleColorModeConfirm}
        isDownloading={
          colorModeDialogConfig.downloadType === 'current'
            ? downloadingStates[`current${colorModeDialogConfig.format.charAt(0).toUpperCase() + colorModeDialogConfig.format.slice(1).toLowerCase()}`]
            : downloadingStates[`full${colorModeDialogConfig.format.charAt(0).toUpperCase() + colorModeDialogConfig.format.slice(1).toLowerCase()}`]
        }
        downloadType={colorModeDialogConfig.downloadType}
        format={colorModeDialogConfig.format}
      />

      {/* Import Progress Dialog */}
      <ImportProgressDialog
        isOpen={showImportProgress}
        onClose={() => setShowImportProgress(false)}
        importType={importProgress.type}
        fileName={importProgress.fileName}
        status={importProgress.status}
        progress={importProgress.progress}
        message={importProgress.message}
        allowCancel={importProgress.status === 'processing'}
      />

    </div>
  )
}

export default WorkspacePage
